const artists = [
    {
        name: "#MERKY BOOKS - 'DEMYSTIFYING PUBLISHING'",
        events: [
            {
                stage: "THE INFORMATION",
                day: "SATURDAY",
                time: "12:00 - 12:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "&? (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "21:45 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "13 MONTHS THEATRE",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "20 YEARS OF PHONICA DAYTIME TAKEOVER: CALL SUPER B2B PEACH, DMX KREW (LIVE), NIKS, PHONICA DJS",
        events: [
            {
                stage: "THE WOW",
                day: "SATURDAY",
                time: "12:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "3 DAFT MONKEYS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "17:05 - 17:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "30 YEARS OF THE LIBERATORS",
        events: [
            {
                stage: "THE TEMPLE",
                day: "FRIDAY",
                time: "02:00 - 03:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "30 YEARS OF V RECORDINGS: BRYAN GEE B2B SL8R FT. DARRISON",
        events: [
            {
                stage: "THE TEMPLE",
                day: "SUNDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "4AM KRU",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "13:45 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "5 CHILDREN & IT",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "50 PENCE",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "5TH ELEMENT PRESENTS BEATBOX ALLSTARS",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "18:30 - 19:00",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "FRIDAY",
                time: "00:45 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "A BAND CALLED BRIAN",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "12:30 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thinkofasong.com/a-band-named-brian-epk/",
    },
    {
        name: "A FOR ALPHA X ARLO",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "http://a%20for%20alpha%20(@aforalphaaa%29%20%7C%20instagram/",
    },
    {
        name: "A FOR ALPHA: SUPPER CLUB TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/aforalphaaa/",
    },
    {
        name: "A LITTLE SOUND",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "22:30 - 23:30",
            },
            {
                stage: "THE TEMPLE",
                day: "THURSDAY",
                time: "22:30 - 23:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/alittlesounduk/",
    },
    {
        name: "ABANDOMAN AKA ROB BRODERICK",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "13:30 - 14:15",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "14:05 - 14:50",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "14:05 - 14:50",
            },
        ],
        imgUrl: "",
        url: "http://abandoman%20aka%20rob%20broderick/",
    },
    {
        name: "ABI CARTER-SIMPSON",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "20:25 - 20:55",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "01:25 - 01:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ABLE MABLE (COMPERE)",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "12:00 - 18:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "15:00 - 18:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ABOVE AND BEYOND",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "00:25 - 00:33",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "23:37 - 23:45",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "00:24 - 00:32",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "23:35 - 23:43",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "00:51 - 00:57",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "00:26 - 00:34",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ABSOLUTE. B2B JODIE HARSH",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "16:30 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ACCESS TO MUSIC/ROLAND",
        events: [
            {
                stage: "MUZIKADEMY",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ACOUSTIC JAM SESSION",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "WEDNESDAY",
                time: "23:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ACOUSTIC OPEN MIC",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "20:00 - 23:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "20:00 - 23:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "11:00 - 11:50",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SATURDAY",
                time: "20:30 - 23:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SATURDAY",
                time: "11:00 - 11:50",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SUNDAY",
                time: "18:30 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ACTIVISTS MASTERCLASS - JAMIE KELSEY FRY, A22 & LISA WINTERSTEIGER",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "WEDNESDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://making%20real%20change%20happen%20-%20a%20master%20class%20in%20successful%20activism/",
    },
    {
        name: "ACTRESS",
        events: [
            {
                stage: "IICON",
                day: "FRIDAY",
                time: "01:50 - 02:50",
            },
        ],
        imgUrl: "",
        url: "https://www.whoisactress.com/",
    },
    {
        name: "ADAM HILLS",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "19:20 - 19:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ADAM HUNT & LULU URQUART",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "http://breavers%20%26%20rewilding/",
    },
    {
        name: "ADAM SCOTT GLASSPOOL",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://spoti.fi/40eblaf",
    },
    {
        name: "ADAM SHELTON",
        events: [
            {
                stage: "IICON",
                day: "THURSDAY",
                time: "21:15 - 23:15",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/adamshelton",
    },
    {
        name: "ADG7",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "FRIDAY",
                time: "14:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/adg7_official/",
    },
    {
        name: "ADWAITH",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "FRIDAY",
                time: "11:30 - 12:10",
            },
            {
                stage: "CROISSANT NEUF",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://adwaithmusic.com/",
    },
    {
        name: "AFRICAN DANCE",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/penny.avery.353",
    },
    {
        name: "AFRICAN DANCE CLASS WITH PENNY AVERY",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "THURSDAY",
                time: "13:30 - 14:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "FRIDAY",
                time: "13:30 - 14:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SATURDAY",
                time: "13:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/penny.avery.353",
    },
    {
        name: "AFRICAN HEAD CHARGE FEAT GAUDI",
        events: [
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "16:00 - 17:10",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/africanheadcharge",
    },
    {
        name: "AFT RAPS: BLACKSMITH, CARASEL, FRENIC",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://aftrecords.com/",
    },
    {
        name: "AFT RECORDS TAKEOVER - KELVIN 373",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://aftrecords.com/",
    },
    {
        name: "AFT RECORDS: KELVIN 373, DUBBZ, MOVE, DEVIANT, CHANGING WAYS, CARASEL, KAYDAN, SAVVY B + MORE TBA",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "03:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "AHADADREAM",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "20:00 - 21:00",
            },
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/ahadadreamx/",
    },
    {
        name: "AI, DEEPFAKE AND SYNTHETIC MEDIA - Q&A WITH ERIC DRASS AKA SHARDCORE",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "14:15 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://www.shardcore.org/spx/",
    },
    {
        name: "AILBHE REDDY",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://ailbhereddy.com/",
    },
    {
        name: "AITCH",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.aitchofficial.com/",
    },
    {
        name: "AK SPORTS",
        events: [
            {
                stage: "THE TEMPLE",
                day: "SATURDAY",
                time: "04:30 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/aksportsdj/",
    },
    {
        name: "AKIRA",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "15:55 - 16:05",
            },
            {
                stage: "THE PAVEMENT",
                day: "THURSDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "13:10 - 13:40",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "16:40 - 17:10",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "13:30 - 14:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "12:30 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://coventgardenentertainment.co.uk/performers/akira-street-performer/",
    },
    {
        name: "AL LEWIS",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "11:30 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.allewismusic.com/",
    },
    {
        name: "ALABASTER DEPLUME",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "FRIDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/alabaster_deplume/?hl=en",
    },
    {
        name: "ALEX HALL",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "12:00 - 12:40",
            },
        ],
        imgUrl: "",
        url: "https://www.alexhallmusic.co.uk/",
    },
    {
        name: "ALEX REX",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "16:00 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://alexrex.bandcamp.com/",
    },
    {
        name: "ALEX SOULOUD (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://on.soundcloud.com/ydvpqddf6hapmbwa6",
    },
    {
        name: "ALEX, EVIE AND DODGE",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ALEXISITRY X WONKA",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/alexisitry/",
    },
    {
        name: "ALIJI",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "18:55 - 20:05",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/alijimusic/",
    },
    {
        name: "ALISON GOLDFRAPP",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SUNDAY",
                time: "18:15 - 19:15",
            },
        ],
        imgUrl: "",
        url: "https://www.goldfrapp.com/",
    },
    {
        name: "ALISTAIR BARRIE (COMPERE)",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "15:30 - 19:00",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "15:30 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://www.alistairbarrie.com/",
    },
    {
        name: "ALLISON RUSSELL",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "12:10 - 12:40",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/allisonrussellmusic/",
    },
    {
        name: "ALMA TWIST",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/katrynaabel",
    },
    {
        name: "ALPS 2",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "23:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://alps2.bandcamp.com/",
    },
    {
        name: "ALT BLK ERA (EARACHE RECORDS TAKEOVER)",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "02:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.altblkera.com/",
    },
    {
        name: "ALT-J",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SUNDAY",
                time: "21:15 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.altjband.com/",
    },
    {
        name: "ALTAR X TEEZLE",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "01:00 - 02:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/t_for_teezle/",
    },
    {
        name: "ALTERN 8 (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.altern8official.com/",
    },
    {
        name: "ALTERN 8 / MARK ARCHER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/altern8official/",
    },
    {
        name: "ALTERN 8 B2B SHADOW CHILD",
        events: [
            {
                stage: "THE TEMPLE",
                day: "FRIDAY",
                time: "05:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/altern8official/",
    },
    {
        name: "ALYONA ALYONA",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "THURSDAY",
                time: "20:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/alyona.alyona.official/",
    },
    {
        name: "AMA",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "THE TEMPLE",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/amadjuk/",
    },
    {
        name: "AMADOU & MARIAM",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SATURDAY",
                time: "14:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/amadouetmariam/",
    },
    {
        name: "AMATEURISM",
        events: [
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.amateurism.co.uk/",
    },
    {
        name: "AMAZING CAMERA OBSCURA",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "THURSDAY",
                time: "12:00 - 16:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "12:00 - 16:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "12:00 - 16:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "12:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://www.amazingcameraobscura.co.uk/",
    },
    {
        name: "AMIE BLU",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "13:45 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/amiebluu/",
    },
    {
        name: "AMONGST THE PIGEONS",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "AMY VIX",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "12:00 - 12:40",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/amyvixmusic",
    },
    {
        name: "AN AUDIENCE WITH...KERRY GODLIMAN, HOSTED BY GUY LLOYD",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "13:35 - 14:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "AN AUDIENCE WITH...STEPHEN K. AMOS, HOSTED BY PROFESSOR SHAWN NAPHTALI SOBERS",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "12:05 - 12:45",
            },
        ],
        imgUrl: "",
        url: "https://www.stephenkamos.com/",
    },
    {
        name: "ANAIS",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://ana%C3%AFs%20jan%20(@xn--anaisjan%29%20%20instagram%20photos%20and%20videos-mf15a/",
    },
    {
        name: "ANALOG SOUL",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SATURDAY",
                time: "01:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/analogsoul",
    },
    {
        name: "ANDREW JENKINS - OFF TO SPACE",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "THURSDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SATURDAY",
                time: "16:00 - 16:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ANDREW MAXWELL MORRIS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "13:05 - 14:00",
            },
            {
                stage: "TOAD HALL",
                day: "WEDNESDAY",
                time: "18:30 - 19:10",
            },
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "12:00 - 13:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "14:00 - 14:40",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/andrewmmorris",
    },
    {
        name: "ANDREW O'NEILL",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "17:00 - 17:45",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "00:15 - 00:45",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "22:25 - 22:55",
            },
        ],
        imgUrl: "",
        url: "https://www.andrewoneill.co.uk/",
    },
    {
        name: "ANDY C",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "01:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "http://andy%20c%20(@andyc_ramagram%29%20%7C%20instagram/",
    },
    {
        name: "ANDY CARROLL",
        events: [
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "21:45 - 23:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ANDY CATO (GROOVE ARMADA)",
        events: [
            {
                stage: "FLYING BUS",
                day: "SUNDAY",
                time: "01:30 - 02:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ANDY CATO B2B SPOOKY CASH CASH",
        events: [
            {
                stage: "THE BUG",
                day: "FRIDAY",
                time: "20:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://en.wikipedia.org/wiki/andy_cato",
    },
    {
        name: "ANDY HATMAN",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "THURSDAY",
                time: "21:00 - 22:30",
            },
            {
                stage: "THE TAPHOUSE",
                day: "FRIDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/andyhatmanlaurie/",
    },
    {
        name: "ANDY HATMAN / SAFE NATH",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "SUNDAY",
                time: "23:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/safenath/",
    },
    {
        name: "ANGELINE MORRISON",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "11:30 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.angelinemorrisonmusic.com/",
    },
    {
        name: "ANGIE MACK",
        events: [
            {
                stage: "THE GLEBE",
                day: "THURSDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "THE PAVEMENT",
                day: "THURSDAY",
                time: "14:55 - 15:25",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "14:55 - 15:25",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "THURSDAY",
                time: "15:55 - 16:25",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "16:05 - 16:35",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "12:35 - 13:05",
            },
        ],
        imgUrl: "",
        url: "https://www.hulahooper.com/",
    },
    {
        name: "ANI GLASS",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "17:15 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://aniglass.bandcamp.com/",
    },
    {
        name: "ANIMA BLOOM",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/@animabloommusic",
    },
    {
        name: "ANNA CAMPEAU",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "12:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ANNA PRANK",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "THE SALON CAROUSEL",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://on.soundcloud.com/t7r1rfd95xwkuy4h8",
    },
    {
        name: "ANNABELLE HOLLAND (COMPERE)",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "20:15 - 00:45",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "14:00 - 18:00",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "10:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://freneticengineering.co.uk/",
    },
    {
        name: "ANNIE MAC",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "22:00 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/anniemacmanus/?hl=en",
    },
    {
        name: "ANOLAH & ZEE BONEZ",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ANS",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SATURDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://en.wikipedia.org/wiki/glade_festival",
    },
    {
        name: "ANTONY SZMIEREK",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "17:30 - 18:15",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "FRIDAY",
                time: "21:30 - 22:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/antonyszmierek/?hl=en",
    },
    {
        name: "ANYONE FOR TENNIS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:00 - 13:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ANZ B2B SPECIAL REQUEST",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "00:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/anzieanz/?hl=en%20//%20https://www.instagram.com/s_p_e_c_i_a_l_r_e_q_u_e_s_t/?hl=en",
    },
    {
        name: "APIENTO",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "16:30 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/apiento/?hl=en",
    },
    {
        name: "APPLE SHAKERS",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "13:00 - 13:20",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "14:00 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://appleshakers.co.uk/",
    },
    {
        name: "ARAMINTA",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/thearaminta/",
    },
    {
        name: "ARCADIA: THE SCIENCE BEHIND THE SPIDER",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "11:15 - 11:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ARCTIC MONKEYS",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "FRIDAY",
                time: "22:15 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://arcticmonkeys.com/",
    },
    {
        name: "AREA 51 - ANGEL FRANCO",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "00:38 - 00:45",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "00:13 - 00:20",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "00:37 - 00:45",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "00:11 - 00:19",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "AREA 51 ANGEL FRANCO",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "00:39 - 00:46",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "00:14 - 00:21",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "AREEBA HAMID",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://greenpeace%20executive%20director/",
    },
    {
        name: "ARIELLE FREE",
        events: [
            {
                stage: "GLADE",
                day: "THURSDAY",
                time: "21:05 - 22:05",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/ariellefree",
    },
    {
        name: "ARIES",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "FRIDAY",
                time: "00:45 - 01:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ARLO: SUPPER CLUB TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/arlo___dj",
    },
    {
        name: "AROUND ABOUT DUSK",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "14:00 - 14:40",
            },
        ],
        imgUrl: "",
        url: "https://www.rachellawrencemusic.co.uk/aroundaboutdusk/",
    },
    {
        name: "ARTWORK",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SUNDAY",
                time: "02:00 - 03:25",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/artwork",
    },
    {
        name: "ASIF KAPADIA, JAMIE KELSEY FRY & VICTORIA KAPADIA",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "http://culture%20%26%20revolutionary%20shifts/",
    },
    {
        name: "ASKEW",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "17:30 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ASSAD REHMAN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "http://race%2C%20class%2C%20climate%20%26%20capitalism/",
    },
    {
        name: "ASTEROID CITY 12A",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SUNDAY",
                time: "11:00 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt14230388/",
    },
    {
        name: "ASTRA CLUB - DJ TENNIS & CARLITA",
        events: [
            {
                stage: "SAN REMO",
                day: "SUNDAY",
                time: "22:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djtennis/?hl=en%20//%20https://www.instagram.com/carlita_music/?hl=en",
    },
    {
        name: "ATCHIN TAN PRESENTS - BORN ON ROAD",
        events: [
            {
                stage: "FLYING BUS",
                day: "THURSDAY",
                time: "23:05 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://bornonroad.com/",
    },
    {
        name: "ATCHIN TAN PRESENTS - SUGAR SHANE",
        events: [
            {
                stage: "FLYING BUS",
                day: "THURSDAY",
                time: "22:30 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://youtube.com/@sugarshane_1",
    },
    {
        name: "ATCHIN TAN PRESENTS - TRAVELLER AWARENESS CAMPAIGN SPEAKERS",
        events: [
            {
                stage: "FLYING BUS",
                day: "THURSDAY",
                time: "23:00 - 23:05",
            },
            {
                stage: "FLYING BUS",
                day: "THURSDAY",
                time: "22:25 - 22:30",
            },
            {
                stage: "FLYING BUS",
                day: "THURSDAY",
                time: "20:40 - 20:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ATCHIN TAN PRESENTS - ZED BIAS B2B METRODOME HOSTED BY MC BIC AND DJ CHUNKY",
        events: [
            {
                stage: "FLYING BUS",
                day: "THURSDAY",
                time: "20:45 - 22:15",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/zedbiasakamaddslinky",
    },
    {
        name: "ATCHIN TAN PRESENTS: FFTP (FREEDOM FOR TRAVELLING PEOPLE) B2B GORJA BAND",
        events: [
            {
                stage: "FLYING BUS",
                day: "THURSDAY",
                time: "20:00 - 20:40",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/atchintan",
    },
    {
        name: "ATHALAHTA",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://athalahta.com/",
    },
    {
        name: "AUTUMN SAINTS",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "17:05 - 17:50",
            },
        ],
        imgUrl: "",
        url: "https://www.theautumnsaints.com/",
    },
    {
        name: "AXEL BOY",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "20:15 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://axelboymusic.com/",
    },
    {
        name: "B:RAVE",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "00:50 - 01:35",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "01:05 - 01:55",
            },
        ],
        imgUrl: "",
        url: "https://brave-night.com/",
    },
    {
        name: "BABY DINO",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BABY SOUL",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "FRIDAY",
                time: "21:00 - 22:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/babysoul7",
    },
    {
        name: "BACHELORS OF PARADISE",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:50 - 17:35",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:50 - 17:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:50 - 17:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:00 - 13:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BACTERIA BUFFET: CELEBRATE THE WORLD BUILDING GIFTS OF THESE MICROSCOPIC HIDDEN GEMS WITH FIN JORDAO FROM CRIW COMPOSTIO AND THE CENTRE FOR ALTERNATIVE TECHNOLOGY",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BADGE BABES WITH ZOE MILES - MAKE YOUR OWN PROPAGANDA: VISIBILITY IS IMPORTANT!",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "13:45 - 15:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BADLY DRAWN BOY",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "16:00 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/badlydrawnboyofficial/",
    },
    {
        name: "BAGGY MONDAYS",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "14:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/baggymondays",
    },
    {
        name: "BAILE LDN",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "05:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "http://www.instagram.com/baileldn",
    },
    {
        name: "BALANCE",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "19:35 - 20:15",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "20:06 - 20:46",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "20:07 - 20:47",
            },
        ],
        imgUrl: "",
        url: "https://www.boomcircus.co.uk/",
    },
    {
        name: "BANGIN' BRAZILIAN BRUNCH",
        events: [
            {
                stage: "BIMBLE INN",
                day: "SUNDAY",
                time: "12:00 - 14:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BARBARA NICE (COMPERE)",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "12:00 - 15:30",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "12:00 - 14:15",
            },
        ],
        imgUrl: "",
        url: "https://www.mrsbarbaranice.com/",
    },
    {
        name: "BARBARELLA",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "WEDNESDAY",
                time: "22:00 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/soundslikebarbarella/",
    },
    {
        name: "BARONESS JENNY JONES, LISA WINTERSTEIGER & LOUISE HARRIS JSO",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SATURDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "http://police%20bills/",
    },
    {
        name: "BARONHAWK POITIER",
        events: [
            {
                stage: "IICON",
                day: "SATURDAY",
                time: "02:45 - 04:45",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/baronhawkpoitier",
    },
    {
        name: "BARRINGTON LEVY",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SUNDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "http://www.barringtonlevy.com/",
    },
    {
        name: "BARRY CAN'T SWIM",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BARRY CAN\u2019T SWIM",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BASH STREET THEATRE",
        events: [
            {
                stage: "GLEBELAND",
                day: "THURSDAY",
                time: "16:00 - 16:40",
            },
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "16:00 - 16:40",
            },
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "13:00 - 13:40",
            },
            {
                stage: "GLEBELAND",
                day: "SATURDAY",
                time: "16:00 - 16:40",
            },
            {
                stage: "GLEBELAND",
                day: "SATURDAY",
                time: "13:00 - 13:40",
            },
            {
                stage: "GLEBELAND",
                day: "SUNDAY",
                time: "14:30 - 15:10",
            },
        ],
        imgUrl: "",
        url: "http://www.miraculoustheatre.com/",
    },
    {
        name: "BASHKKA",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SATURDAY",
                time: "04:30 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/bashkka",
    },
    {
        name: "BASIL BRUSH",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BASKET WEAVING",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BASSWEIGHT COLLECTIVE",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BASTARD LOVE",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "01:45 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/bastardlove",
    },
    {
        name: "BATU",
        events: [
            {
                stage: "IICON",
                day: "THURSDAY",
                time: "23:15 - 01:15",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/batu-uk",
    },
    {
        name: "BATU B2B ANZ",
        events: [
            {
                stage: "THE LEVELS",
                day: "SUNDAY",
                time: "21:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BAZUKA",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bazuka.nights/",
    },
    {
        name: "BBC 1XTRA AT GLASTONBURY WITH DJ TARGET",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SATURDAY",
                time: "21:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BBC 1XTRA AT GLASTONBURY WITH DJ TARGET & FRIENDS",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SATURDAY",
                time: "19:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BBC ASIAN NETWORK CERTIFIED AT GLASTONBURY WITH DJ MANARA",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SUNDAY",
                time: "21:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BBC NATURAL HISTORY UNIT",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "THURSDAY",
                time: "14:15 - 14:45",
            },
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SATURDAY",
                time: "14:15 - 14:45",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SUNDAY",
                time: "15:00 - 15:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BBC R1 DANCE TAKEOVER",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "THURSDAY",
                time: "18:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BBC RADIO 1 ESSENTIAL MIX (LIVE)",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BBC RADIO 6 MUSIC: INDIE FOREVER LIVE AT GLASTONBURY",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "FRIDAY",
                time: "21:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.bbc.co.uk/programmes/m0012v02",
    },
    {
        name: "BE EXPERIMENTAL INTERACTIVE CONCERT WITH BEXX",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "FRIDAY",
                time: "17:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bexx.me/",
    },
    {
        name: "BE MORE SMILEY'S PEOPLE",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BEANS ON TOAST",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SATURDAY",
                time: "14:10 - 15:05",
            },
        ],
        imgUrl: "",
        url: "https://beansontoastmusic.com/",
    },
    {
        name: "BEATBOX COLLECTIVE",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "23:15 - 23:25",
            },
            {
                stage: "THE GATEWAY",
                day: "FRIDAY",
                time: "13:15 - 13:45",
            },
            {
                stage: "THE GATEWAY",
                day: "SATURDAY",
                time: "13:10 - 13:40",
            },
            {
                stage: "THE GATEWAY",
                day: "SUNDAY",
                time: "13:10 - 13:40",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "18:25 - 18:55",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "16:05 - 16:35",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SUNDAY",
                time: "14:20 - 14:50",
            },
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "20:15 - 21:15",
            },
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "20:50 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/thebeatboxcollective",
    },
    {
        name: "BEATBOX WORKSHOP WITH LEE",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "THURSDAY",
                time: "16:30 - 17:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "FRIDAY",
                time: "16:30 - 17:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SATURDAY",
                time: "16:30 - 17:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://leemakesnoises.co.uk/",
    },
    {
        name: "BEATLES DUB CLUB",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "18:00 - 18:55",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/beatlesdubclub",
    },
    {
        name: "BEAUTIFUL LANDING",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/@beautifullanding/",
    },
    {
        name: "BECKY HILL",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.beckyhill.com/",
    },
    {
        name: "BEE-OLOGY",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BELL AND BULLOCK",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:50 - 15:20",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:45 - 12:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:50 - 15:20",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:45 - 12:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:50 - 15:20",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:45 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.bellandbullock.co.uk/",
    },
    {
        name: "BELLAH",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "18:00 - 18:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BELVEDERE TOWN CATS",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "10:00 - 11:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BEN ATKINS",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BEN B\u00d6HMER",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BEN HOWARD",
        events: [
            {
                stage: "OTHER STAGE",
                day: "FRIDAY",
                time: "11:30 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.benhowardmusic.co.uk/",
    },
    {
        name: "BEN LOADER",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "18:40 - 18:48",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "16:08 - 16:14",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "00:50 - 00:56",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "00:00 - 00:06",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "00:03 - 00:09",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "20:13 - 20:19",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BEN MONK & FRIENDS",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "THURSDAY",
                time: "17:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BEN PEST",
        events: [
            {
                stage: "THE TEMPLE",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/benpest/",
    },
    {
        name: "BEN RANDM",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "10:00 - 10:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BEN UFO",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SATURDAY",
                time: "02:30 - 04:30",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/benufo",
    },
    {
        name: "BEN VIRGO B2B CHRIS THORNE",
        events: [
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "17:40 - 18:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BENEFITS",
        events: [
            {
                stage: "LEFT FIELD",
                day: "FRIDAY",
                time: "19:30 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://www.benefitstheband.com/",
    },
    {
        name: "BENJI B",
        events: [
            {
                stage: "PLATFORM 23",
                day: "FRIDAY",
                time: "05:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/benjib/",
    },
    {
        name: "BENJI CLEMENTS",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://youtu.be/f9by7yn9ayy",
    },
    {
        name: "BENJI CLEMENTS (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "21:00 - 21:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/benjiclementsmusic/",
    },
    {
        name: "BENNY HUSTLE: SUPPER CLUB TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/supperclubbristol/",
    },
    {
        name: "BENTON",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "16:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BETH METAL",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bethgmiles/",
    },
    {
        name: "BETH ORTON",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SUNDAY",
                time: "12:30 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://bethortonofficial.com/",
    },
    {
        name: "BETHANY HUMPHRIES",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "13:05 - 13:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BEXI",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "00:50 - 00:56",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "00:02 - 00:08",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "18:35 - 18:41",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "16:08 - 16:14",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "23:37 - 23:43",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "18:04 - 18:10",
            },
        ],
        imgUrl: "",
        url: "https://www.rebeccarennison.com/",
    },
    {
        name: "BEYOND REPAIR ENTERTAINMENT",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "14:45 - 15:15",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "14:45 - 15:15",
            },
        ],
        imgUrl: "",
        url: "https://beyondrepairentertainment.com/",
    },
    {
        name: "BEYOND THE STRUTTOSPHERE",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SUNDAY",
                time: "23:30 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/beyond-the-struttosphere",
    },
    {
        name: "BICYCLE PIANO & DOUBLE BASSICLE",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "15:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "BIG JOANIE",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SATURDAY",
                time: "16:30 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://bigjoanie.com/",
    },
    {
        name: "BIG TEAM CIC PRESENTS: 'CAN FESTIVALS BE A FORCE FOR CHANGE?'",
        events: [
            {
                stage: "THE INFORMATION",
                day: "FRIDAY",
                time: "15:45 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BILL BREWSTER",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SUNDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BILL BREWSTER (LOWLIFE)",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "SATURDAY",
                time: "01:45 - 03:00",
            },
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/billbrewster",
    },
    {
        name: "BILLY BRAGG",
        events: [
            {
                stage: "LEFT FIELD",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.billybragg.co.uk/",
    },
    {
        name: "BILLY KIDD SHOW",
        events: [
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "15:35 - 16:05",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "15:35 - 16:05",
            },
            {
                stage: "THE GLEBE",
                day: "SUNDAY",
                time: "15:35 - 16:05",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "12:55 - 13:25",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "12:30 - 13:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "13:30 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.billykiddshow.com/",
    },
    {
        name: "BILLY NOMATES",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "FRIDAY",
                time: "15:15 - 16:15",
            },
        ],
        imgUrl: "",
        url: "https://www.iambillynomates.com/",
    },
    {
        name: "BILLY'S WARM HUG",
        events: [
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "12:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BIMBLE DJS",
        events: [
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "21:15 - 00:15",
            },
            {
                stage: "BIMBLE INN",
                day: "SUNDAY",
                time: "21:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BIMINI",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "20:50 - 21:20",
            },
            {
                stage: "NYC DOWNLOW",
                day: "THURSDAY",
                time: "23:20 - 23:35",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BINGO BANGO BONGO",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "14:20 - 14:50",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "16:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BINGO WITH KEITH ALLEN",
        events: [
            {
                stage: "DELUXE DINER",
                day: "FRIDAY",
                time: "19:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BIO-DESIGN - BUILDING A REGENERATIVE PLANET",
        events: [
            {
                stage: "THE INFORMATION",
                day: "FRIDAY",
                time: "12:00 - 12:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BIRD ON THE WIRE: THE SONGS OF LEONARD COHEN",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "15:00 - 15:50",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/birdotwire/?hl=en",
    },
    {
        name: "BISH 90S DANCE ANTHEMS SET",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/jimbit",
    },
    {
        name: "BLACK BOX",
        events: [
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "17:40 - 18:40",
            },
        ],
        imgUrl: "",
        url: "https://www.blackboxhouse.eu/",
    },
    {
        name: "BLACK COUNTRY, NEW ROAD",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://blackcountrynewroad.com/",
    },
    {
        name: "BLACK KAT BOPPERS",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "SUNDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://blackkatboppers.com/",
    },
    {
        name: "BLACK OBSIDIAN SOUND \n SYSTEM",
        events: [
            {
                stage: "IICON",
                day: "SATURDAY",
                time: "20:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/blackobsidiansoundsystem/",
    },
    {
        name: "BLACKSKYWHITE - 'STREET OF CROCODILES'",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "THURSDAY",
                time: "22:50 - 00:05",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "23:00 - 00:15",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "23:00 - 00:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BLACKSMITH & FRENIC",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/blacksmithmusic/.%20https://www.instagram.com/djfrenic/",
    },
    {
        name: "BLENDID X BEATBOX COLLECTIVE TAKEOVER 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "00:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thebeatboxcollective.com/",
    },
    {
        name: "BLIND TIGER RESIDENTS & GUESTS - LOKO",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BLIND TIGER RESIDENTS & GUESTS OPENING PARTY",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BLIND TIGER RESIDENTS & GUESTS OPENING PARTY - CARDINAL SOUND",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BLIND TIGER RESIDENTS & GUESTS OPENING PARTY - VIXAN SOUNDS",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BLOCKBUSTER FACTORY",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "15:45 - 16:40",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "13:30 - 14:25",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:45 - 16:40",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:30 - 14:25",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:45 - 16:40",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:30 - 14:25",
            },
        ],
        imgUrl: "",
        url: "https://www.catandmousetheatre.com/",
    },
    {
        name: "BLOCO B",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "15:05 - 15:45",
            },
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "12:30 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bloco.b_uk",
    },
    {
        name: "BLONDIE",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SUNDAY",
                time: "17:00 - 18:15",
            },
        ],
        imgUrl: "",
        url: "https://www.blondie.net/",
    },
    {
        name: "BLUE LAB BEATS",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "00:15 - 01:00",
            },
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "14:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BLUE VIOLET",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "16:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/weareblueviolet/?hl=en",
    },
    {
        name: "BOBBY FRICTION'S BHANGRA ALL STARS (GOING SOUTH TAKEOVER)",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "21:15 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bhangraallstarsband/?hl=en",
    },
    {
        name: "BOBBY FRICTON",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bobbyfricton/",
    },
    {
        name: "BOBBY.",
        events: [
            {
                stage: "THE WOW",
                day: "SUNDAY",
                time: "19:30 - 20:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BONZAI BONNER",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BOOKS ARE WEAPONS - SPORTS BANGER IN CONVERSATION WITH JEREMY DELLER",
        events: [
            {
                stage: "THE INFORMATION",
                day: "SATURDAY",
                time: "15:45 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BOOT PUPPET THEATRE",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BOOTWORKS THEATRE",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "18:00 - 19:30",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "14:30 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "18:00 - 19:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:30 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "18:00 - 19:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:30 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:00 - 19:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BOOTY BASS",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "15:45 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bootybassdj/",
    },
    {
        name: "BOOTY BASS X SHADE CARTEL",
        events: [
            {
                stage: "NOMAD",
                day: "THURSDAY",
                time: "00:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BORN ON ROAD X RUMBLE IN THE JUNGLE TAKEOVER",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "22:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BORN ON ROAD; ARIES, KELVIN 373 & SELECTA J-MAN",
        events: [
            {
                stage: "THE TEMPLE",
                day: "THURSDAY",
                time: "23:15 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bornonroad/",
    },
    {
        name: "BOSCO CIRCUS",
        events: [
            {
                stage: "JUGGLING TENT",
                day: "FRIDAY",
                time: "12:00 - 15:00",
            },
            {
                stage: "JUGGLING TENT",
                day: "SATURDAY",
                time: "12:00 - 15:00",
            },
            {
                stage: "JUGGLING TENT",
                day: "SUNDAY",
                time: "12:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/boscoatglasto",
    },
    {
        name: "BOSSLADY",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "THURSDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "http://www.instagram.com/dj_bosslady_uk",
    },
    {
        name: "BOT",
        events: [
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "14:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://beansontoastmusic.com/",
    },
    {
        name: "BOU",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "19:05 - 20:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/boudnb",
    },
    {
        name: "BOU B2B HEDEX FT HARIBO & EKS",
        events: [
            {
                stage: "THE TEMPLE",
                day: "THURSDAY",
                time: "20:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bou_dnb/%20https://www.instagram.com/hedexuk/",
    },
    {
        name: "BOU B2B TURNO",
        events: [
            {
                stage: "NOWHERE",
                day: "SUNDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "http://bou%20(@xn--bou_dnb%29%20%20instagram%20photos%20and%20videos%20%20%20%20%20%20%20https-vo61c//www.instagram.com/turno_/",
    },
    {
        name: "BOWJANGLES",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:15 - 14:15",
            },
        ],
        imgUrl: "",
        url: "https://www.bowjangles.org/",
    },
    {
        name: "BPOC RETREAT SPACE - COLLECTIVE CARE SESSION LED BY LION FEATURING SELF-MASSAGE, MUD FOOT MASKS, DIY FACE MASKS AND MORE",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "16:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BRADLEY ZERO",
        events: [
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "23:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bradley_zero/?hl=en",
    },
    {
        name: "BRADLEY ZERO B2B RUF DUG",
        events: [
            {
                stage: "THE WOW",
                day: "THURSDAY",
                time: "19:30 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BRASS OFF",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.newyorkbrassband.co.uk/",
    },
    {
        name: "BRASS RASCALS",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "15:00 - 15:50",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "FRIDAY",
                time: "23:45 - 00:40",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BREAKING BROKEN DREAMS",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "15:33 - 16:03",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "14:58 - 15:28",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "16:06 - 16:36",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "17:15 - 17:45",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SUNDAY",
                time: "13:10 - 13:40",
            },
        ],
        imgUrl: "",
        url: "https://www.lascossasnostra.com/breaking-broken-dreams---eng",
    },
    {
        name: "BREATH AND BASS",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "SATURDAY",
                time: "17:30 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BRIAN V",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BRIGHT & FINDLAY (LIVE)",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "23:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/brightandfindlay/?hl=en-gb",
    },
    {
        name: "BROADSIDE BANGERS",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "18:05 - 19:50",
            },
        ],
        imgUrl: "",
        url: "https://juliangaskell.co.uk/2023/01/12/broadside-bangers-in-falmouth/",
    },
    {
        name: "BROOKLYN HEALER",
        events: [
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "15:00 - 17:00",
            },
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "12:00 - 14:00",
            },
            {
                stage: "GLEBELAND",
                day: "SATURDAY",
                time: "15:00 - 17:00",
            },
            {
                stage: "GLEBELAND",
                day: "SATURDAY",
                time: "12:00 - 14:00",
            },
            {
                stage: "GLEBELAND",
                day: "SUNDAY",
                time: "15:00 - 17:00",
            },
            {
                stage: "GLEBELAND",
                day: "SUNDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "http://www.miraculoustheatre.com/",
    },
    {
        name: "BRU-C",
        events: [
            {
                stage: "WOODSIES",
                day: "FRIDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.bru-c.com/",
    },
    {
        name: "BRUCE (LIVE)",
        events: [
            {
                stage: "THE WOW",
                day: "FRIDAY",
                time: "18:00 - 18:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BSL POET LAUREATE - KABIR KAPOOR",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "17:15 - 17:25",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BUNMI - AFROFUSION STRAPS",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "20:31 - 20:37",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "22:06 - 22:12",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "19:44 - 19:50",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "22:07 - 22:13",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "19:45 - 19:51",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "16:56 - 17:02",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BUNNY",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "12:05 - 12:35",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "16:45 - 17:15",
            },
            {
                stage: "THE PAVEMENT",
                day: "WEDNESDAY",
                time: "14:35 - 15:05",
            },
        ],
        imgUrl: "",
        url: "https://freneticengineering.co.uk/",
    },
    {
        name: "BUNNY MORETHAN (COMPERE)",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "16:00 - 20:30",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "18:00 - 22:00",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "22:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://scarylittlegirls.co.uk/",
    },
    {
        name: "BUNTY (LIVE)",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SUNDAY",
                time: "22:45 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/buntylooping/",
    },
    {
        name: "BUSHBBY",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "03:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/people/bushbby/100063534603925/",
    },
    {
        name: "BUSTAWIDEMOVE",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.widedubz.co.uk/",
    },
    {
        name: "BUZZ STOP",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "BUZZING BEES",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:20 - 15:20",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:10 - 12:10",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:20 - 15:20",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:10 - 12:10",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CABARET FANTASTIQUE",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "21:05 - 21:45",
            },
        ],
        imgUrl: "",
        url: "https://www.marcellucont.com/",
    },
    {
        name: "CABLE STREET COLLECTIVE",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SATURDAY",
                time: "11:30 - 12:20",
            },
        ],
        imgUrl: "",
        url: "http://cablestreetcollective.co.uk/",
    },
    {
        name: "CAKES DA KILLA (LIVE)",
        events: [
            {
                stage: "IICON",
                day: "FRIDAY",
                time: "22:50 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.cakesdakilla.com/",
    },
    {
        name: "CAL JADER",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "SUNDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CAL JADER (MOVIMIENTOS)",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "15:45 - 16:15",
            },
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "14:45 - 01:12",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/djcaljader/?locale=en_gb",
    },
    {
        name: "CALL SUPER",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "THURSDAY",
                time: "20:00 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/callsuper",
    },
    {
        name: "CALLUM EASTER",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "22:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CAM COLE",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CAMELPHAT",
        events: [
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CANDAR",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "19:30 - 20:15",
            },
        ],
        imgUrl: "",
        url: "https://www.candarband.com/",
    },
    {
        name: "CANDI STATON",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.candi-staton.com/",
    },
    {
        name: "CANDYMAN 15",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "WEDNESDAY",
                time: "20:15 - 21:52",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt9347730/",
    },
    {
        name: "CAPTAIN KIPPER",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SATURDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CARA DILLON",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SUNDAY",
                time: "13:55 - 14:50",
            },
        ],
        imgUrl: "",
        url: "https://www.caradillon.co.uk/",
    },
    {
        name: "CARDINAL SOUND: ORIGINS",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/cardinalsound/",
    },
    {
        name: "CARL COX HYBRID SET",
        events: [
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "23:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://carlcox.com/",
    },
    {
        name: "CARLY RAE JEPSEN",
        events: [
            {
                stage: "OTHER STAGE",
                day: "FRIDAY",
                time: "15:45 - 16:45",
            },
        ],
        imgUrl: "",
        url: "https://www.carlyraemusic.com/",
    },
    {
        name: "CARLY WILFORD",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "23:00 - 00:30",
            },
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "21:15 - 22:25",
            },
        ],
        imgUrl: "",
        url: "https://carlywilford.com/",
    },
    {
        name: "CARNIVAL",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "THURSDAY",
                time: "21:00 - 21:30",
            },
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "12:30 - 13:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "12:30 - 13:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CAROLINE POLACHEK",
        events: [
            {
                stage: "WOODSIES",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.carolinepolachek.com/",
    },
    {
        name: "CASEY SPILLMAN",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "23:20 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/caseyspillman/?hl=en",
    },
    {
        name: "CASH COWS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "17:45 - 18:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CASPA X JOKER X SIR SPYRO FT FOOTSIE",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/caspaofficial/%20%20%20%20%20%20%20https://www.instagram.com/sirspyro/%20%20%20%20%20https://www.instagram.com/joker_kapsize/%20%20%20%20https://www.instagram.com/itsfootsieagain/",
    },
    {
        name: "CASSETTEBOY VS DJ RUBBISH",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "13:00 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/boycassette",
    },
    {
        name: "CASSYETTE",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SUNDAY",
                time: "20:00 - 20:30",
            },
            {
                stage: "LEFT FIELD",
                day: "FRIDAY",
                time: "18:15 - 19:00",
            },
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "22:45 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/cassyette",
    },
    {
        name: "CAT BURNS",
        events: [
            {
                stage: "WOODSIES",
                day: "SUNDAY",
                time: "15:30 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://www.catburns.com/",
    },
    {
        name: "CAVETOWN",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SUNDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://uk.cave.town/",
    },
    {
        name: "CELEBRATING 30 YEARS OF V RECORDINGS: BRYAN GEE X  DILLINJA X DJ DIE X JUMPIN JACK FROST W/ CARASEL",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "FRIDAY",
                time: "19:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CELESTE LOVICK",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CELTIC BLUE ROCKER",
        events: [
            {
                stage: "MUZIKADEMY",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CENTRAL CEE",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SATURDAY",
                time: "20:45 - 21:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/centralcee/?hl=en",
    },
    {
        name: "CERIAN",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "14:40 - 15:25",
            },
        ],
        imgUrl: "",
        url: "https://www.cerianmusic.com/",
    },
    {
        name: "CERYS NELMES (COMPERE)",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "19:00 - 22:30",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "20:45 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.cerysnelmes.com/",
    },
    {
        name: "CHAINSKA BRASSIKA",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "00:00 - 01:15",
            },
            {
                stage: "BIMBLE INN",
                day: "SUNDAY",
                time: "00:30 - 01:45",
            },
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "16:15 - 17:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/chainskabrassika",
    },
    {
        name: "CHAMPIGNON WORLD",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/watch?v=lg2halo0-as",
    },
    {
        name: "CHAMPION B2B OPPIDAN",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "FRIDAY",
                time: "21:30 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHANNEL ONE SOUNDSYSTEM",
        events: [
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "12:30 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://channelonesoundsystem.com/",
    },
    {
        name: "CHANTZ DEE",
        events: [
            {
                stage: "NOMAD",
                day: "SUNDAY",
                time: "01:30 - 02:30",
            },
            {
                stage: "THE RUM SHACK",
                day: "FRIDAY",
                time: "05:00 - 06:00",
            },
            {
                stage: "THE RUM SHACK",
                day: "FRIDAY",
                time: "23:00 - 23:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHARISSE C",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "FRIDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/charisseec/",
    },
    {
        name: "CHARLIE BICKNELL - BIG SPENDER",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "18:47 - 18:59",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "22:17 - 22:29",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "12:30 - 12:42",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "18:22 - 18:35",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "18:17 - 18:30",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "13:50 - 13:56",
            },
        ],
        imgUrl: "",
        url: "https://www.circusworksdevoran.org/",
    },
    {
        name: "CHARLIE BICKNELL - WRECKING BALL",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "21:19 - 21:25",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "15:31 - 15:37",
            },
        ],
        imgUrl: "",
        url: "https://www.charliebicknell.com/",
    },
    {
        name: "CHARLIE TEE",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.charlietee.com/",
    },
    {
        name: "CHARLOTTE ADIGERY & BOLIS PUPUL",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SUNDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://charlotteandbolis.com/",
    },
    {
        name: "CHE LINGO",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/che_lingo/",
    },
    {
        name: "CHEEKY FIELD MICE",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHEMICAL BROS DON'T THINK PG",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "FRIDAY",
                time: "01:30 - 03:06",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt2137916/",
    },
    {
        name: "CHEVY CHASE STOLE MY WIFE",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "21:30 - 22:30",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "19:35 - 20:05",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHEWY SHE",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "FRIDAY",
                time: "01:30 - 02:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHEZNEY (100% VINYL SET)",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHIEF DADA, TIM VAN SOLINGE, LEA HEJN.",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "WEDNESDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "http://forest%20forces/",
    },
    {
        name: "CHINNEN",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "14:58 - 15:28",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "16:54 - 17:24",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "18:50 - 19:20",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "17:15 - 17:45",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "THE PAVEMENT",
                day: "SUNDAY",
                time: "14:55 - 15:25",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHLOE ROBINSON B2B PLASTICIAN",
        events: [
            {
                stage: "ARCADIA",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/chloerobinsondj",
    },
    {
        name: "CHLO\u00c9 CAILLET",
        events: [
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/chloecaillet/?hl=en-gb",
    },
    {
        name: "CHRIS CHURCH",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SUNDAY",
                time: "10:00 - 11:00",
            },
        ],
        imgUrl: "",
        url: "http://50%20years%20of%20green%20action/",
    },
    {
        name: "CHRIS CRUSE",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SATURDAY",
                time: "22:00 - 23:20",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/chriscruse",
    },
    {
        name: "CHRIS GEE B2B STACKY",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHRIS HOLT",
        events: [
            {
                stage: "DELUXE DINER",
                day: "FRIDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "DELUXE DINER",
                day: "SUNDAY",
                time: "00:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHRIS HOLT, ANDY P, ANNIE TRASH",
        events: [
            {
                stage: "DELUXE DINER",
                day: "SUNDAY",
                time: "02:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHRIS LYNAM",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "00:30 - 01:00",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "00:30 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://chrislynam.net/",
    },
    {
        name: "CHRIS READ",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "SATURDAY",
                time: "19:00 - 21:00",
            },
            {
                stage: "THE MEETING PLACE BAR",
                day: "SUNDAY",
                time: "16:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/chris_read/?hl=en",
    },
    {
        name: "CHRISTINE AND THE QUEENS",
        events: [
            {
                stage: "WOODSIES",
                day: "SATURDAY",
                time: "22:30 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://www.christineandthequeens.com/",
    },
    {
        name: "CHRISTINE WILLISON",
        events: [
            {
                stage: "STORYTELLERS LOUNGE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CHVRCHES",
        events: [
            {
                stage: "OTHER STAGE",
                day: "FRIDAY",
                time: "18:45 - 19:45",
            },
        ],
        imgUrl: "",
        url: "https://chvrch.es/",
    },
    {
        name: "CINTHIE",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "FRIDAY",
                time: "23:30 - 00:55",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/cinthie",
    },
    {
        name: "CIRCUS ERUPTION",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "WEDNESDAY",
                time: "14:00 - 16:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "WEDNESDAY",
                time: "11:00 - 13:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "14:00 - 16:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "11:00 - 13:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "11:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.circuseruption.co.uk/",
    },
    {
        name: "CIRCUS FUDGE",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CIRCUS FUNTASIA",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "17:32 - 18:42",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "17:59 - 19:09",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "18:00 - 19:10",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "17:07 - 18:17",
            },
        ],
        imgUrl: "",
        url: "https://www.circusfuntasia.co.uk/",
    },
    {
        name: "CIRCUS RAJ",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "11:30 - 12:00",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "11:30 - 12:00",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:30 - 17:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:30 - 17:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:30 - 17:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://www.accessallareas.info/artist/circus-raj/",
    },
    {
        name: "CIRCUS SKILLS WITH MARIE AND JACOB- FREE HUGS AND SPARKLES",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CIRCUS TASTER WORKSHOP",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "14:20 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/nulahula",
    },
    {
        name: "CIRK HES (NEXT GEN)",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "19:04 - 19:19",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "17:39 - 17:54",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "14:46 - 15:01",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "17:40 - 17:55",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "14:41 - 14:56",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "14:15 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.circusworksdevoran.org/",
    },
    {
        name: "CIRQUE DU VULGAR",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "22:00 - 23:10",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "23:02 - 00:12",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "22:57 - 00:07",
            },
        ],
        imgUrl: "",
        url: "https://www.cirqueduvulgar.com/",
    },
    {
        name: "CIRQUE PYROMANTIC",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "17:15 - 18:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:15 - 18:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:15 - 18:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:30 - 16:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/cirquepyromantic/",
    },
    {
        name: "CLAMOUR OF BELLS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:50 - 14:35",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:10 - 11:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:05 - 15:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:05 - 11:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:15 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:45 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/musicandfools",
    },
    {
        name: "CLARE FARRELL XR & JAMIE KELSEY FRY",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://the%20tyranny%20of%20agreement/",
    },
    {
        name: "CLARE SANDS",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "11:30 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://claresands.com/",
    },
    {
        name: "CLAY BOTTOM JUG BUSTERS",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "THE BANDSTAND",
                day: "WEDNESDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://jugbusters.bandcamp.com/",
    },
    {
        name: "CLIMATE CHANGE Q&A WITH RICHARD BETTS",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "SUNDAY",
                time: "12:45 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://geography.exeter.ac.uk/staff/?web_id=richard_betts",
    },
    {
        name: "CLIMATE CHANGE Q&A WITH RICHARD BETTS AND TAMSIN EDWARDS",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "12:45 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://geography.exeter.ac.uk/staff/?web_id=richard_betts",
    },
    {
        name: "CLIVE LEWIS MP & JOHN HARRIS",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://climate%20%26%20food/",
    },
    {
        name: "CLIVE LEWIS MP, MOLLY SCOTT CATO, LUKE KEMP & LEILA DEEN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SATURDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "http://averting%20climate%20collapse/",
    },
    {
        name: "CLLR SHANE COLLINS",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "WEDNESDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://strategies%20for%20change/",
    },
    {
        name: "CLLR SHANE COLLINS, AREEBA HAMID [GREENPEACE], BARONESS JENNY JONES, CLARE FARRELL XR",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "http://reform%2C%20protest%2C%20sabotage%20or%20resistance/?",
    },
    {
        name: "CLOCKWORK ORANGE 18",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SUNDAY",
                time: "00:30 - 02:46",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt0066921/",
    },
    {
        name: "CLOSED",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "21:04 - 23:32",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "20:57 - 23:30",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "21:09 - 23:32",
            },
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "18:10 - 18:40",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "18:10 - 18:40",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "18:00 - 22:15",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "18:00 - 22:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "18:35 - 23:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CLOSEDOWN",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "20:35 - 20:35",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "20:35 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CLOSING CEREMONY",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SUNDAY",
                time: "04:30 - 05:00",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SUNDAY",
                time: "15:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "http://ig%20@karysjourney/",
    },
    {
        name: "CLOUDMEN",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "17:45 - 18:45",
            },
        ],
        imgUrl: "",
        url: "https://www.lagaleriemobile.com/",
    },
    {
        name: "CLOWN ZAZ & THE LITTLE CLOWNS",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CLUB YEKE: CAMI LAYE OKUN",
        events: [
            {
                stage: "PLATFORM 23",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/camilayeokun/",
    },
    {
        name: "CLUB YEKE: JARREAU VANDAL",
        events: [
            {
                stage: "PLATFORM 23",
                day: "FRIDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jarreauvandal/",
    },
    {
        name: "CLUB YEKE: SHANNEN SP",
        events: [
            {
                stage: "PLATFORM 23",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/shannensp_/",
    },
    {
        name: "CLUB YEKE: TASH LC",
        events: [
            {
                stage: "PLATFORM 23",
                day: "FRIDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/tashlc/",
    },
    {
        name: "CMAT",
        events: [
            {
                stage: "WOODSIES",
                day: "SUNDAY",
                time: "12:30 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.cmatbaby.com/",
    },
    {
        name: "COACH PARTY",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SUNDAY",
                time: "15:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://coachparty.ochre.store/",
    },
    {
        name: "COCKATOO",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "15:00 - 02:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "15:00 - 02:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "15:00 - 02:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SUNDAY",
                time: "15:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "http://nil/",
    },
    {
        name: "COCOLOCO",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "18:40 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://cocoloco.co.uk/",
    },
    {
        name: "COCOLOCO - ALICE AND ALICE",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "18:15 - 19:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:45 - 15:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "18:15 - 19:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:45 - 15:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:00 - 18:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:45 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.cocoloco.co.uk/",
    },
    {
        name: "COLECTIVA",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "20:00 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/colectivamusic/?hl=en",
    },
    {
        name: "COLECTIVA (GLOBAL LOCAL)",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "16:15 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.globallocal.co.uk/colectiva",
    },
    {
        name: "COLONEL",
        events: [
            {
                stage: "VILLAGE INN",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/colonelcotch/",
    },
    {
        name: "COME AND MEET ARTIST IONE MARIE ROJAS IN HER TEMPORARY EARTH BASED STUDIO APOTHACARY",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "12:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "COMPERE: JONNY FLUFFYPUNK",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "11:50 - 15:30",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "15:30 - 19:00",
            },
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "11:55 - 14:20",
            },
        ],
        imgUrl: "",
        url: "http://jonnyfluffypunk.co.uk/",
    },
    {
        name: "COMPERE: ROSY CARRICK",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "15:39 - 19:00",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "11:50 - 15:30",
            },
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "14:20 - 16:55",
            },
        ],
        imgUrl: "",
        url: "https://www.rosycarrick.com/",
    },
    {
        name: "CONDUCTA/BAKEY CAPO LEE",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/conductauk/%20%20%20%20%20%20https://www.instagram.com/bakey_____/%20%20%20%20%20https://www.instagram.com/capo_lee/",
    },
    {
        name: "CONFIDENCE MAN (DJ SET)",
        events: [
            {
                stage: "SAN REMO",
                day: "SUNDAY",
                time: "17:00 - 19:00",
            },
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CONGO IAIN",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CONSCIOUS BREATHWORK WITH KERRY VEITCH",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "THURSDAY",
                time: "11:00 - 12:30",
            },
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "FRIDAY",
                time: "11:15 - 12:15",
            },
        ],
        imgUrl: "",
        url: "https://www.thesacredbreath.co.uk/",
    },
    {
        name: "COOL BEANS ROADSHOW",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "COPPER JEWELLERY WORKSHOP",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CORDELIA GARTSIDE",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "15:00 - 15:40",
            },
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "15:00 - 15:40",
            },
        ],
        imgUrl: "",
        url: "https://www.cordeliagartside.com/",
    },
    {
        name: "CORREO HAZZARD",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CORTO.ALTO",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "SATURDAY",
                time: "21:30 - 22:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/corto.alto/?hl=en-gb",
    },
    {
        name: "CORVUS ANGELICUS - ANGELS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "22:45 - 23:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "22:45 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/corvusangelicus",
    },
    {
        name: "CORVUS ANGELICUS - CROWS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:20 - 16:50",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:40 - 15:10",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/corvusangelicus",
    },
    {
        name: "CORVUS ANGELICUS- ANGELS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "22:45 - 23:30",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "21:30 - 22:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "21:30 - 22:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "21:30 - 22:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/corvusangelicus",
    },
    {
        name: "CORVUS ANGELICUS- CROWS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:20 - 17:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:20 - 15:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:20 - 16:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:25 - 14:55",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/corvusangelicus",
    },
    {
        name: "COSMIC TITS",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "00:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/globalhealthglobalbeats/",
    },
    {
        name: "COURTEENERS",
        events: [
            {
                stage: "WOODSIES",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.courteeners-stjude.com/",
    },
    {
        name: "CRACK MAGAZINE PRESENTS: 'RE-DEFINING INDEPENDENCE",
        events: [
            {
                stage: "THE INFORMATION",
                day: "FRIDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CRACK ST BOYS",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CRAFTY COSTUMES",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CRAIG CHARLES",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SATURDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/craigcharlespage/?locale=en_gb",
    },
    {
        name: "CRAIG CHARLES & FRIENDS",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "14:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.craig-charles.co.uk/",
    },
    {
        name: "CRAIG RICHARDS B2B FRANCESCO DEL GARDA",
        events: [
            {
                stage: "THE WOW",
                day: "FRIDAY",
                time: "23:30 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CRATE STACK CHALLENGE",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "10:30 - 11:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "http://nil/",
    },
    {
        name: "CRAWLERS",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SATURDAY",
                time: "18:45 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.crawlersband.com/",
    },
    {
        name: "CRAZY P SOUNDSYSTEM",
        events: [
            {
                stage: "GLADE",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/crazypmusic",
    },
    {
        name: "CREATIVE NATURE",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CREATURE + Q&A 12",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "THURSDAY",
                time: "15:15 - 17:15",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt17499492/",
    },
    {
        name: "CROSSY",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "FRIDAY",
                time: "03:45 - 04:30",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/crossydnb?igshid=ymmymta2m2y=",
    },
    {
        name: "CRYPTID PETTING ZOO",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "CRYSTAL SINGING BOWLS",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SATURDAY",
                time: "10:15 - 11:15",
            },
        ],
        imgUrl: "",
        url: "https://yogicsound.com/",
    },
    {
        name: "CRYSTAL SINGING BOWLS WITH MARTINA",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "THURSDAY",
                time: "09:30 - 10:30",
            },
        ],
        imgUrl: "",
        url: "https://yogicsound.com/",
    },
    {
        name: "CRYSTAL SINGING BOWLS WITH MARTINA SAORIN",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "FRIDAY",
                time: "10:00 - 11:00",
            },
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SUNDAY",
                time: "10:00 - 11:00",
            },
        ],
        imgUrl: "",
        url: "https://yogicsound.com/",
    },
    {
        name: "CUMBIA KID",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "14:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "D*LEX",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "THURSDAY",
                time: "11:00 - 14:00",
            },
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "12:00 - 14:00",
            },
            {
                stage: "THE MEETING PLACE BAR",
                day: "SUNDAY",
                time: "18:00 - 20:00",
            },
            {
                stage: "THE MEETING PLACE BAR",
                day: "SUNDAY",
                time: "14:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/dlex",
    },
    {
        name: "DADO",
        events: [
            {
                stage: "GLEBELAND",
                day: "WEDNESDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "GLEBELAND",
                day: "WEDNESDAY",
                time: "14:00 - 14:30",
            },
            {
                stage: "GLEBELAND",
                day: "THURSDAY",
                time: "13:30 - 14:00",
            },
            {
                stage: "GLEBELAND",
                day: "THURSDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "13:40 - 14:10",
            },
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "12:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.dadoshow.com/",
    },
    {
        name: "DAEMON OR DOPPLEGANGER",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "13:00 - 17:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "11:00 - 19:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "11:00 - 19:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SUNDAY",
                time: "13:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://nil/",
    },
    {
        name: "DAISY CHUTE",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "17:20 - 18:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "16:00 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://www.daisychute.com/",
    },
    {
        name: "DAMO",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "SATURDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DAN EVANS (COMPERE)",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "15:15 - 20:35",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "11:00 - 15:15",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "15:30 - 19:45",
            },
        ],
        imgUrl: "",
        url: "https://www.danevans.info/",
    },
    {
        name: "DAN OTTEWELL",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "10:15 - 10:45",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "SUNDAY",
                time: "18:00 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://danottewellmusic.bandcamp.com/album/dan-ottewell-ep",
    },
    {
        name: "DAN RHODES",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DAN SHAKE B2B ELKKA",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "17:30 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DAN THE HAT",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "16:19 - 16:49",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "17:42 - 18:12",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "12:55 - 13:25",
            },
            {
                stage: "THE GLEBE",
                day: "THURSDAY",
                time: "14:20 - 14:50",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "THURSDAY",
                time: "15:20 - 15:50",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "14:20 - 14:50",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SUNDAY",
                time: "16:40 - 17:10",
            },
        ],
        imgUrl: "",
        url: "https://www.danthehat.co.uk/",
    },
    {
        name: "DAN WEBBER",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "12:54 - 13:19",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "12:31 - 12:56",
            },
        ],
        imgUrl: "",
        url: "https://imgenrefluid.com/",
    },
    {
        name: "DANA IMMANUEL & THE STOLEN BAND",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "17:05 - 17:50",
            },
        ],
        imgUrl: "",
        url: "http://www.danaimmanuel.com/",
    },
    {
        name: "DANCE CLASS: REGGAETON",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/nigel.may.773/",
    },
    {
        name: "DANCE CLASS: SALSA",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "WEDNESDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "WEDNESDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "WEDNESDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "THURSDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "THURSDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://moeflex.com/",
    },
    {
        name: "DANCE CLASS: TANGO",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "WEDNESDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "WEDNESDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "THURSDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.tangoalchemy.co.uk/",
    },
    {
        name: "DANCE SYSTEM",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SUNDAY",
                time: "19:30 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/l-vis1990",
    },
    {
        name: "DANIEL AVERY",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DANIEL AVERY B2B RICHARD FEARLESS",
        events: [
            {
                stage: "GLADE",
                day: "THURSDAY",
                time: "00:35 - 02:25",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/danielmarkavery/",
    },
    {
        name: "DANIEL GONCALVES",
        events: [
            {
                stage: "THE GLEBE",
                day: "THURSDAY",
                time: "14:55 - 15:25",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "THURSDAY",
                time: "16:30 - 16:55",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "14:20 - 14:50",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "19:30 - 20:00",
            },
        ],
        imgUrl: "",
        url: "http://danielgoncalves.eu/",
    },
    {
        name: "DANIEL MCKEE",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "13:00 - 13:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DANNY HOWARD",
        events: [
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "01:45 - 02:55",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/dannyhowarddj",
    },
    {
        name: "DANNY PRICE PRESENTS THE RIOT SOCIETY",
        events: [
            {
                stage: "NOMAD",
                day: "THURSDAY",
                time: "15:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://novaramedia.com/",
    },
    {
        name: "DANNY WAV (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dannywav",
    },
    {
        name: "DANNY WAV (BLENDID TAKEOVER) 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dannywav",
    },
    {
        name: "DAPHNI",
        events: [
            {
                stage: "THE LEVELS",
                day: "SUNDAY",
                time: "01:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DARCEY HOPE",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "13:30 - 13:50",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SATURDAY",
                time: "12:00 - 12:20",
            },
        ],
        imgUrl: "",
        url: "http://hhtps//darceyhope.com",
    },
    {
        name: "DARIUS AKASHIC",
        events: [
            {
                stage: "IICON",
                day: "FRIDAY",
                time: "20:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/dariusakashic/",
    },
    {
        name: "DARIUS MAGIC",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "23:50 - 23:57",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "23:48 - 23:55",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "23:48 - 23:58",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "19:35 - 20:20",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "18:45 - 19:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:45 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.dadoshow.com/",
    },
    {
        name: "DARK MAVIS",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "02:00 - 02:45",
            },
        ],
        imgUrl: "",
        url: "https://babylonuprising.com/",
    },
    {
        name: "DARK MOON",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "22:00 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/thisdarkmoon/",
    },
    {
        name: "DAS BRASS",
        events: [
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "19:30 - 20:30",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DAVE CHAMELEON (COMPERE)",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "10:00 - 14:00",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "14:00 - 18:00",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "14:45 - 19:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DAVE GAMBLE",
        events: [
            {
                stage: "VILLAGE INN",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "TOLPUDDLE",
                day: "THURSDAY",
                time: "15:30 - 17:30",
            },
            {
                stage: "TOLPUDDLE",
                day: "FRIDAY",
                time: "17:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/davevgamble/",
    },
    {
        name: "DAVE HARVEY",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "SATURDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/daveharvey",
    },
    {
        name: "DAVE SEAMAN",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "20:05 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://djdaveseaman.com/",
    },
    {
        name: "DAVID CELIA",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DAVID CELIA & ZUFFALO",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "WEDNESDAY",
                time: "18:30 - 19:30",
            },
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "14:00 - 14:40",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "15:05 - 15:35",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "13:45 - 14:10",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DAVID ERIKSSON",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "21:17 - 21:27",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "22:47 - 22:57",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "20:51 - 21:01",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "22:42 - 22:52",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "21:03 - 21:13",
            },
        ],
        imgUrl: "",
        url: "https://wwwfacebook.com/baldwithballs",
    },
    {
        name: "DAYTIMERS ASKS - 'HOW CAN WE MOVE THE NEEDLE FORWARD TO ACTUAL INCLUSION'",
        events: [
            {
                stage: "THE INFORMATION",
                day: "SUNDAY",
                time: "12:00 - 12:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DAYTIMERS: FRESHTA, G33, NAD\u00cf, SUCHI, SURUSINGHE B2B",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "20:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/daytimers_uk/",
    },
    {
        name: "DEAD HORSE BAY",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "17:15 - 18:15",
            },
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "16:15 - 17:15",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DEAD IN BLOOM",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://on.soundcloud.com/gox5ewrw21xhgjhr8",
    },
    {
        name: "DEAD PAGES",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.deadpages.co.uk/",
    },
    {
        name: "DEAD REDS",
        events: [
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thedeadreds.com/",
    },
    {
        name: "DEADLETTER",
        events: [
            {
                stage: "LEFT FIELD",
                day: "FRIDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/deadlettertheband",
    },
    {
        name: "DEANNA RODGER",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "15:42 - 16:07",
            },
        ],
        imgUrl: "",
        url: "https://www.deannarodger.co.uk/",
    },
    {
        name: "DEBATES:  WOMAN, LIFE, FREEDOM: SOLIDARITY WITH IRAN:  WITH AGHILEH DJAFARI-MARBINI, NAZANIN ZAGHARI-RATCLIFFE, PARDIS SHAFAFI, SHAPPI KHORSANDI, HANAN ABDALLA",
        events: [
            {
                stage: "LEFT FIELD",
                day: "FRIDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DEBATES: CAN WE SAVE THE NHS? WITH MIGRANTS ORGANISE, WE OWN IT, DR SONIA ADESARA, DR ROSENA ALLIN-KHAN MP, MINNIE RAHMAN",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SATURDAY",
                time: "13:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DEBATES: ONE MINUTE TO MIDNIGHT: CAN POLITICS DELIVER ON CLIMATE ACTION? WITH AREEBA HAMID, ED MILIBAND MP, SEPI GOLZARI-MUNRO, NICK ANIM, JOHN HARRIS",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SATURDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DEBATES: POWER IN A UNION: A YEAR OF STRIKES AND SOLIDARITY WITH STRIKING NURSE, STRIKING TEACHER, PAT CULLEN (RCN), MIATTA FAHNBULLEH, JOHN HARRIS",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DEBATES: THIS LAND IS YOUR LAND: THE FIGHT FOR NATURE: WITH BLACK GIRLS HIKE, CLAIRE RATINON, RIGHT TO ROAM, SURFERS AGAINST SEWAGE, JOHN HARRIS",
        events: [
            {
                stage: "LEFT FIELD",
                day: "FRIDAY",
                time: "13:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DEBATES: TRUTH, JUSTICE AND CHANGE FOR GRENFELL? WITH BEREAVED AND SURVIVORS FROM GRENFELL UNITED, NIM RALPH",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SUNDAY",
                time: "13:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DEBBIE",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SUNDAY",
                time: "16:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://www.debbieofficial.com/",
    },
    {
        name: "DECADENT TIMES TAKEOVER (COMEDY, THEATRE AND CIRCUS )",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "12:00 - 12:40",
            },
        ],
        imgUrl: "",
        url: "https://www.decadenttimes.com/",
    },
    {
        name: "DECOLONIAL APPROACHES TO LAND AND FARMING - INTERACTIVE AND INTERDISCIPLINARY WORKSHOP LED BY NAOMI TERRY OF LION",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "15:45 - 17:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DECOLONISE YOUR SENSES - INFORMAL PANEL HOSTED BY SAM AND JAMILA OF LION WITH GUEST SPEAKERS EXPLORING INTERSECTIONALITY, LAND AND HOUSING JUSTICE IN URBAN SPACE, RECREATION, INCLUSIVE EVENTS VENUES AND REST AS A FORM OF RESISTANCE",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "12:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DEENA ABDELWAHED",
        events: [
            {
                stage: "IICON",
                day: "SUNDAY",
                time: "03:30 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/deenaabdelwahed",
    },
    {
        name: "DEFECTED PRESENTS: SAM DIVINE X MEL\u00c9 X MONKI",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "00:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DELE SOSIMI + MEDLAR LIVE",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "17:20 - 18:35",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/medlar_/",
    },
    {
        name: "DELE SOSIMI AFROBEAT ORCHESTRA",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "14:25 - 15:55",
            },
        ],
        imgUrl: "",
        url: "http://www.delesosimi.org/",
    },
    {
        name: "DELILAH BON",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SATURDAY",
                time: "17:30 - 18:15",
            },
        ],
        imgUrl: "",
        url: "https://www.delilahbon.co.uk/about",
    },
    {
        name: "DEMI RIQU\u00cdSMO",
        events: [
            {
                stage: "SAN REMO",
                day: "SUNDAY",
                time: "15:30 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/demi_riquisimo_/?hl=en",
    },
    {
        name: "DENIS SULTA",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
            {
                stage: "GLADE",
                day: "THURSDAY",
                time: "23:05 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/denissulta/",
    },
    {
        name: "DENNIS FERRER",
        events: [
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "20:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/dennisferrerobj/",
    },
    {
        name: "DEPTFORD NORTHERN SOUL CLUB",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "THURSDAY",
                time: "20:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://deptfordnorthernsoulclub.co.uk/",
    },
    {
        name: "DERMOT KENNEDY",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SUNDAY",
                time: "16:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.dermotkennedy.com/",
    },
    {
        name: "DEVIL'S PERFECT",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "20:50 - 21:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DEXTER SELBOY",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "18:20 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://dexterandtheshonk.bandcamp.com/",
    },
    {
        name: "DEYAZ",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "FRIDAY",
                time: "17:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DFS",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SATURDAY",
                time: "05:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/dancefloorsmashers",
    },
    {
        name: "DIANA DRILL",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "FRIDAY",
                time: "13:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dianadrill",
    },
    {
        name: "DIDDY SWEG",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "21:20 - 22:10",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/diddysweg/",
    },
    {
        name: "DIGGA D",
        events: [
            {
                stage: "WOODSIES",
                day: "FRIDAY",
                time: "15:15 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.diggad.co.uk/",
    },
    {
        name: "DIGITAL MYSTIKZ (MALA & COKI)",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "16:30 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DIMENSION",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "00:30 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DISC-O-LYPSO",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "THURSDAY",
                time: "23:45 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/discolypso",
    },
    {
        name: "DISCO FIT WITH MERLIN",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "THURSDAY",
                time: "15:30 - 16:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "FRIDAY",
                time: "15:30 - 16:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SATURDAY",
                time: "15:30 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://www.msmerlin.com/",
    },
    {
        name: "DISCO FREAKS",
        events: [
            {
                stage: "VILLAGE INN",
                day: "FRIDAY",
                time: "23:45 - 02:00",
            },
            {
                stage: "VILLAGE INN",
                day: "SATURDAY",
                time: "20:00 - 22:00",
            },
            {
                stage: "VILLAGE INN",
                day: "SUNDAY",
                time: "17:15 - 19:15",
            },
        ],
        imgUrl: "",
        url: "http://discofreaks.co.uk/",
    },
    {
        name: "DISCO ROBOT GIRLZ",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:05 - 16:50",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:15 - 13:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "18:45 - 19:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:30 - 17:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:45 - 19:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.pennitovey.com/",
    },
    {
        name: "DISCOVER YOUR INNER NEMATODE - AN IMAGINARY DINNER PARTY WITH THE CHARACTERS UNDERFOOT",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "WEDNESDAY",
                time: "16:45 - 17:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DISOBEDIENT BODIES",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SUNDAY",
                time: "09:30 - 10:30",
            },
        ],
        imgUrl: "",
        url: "https://www.bodybitsbrighton.com/",
    },
    {
        name: "DISOBEDIENT BODIES WITH LOU THOMAS",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "THURSDAY",
                time: "09:45 - 10:45",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "FRIDAY",
                time: "09:45 - 10:45",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SATURDAY",
                time: "09:45 - 10:45",
            },
        ],
        imgUrl: "",
        url: "https://www.bodybitsbrighton.com/",
    },
    {
        name: "DISZK\u00d3",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/diszko_/",
    },
    {
        name: "DIVINE INK: DROP-IN DIVINATION SESSION WITH IONE MARIE ROJAS. BRING A QUESTION AND SEE HOW THE INK RESPONDS",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "13:45 - 15:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DIZRAELI (DJ SET)",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.dizraeli.com/",
    },
    {
        name: "DIZRAELI (DJ SET) (BLENDID TAKEOVER) 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://dizraeli.com/",
    },
    {
        name: "DJ ABSOLUTELY SHIT",
        events: [
            {
                stage: "THE WOW",
                day: "THURSDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ AMMI B2B JAMURAI",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "THURSDAY",
                time: "00:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djammi__/",
    },
    {
        name: "DJ AND DANCING",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "22:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ ANDY CATO (GROOVE ARMADA)",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://music.apple.com/gb/artist/journey-man-dj/21485504",
    },
    {
        name: "DJ ANDY P",
        events: [
            {
                stage: "DELUXE DINER",
                day: "SATURDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ ARCHIE",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/djarchie",
    },
    {
        name: "DJ BABY SOUL",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "SATURDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ BASIL B",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://basilbrooks.com/",
    },
    {
        name: "DJ BEERWAX",
        events: [
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "21:15 - 00:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ BETTS",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "FRIDAY",
                time: "01:30 - 03:00",
            },
            {
                stage: "THE TAPHOUSE",
                day: "SUNDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dj_russell_betts/",
    },
    {
        name: "DJ BEYOND THE YELLOW",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ BILL BREWSTER",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/billbrewster/",
    },
    {
        name: "DJ BORING",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.djboring.com/",
    },
    {
        name: "DJ CHEWY SHE",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.chewyshe.com/",
    },
    {
        name: "DJ CODA",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ COUSCOUS",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/djcouscous/",
    },
    {
        name: "DJ DARIUS AKASHIC - CROOKED STYLUS",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/resoundradio2018/good-on-paper-darius-aka-the-crooked-stylus",
    },
    {
        name: "DJ DEPTFORD NORTHERN SOUL CLUB",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://deptfordnorthernsoulclub.co.uk/",
    },
    {
        name: "DJ DOUBLE L",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ DRAGONFLO B2B WITH DJ SOLARA",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/dragonflo",
    },
    {
        name: "DJ EARL RAFF & OLLY LUIZ",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "21:30 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ EGGS LEGS",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "SATURDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ ESTI",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "FRIDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/estherraffell/",
    },
    {
        name: "DJ FAYDZ",
        events: [
            {
                stage: "VILLAGE INN",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "TOLPUDDLE",
                day: "SUNDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.djfaydz.com/",
    },
    {
        name: "DJ FAYDZ (BLENDID TAKEOVER) 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "20:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.djfaydz.com/",
    },
    {
        name: "DJ FLIGHT",
        events: [
            {
                stage: "ARCADIA",
                day: "SUNDAY",
                time: "21:45 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://djflight.co.uk/",
    },
    {
        name: "DJ FRAU LUDWIG",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/people/frau-ludwig/",
    },
    {
        name: "DJ FRESHTA",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/_freshta",
    },
    {
        name: "DJ FUN SABA",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/funsaba/",
    },
    {
        name: "DJ GAZ",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ GREEN MAN (ALWAYS SUNNY IN PHILADELPHIA SET)",
        events: [
            {
                stage: "VILLAGE INN",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ GUILTY PLEASURES",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://guiltypleasures.co.uk/",
    },
    {
        name: "DJ HIPHOPPAPOTAMUS (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/djhiphoppapotamus/",
    },
    {
        name: "DJ HOMOLUDO",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "17:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/homoludo",
    },
    {
        name: "DJ HULBERT",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "THURSDAY",
                time: "01:30 - 03:00",
            },
            {
                stage: "THE TAPHOUSE",
                day: "SATURDAY",
                time: "21:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/james.hulbert.78",
    },
    {
        name: "DJ IONA",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "FRIDAY",
                time: "05:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/iona.t/",
    },
    {
        name: "DJ J1MI (BEYONDERS)",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "19:45 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/beyondersmusic/",
    },
    {
        name: "DJ JERRY SOBER SOBER & GUESTS (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://brokenslang.bandcamp.com/",
    },
    {
        name: "DJ KEV TUNGATT",
        events: [
            {
                stage: "VILLAGE INN",
                day: "SATURDAY",
                time: "18:00 - 20:00",
            },
            {
                stage: "TOLPUDDLE",
                day: "FRIDAY",
                time: "19:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "http://coolbeansproductions.co.uk/audio/",
    },
    {
        name: "DJ KOOKI - POSITIVE SOUND SYSTEM",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "18:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.flickr.com/photos/positivesoundsystem/albums",
    },
    {
        name: "DJ LOOCEE",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/lovely_stuff_by_loocee",
    },
    {
        name: "DJ LOUIE LOUIE",
        events: [
            {
                stage: "DELUXE DINER",
                day: "THURSDAY",
                time: "00:00 - 01:30",
            },
            {
                stage: "DELUXE DINER",
                day: "SATURDAY",
                time: "04:30 - 06:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ LOVE LIFE DISCO",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/lovelifedisco/",
    },
    {
        name: "DJ LUSINDA",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djlusinda/",
    },
    {
        name: "DJ MAJ DUCKWORTH",
        events: [
            {
                stage: "TOLPUDDLE",
                day: "SATURDAY",
                time: "17:30 - 19:30",
            },
            {
                stage: "TOLPUDDLE",
                day: "SUNDAY",
                time: "15:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.majduckworth.com/",
    },
    {
        name: "DJ MAJ DUCKWORTH - SAMPLE NATION (BLENDID TAKEOVER) 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.majduckworth.com/",
    },
    {
        name: "DJ MASDA",
        events: [
            {
                stage: "THE WOW",
                day: "FRIDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ MIKE WHITFIELD AKA FUNK & SOIL - BEATS OF SCIENCE BRUNCH",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "SATURDAY",
                time: "11:15 - 12:30",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SUNDAY",
                time: "11:15 - 12:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ MIKE WHITFIELD AKA FUNK AND SOIL - BEATS OF SCIENCE DJ SET",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "SATURDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://www.sciencefestival.co.uk/",
    },
    {
        name: "DJ MIKEY SNOOZE & FRIENDS",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "16:15 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/mikeysnooze/",
    },
    {
        name: "DJ MODIR",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "SUNDAY",
                time: "20:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djmodir/",
    },
    {
        name: "DJ MONNE",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "14:15 - 15:15",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "13:30 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/djmonne/",
    },
    {
        name: "DJ MOSSMAN",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ MR MASS",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "FRIDAY",
                time: "23:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ NEPTIZZLE",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "FRIDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djneptizzle/",
    },
    {
        name: "DJ NICKY NICKY",
        events: [
            {
                stage: "DELUXE DINER",
                day: "FRIDAY",
                time: "04:30 - 06:00",
            },
            {
                stage: "DELUXE DINER",
                day: "SATURDAY",
                time: "03:00 - 04:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ PAULETTE",
        events: [
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "01:00 - 02:30",
            },
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "19:00 - 20:30",
            },
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "15:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ POLLY",
        events: [
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "00:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ PRIYA",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/deejaypri",
    },
    {
        name: "DJ PRIYA (GOING SOUTH TAKEOVER )",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "22:00 - 22:30",
            },
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "20:45 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/deejaypri",
    },
    {
        name: "DJ PRODUCER",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SATURDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "http://www.soundcloud.com/the-dj-producer",
    },
    {
        name: "DJ Q B2B YUNG SINGH",
        events: [
            {
                stage: "ARCADIA",
                day: "SUNDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djqmusic/%20%20%20//%20%20%20%20https://www.instagram.com/yungsingh35ol",
    },
    {
        name: "DJ QUEEN KONG",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ ROSS WILSON",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/rosswilson_07/?hl=en",
    },
    {
        name: "DJ ROTATE 38",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/rotate38.ldn/",
    },
    {
        name: "DJ RUBY FLASHMAN",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "THURSDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ SADEEDO",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/sadeedo/",
    },
    {
        name: "DJ SIR FUNK",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://sirfunk.com/",
    },
    {
        name: "DJ SPAMALAM",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "14:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ SWEET SIR RENDER",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJ TAMBOI",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "FRIDAY",
                time: "03:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/tamboi__/",
    },
    {
        name: "DJ TARLOAK",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/tarloak",
    },
    {
        name: "DJ THE MENENDEZ BROTHERS",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/themenendezbros",
    },
    {
        name: "DJ THRILOGY",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "01:00 - 01:40",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/thrilogysound/",
    },
    {
        name: "DJ TOFU AND FRIENDS MORNING ECSTATIC",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "11:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://djchristofu.com/about/",
    },
    {
        name: "DJ VINCENT1000 & FRIENDS & YARD AERIALISTS",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "00:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "DJ WOODY COOK",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/woody_cook/",
    },
    {
        name: "DJ YODA (50TH ANNIVERSARY OF HIP HOP SET)",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "FRIDAY",
                time: "15:30 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJANGO CHUTNEY",
        events: [
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DJDAKILEI",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djdakilei/",
    },
    {
        name: "DNA PUPPET MAKING",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DNA THEATRE",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DO WHAT YA MAMA TOLD YA!",
        events: [
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "14:25 - 14:55",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "14:25 - 14:55",
            },
            {
                stage: "THE GLEBE",
                day: "SUNDAY",
                time: "14:25 - 14:55",
            },
        ],
        imgUrl: "",
        url: "https://www.justmoreproductions.com/",
    },
    {
        name: "DOCKSIDE LATIN ORCHESTRA",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "THURSDAY",
                time: "21:30 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://docksidelatin.co.uk/",
    },
    {
        name: "DODGY BOYS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:50 - 12:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:50 - 12:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:50 - 12:35",
            },
        ],
        imgUrl: "",
        url: "https://www.fairplaycomedy.com/",
    },
    {
        name: "DOG DAUGHTER",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "14:45 - 15:45",
            },
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "15:00 - 15:40",
            },
        ],
        imgUrl: "",
        url: "https://dogdaughter.bandcamp.com/",
    },
    {
        name: "DOGHOUSE DERELICTS",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "14:50 - 15:50",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/doghousederelicts",
    },
    {
        name: "DOGS/THE SONG CYCLE",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "16:30 - 17:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SUNDAY",
                time: "14:00 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://nickkelly.ie/",
    },
    {
        name: "DOLLY DELICIOUS",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "22:45 - 22:50",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/seeyouatmimis",
    },
    {
        name: "DOM JOLY",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "THURSDAY",
                time: "19:15 - 20:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DOMBRANCE",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "01:40 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dombrance/",
    },
    {
        name: "DOMBRANCE - LIVE",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "THURSDAY",
                time: "22:30 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/dombrance",
    },
    {
        name: "DON LETTS",
        events: [
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "18:45 - 19:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/officialdonletts",
    },
    {
        name: "DOPE AMMO B2B DJ HYBRID FT. JASMINE KNIGHT",
        events: [
            {
                stage: "THE TEMPLE",
                day: "THURSDAY",
                time: "00:15 - 01:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dopeammo/%20/%20https://djhybrid.co.uk/",
    },
    {
        name: "DOREEN DOREEN",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "01:20 - 02:20",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "01:20 - 02:20",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "23:45 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.doreendoreen.co.uk/",
    },
    {
        name: "DOWNSETTERS",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "SUNDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/thedownsetters/?locale=en_gb",
    },
    {
        name: "DR BANANA",
        events: [
            {
                stage: "FLYING BUS",
                day: "SATURDAY",
                time: "01:30 - 02:30",
            },
            {
                stage: "ARCADIA",
                day: "SATURDAY",
                time: "21:30 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/drbananana",
    },
    {
        name: "DR BANANA X LUKAS WIGFLEX",
        events: [
            {
                stage: "THE WOW",
                day: "THURSDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DR JANINA RAMIREZ",
        events: [
            {
                stage: "FREE UNIVERSITY OF GLASTONBURY",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.janinaramirez.co.uk/",
    },
    {
        name: "DR TAMSIN EDWARDS",
        events: [
            {
                stage: "FREE UNIVERSITY OF GLASTONBURY",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/flimsin?lang=en",
    },
    {
        name: "DRAG SYNDROME",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "02:30 - 03:00",
            },
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "01:00 - 01:30",
            },
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "23:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.dragsyndrome.com/",
    },
    {
        name: "DRAGIATORS",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "14:00 - 14:40",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "13:00 - 13:40",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SUNDAY",
                time: "13:00 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dragiators",
    },
    {
        name: "DRAGPROV SHOW",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "22:00 - 22:40",
            },
        ],
        imgUrl: "",
        url: "https://www.dolly-delicious.co.uk/",
    },
    {
        name: "DREA CHUMA",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "14:18 - 14:43",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "15:23 - 15:48",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DREADZONE",
        events: [
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "17:40 - 18:45",
            },
        ],
        imgUrl: "",
        url: "https://www.dreadzone.com/",
    },
    {
        name: "DREAMING OF REPARATIVE FUTURES - INTERACTIVE TALK WITH THE LAND IN OUR NAMES (LION) COLLECTIVE",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DREAMWAVE",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "20:30 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/dreamwaveband",
    },
    {
        name: "DRIFTY",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "23:30 - 00:00",
            },
            {
                stage: "PLATFORM 23",
                day: "SUNDAY",
                time: "02:30 - 03:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/driftygram/",
    },
    {
        name: "DRIFTY AND FRIENDS",
        events: [
            {
                stage: "NOMAD",
                day: "THURSDAY",
                time: "20:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DRUM THUNDER FUNK PARTY",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "SUNDAY",
                time: "00:45 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/gillanthegillan/",
    },
    {
        name: "DRY WHITE BONES",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "THURSDAY",
                time: "20:30 - 21:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://facebook.com/drywhitebones",
    },
    {
        name: "DR\u00c9YA MAC",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SATURDAY",
                time: "21:20 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/dreyamac/",
    },
    {
        name: "DUB BOY & ATKI2",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/tim_dub_boy/%20https://www.instagram.com/sam_atki2/",
    },
    {
        name: "DUBKASM",
        events: [
            {
                stage: "ARCADIA",
                day: "SUNDAY",
                time: "20:15 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/dubkasm",
    },
    {
        name: "DUNCAN DISORDERLY & THE SCALLYWAGS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "00:30 - 01:30",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "01:00 - 02:30",
            },
            {
                stage: "BIMBLE INN",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/scallywaggin/",
    },
    {
        name: "DUNGEON MEAT",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "SATURDAY",
                time: "03:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/dungeonmeat",
    },
    {
        name: "DUO",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://duoguitarmusic.com/",
    },
    {
        name: "DUSK ART RHYTHM QUARTET",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "DUTCHIE",
        events: [
            {
                stage: "THE BUG",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dutchiebristol/",
    },
    {
        name: "DUTCHIE FT DR SYNTAX",
        events: [
            {
                stage: "NOWHERE",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dutchiebristol/%20%20%20%20%20%20%20%20%20https://www.instagram.com/drsyntaxraps/",
    },
    {
        name: "DUTTY MOONSHINE BIG BAND",
        events: [
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "21:45 - 22:45",
            },
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.duttymoonshine.com/",
    },
    {
        name: "DYLAN",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "FRIDAY",
                time: "20:00 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://www.iamdylanofficial.com/",
    },
    {
        name: "E.T. U",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "THURSDAY",
                time: "13:00 - 14:55",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt0083866/",
    },
    {
        name: "EARL RAFF (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/earlraff",
    },
    {
        name: "EARL SWEATSHIRT",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "EATS EVERYTHING (D&B SET)",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "EATS EVERYTHING (HISTORY OF RAVE SET)",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "EATS EVERYTHING B2B PETE TONG B2B DENNIS FERRER",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "EAVES WILDER",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SATURDAY",
                time: "14:00 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://eaveswilder.com/",
    },
    {
        name: "EC2A TAKEOVER: DR DUBPLATE, LCY, MIA KODEN, SKREAM, \n,SURUSINGHE, TA\u00d1 B2B DJ COSWORTH",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "SATURDAY",
                time: "18:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ECMSTU",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "11:00 - 12:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ECOLI",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SATURDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://open.spotify.com/artist/2mpy1k969lurkehrzb5ljy?si=p3ti7_yqsfuef_i3x58gaw",
    },
    {
        name: "ED ELDRIDGE",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "18:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/edeldridge",
    },
    {
        name: "ED MILIBAND, KEVIN ANDERSON & MOLLY SCOTT CATO",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "http://politics%20%26%20climate%20science/",
    },
    {
        name: "ED MILLIBAND MP",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "http://ed%20miliband%20mp%20with%20justin%20rowlatt/",
    },
    {
        name: "ED PETRIE (COMPERE)",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "22:00 - 02:00",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "18:00 - 22:00",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "10:15 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://www.edpetrie.com/",
    },
    {
        name: "EDITORS",
        events: [
            {
                stage: "WOODSIES",
                day: "SUNDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.editors-official.com/",
    },
    {
        name: "EFFY",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "THE TEMPLE",
                day: "FRIDAY",
                time: "00:45 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/its_effyy/",
    },
    {
        name: "EFFY FT FLOWDAN",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://effy%20(@its_effyy%29%20%7C%20instagram/",
    },
    {
        name: "EL TEL",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "20:30 - 21:10",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/eltelmusic23",
    },
    {
        name: "ELEANOR DILLON-REAMS",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "16:10 - 16:35",
            },
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "14:30 - 14:55",
            },
        ],
        imgUrl: "",
        url: "https://www.elledillonreams.com/",
    },
    {
        name: "ELI BROWN",
        events: [
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ELIAS MAZIAN",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "19:30 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/eliasmazian/?hl=en",
    },
    {
        name: "ELIJAH + SKILLIAM",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ELIZA LEGZDINA",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "17:00 - 17:45",
            },
            {
                stage: "NOMAD",
                day: "SUNDAY",
                time: "00:00 - 00:45",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/watch?v=ojt8yqf0wzs&feature=youtu.be",
    },
    {
        name: "ELIZA ROSE",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "THURSDAY",
                time: "18:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ELIZA ROSE B2B DAN SHAKE B2B SALLY C",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "FRIDAY",
                time: "18:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/sallyc%20https://danshake.com/%20https://ra.co/dj/elizarose",
    },
    {
        name: "ELKKA",
        events: [
            {
                stage: "ARCADIA",
                day: "FRIDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/elkkamusic/",
    },
    {
        name: "ELLA KNIGHT: SUPPER CLUB TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/ellaknight__/",
    },
    {
        name: "ELLIE DIXON",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SATURDAY",
                time: "15:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.elliedixonmusic.com/",
    },
    {
        name: "ELLIE PROHAN",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "THURSDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/ellieprohan/",
    },
    {
        name: "ELMIENE",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/elmiene/",
    },
    {
        name: "ELOISE CURRIE & ISHITA RAINA",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "15:57 - 16:07",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "13:34 - 13:44",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "16:22 - 16:32",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "13:40 - 13:50",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "15:24 - 15:34",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "13:14 - 13:24",
            },
        ],
        imgUrl: "",
        url: "https://www.aerialdancer.net/",
    },
    {
        name: "ELTON JOHN",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SUNDAY",
                time: "21:00 - 23:05",
            },
        ],
        imgUrl: "",
        url: "https://www.eltonjohn.com/",
    },
    {
        name: "ELVANA",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SUNDAY",
                time: "15:20 - 16:20",
            },
        ],
        imgUrl: "",
        url: "https://www.elvana.co.uk/",
    },
    {
        name: "ELV\u00c9",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/michael_elve/",
    },
    {
        name: "EMERALD",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "http://emerald%20(@emeraldroselewis%29%20%7C%20instagram/",
    },
    {
        name: "EMERGENCY EXIT ARTS",
        events: [
            {
                stage: "GLEBELAND",
                day: "THURSDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "21:30 - 23:00",
            },
            {
                stage: "GLEBELAND",
                day: "SATURDAY",
                time: "21:30 - 23:00",
            },
            {
                stage: "GLEBELAND",
                day: "SUNDAY",
                time: "21:30 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.eea.org.uk/",
    },
    {
        name: "EMILY DUST",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/emily_dust/",
    },
    {
        name: "EMILY DUST (BAILE LDN)",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SUNDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/emily_dust/",
    },
    {
        name: "EMILY JENNINGS",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://youtu.be/aghos-zobae",
    },
    {
        name: "EMMA KORANTEMA: VILLAGE CUTS TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/emmakorantema/",
    },
    {
        name: "EMMA WARREN WITH ANNA WOOD",
        events: [
            {
                stage: "FREE UNIVERSITY OF GLASTONBURY",
                day: "SATURDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "http://emmawarren.squarespace.com/",
    },
    {
        name: "EMMANUEL SONUBI",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "17:35 - 18:05",
            },
        ],
        imgUrl: "",
        url: "https://www.emmanuelstandup.com/",
    },
    {
        name: "EMMANUEL SONUBI (COMPERE)",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "22:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.emmanuelstandup.com/",
    },
    {
        name: "EMMY",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "THURSDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/itsdjemmy/",
    },
    {
        name: "EMPIRE STATE BASTARDS (EARACHE RECORDS TAKEOVER)",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "01:30 - 02:15",
            },
        ],
        imgUrl: "",
        url: "https://empirestatebastard.com/",
    },
    {
        name: "ENGLISH DISCO LOVERS",
        events: [
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "14:10 - 16:10",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/engdiscolovers/",
    },
    {
        name: "ENJOYABLE LISTENS",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "14:10 - 14:40",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "21:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/enjoyablelistens/?hl=en",
    },
    {
        name: "ENTITLED SONS",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "16:00 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/theentitledsons/",
    },
    {
        name: "ENVELOPE",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "17:00 - 17:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ENZO SIRAGUSA",
        events: [
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "21:30 - 22:50",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/enzosiragusa/?hl=en",
    },
    {
        name: "ENZO SIRAGUSA (JUNGLE SET)",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "19:00 - 20:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "EPIC STORY QUEST",
        events: [
            {
                stage: "THE GATEWAY",
                day: "SUNDAY",
                time: "13:45 - 14:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ERIKA DE CASIER",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "16:15 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ESCALATION./",
        events: [
            {
                stage: "VILLAGE INN",
                day: "THURSDAY",
                time: "14:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/escalationldn/",
    },
    {
        name: "EUAN FRYER (ATHENS OF THE NORTH)",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/euan_fryer_aotn/?hl=en",
    },
    {
        name: "EUPHONIQUE",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "THURSDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "http://www.djeuphonique.com/",
    },
    {
        name: "EVA",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "17:05 - 17:50",
            },
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "14:30 - 15:30",
            },
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "12:00 - 12:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "EVA SCOTT",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "17:30 - 18:30",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "13:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/user-478746957",
    },
    {
        name: "EVERYTHING WILL BE AMAZING",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SUNDAY",
                time: "10:30 - 11:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/urbanavatars/",
    },
    {
        name: "EVERYTHING WILL BE AMAZING! WITH FELIX PRICE, DJ BALCONY & LORNA BEE",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "THURSDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "FRIDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SATURDAY",
                time: "12:15 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/urbanavatars/",
    },
    {
        name: "EWAN  MCVICAR",
        events: [
            {
                stage: "GLADE",
                day: "THURSDAY",
                time: "22:05 - 23:05",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/ewanmcvicar_",
    },
    {
        name: "EWAN MCVICAR B2B KETTAMA",
        events: [
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "19:30 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "EXAMPLE",
        events: [
            {
                stage: "GLADE",
                day: "THURSDAY",
                time: "19:00 - 19:55",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/leadingbyexample",
    },
    {
        name: "EXTRA MEDIUM FT DOPPLER",
        events: [
            {
                stage: "THE BUG",
                day: "SATURDAY",
                time: "18:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/extramediumuk/?hl=en",
    },
    {
        name: "EZRA COLLECTIVE",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "WEST HOLTS STAGE",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://ezracollective.com/",
    },
    {
        name: "EZRA WILLIAMS",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "18:00 - 18:40",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "16:00 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://ezrawilliamsmusic.com/",
    },
    {
        name: "FAFF",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FAIL FAIL FAIL FAIL WIN",
        events: [
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "15:00 - 15:30",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "17:15 - 17:45",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "16:40 - 17:10",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SUNDAY",
                time: "13:45 - 14:15",
            },
        ],
        imgUrl: "",
        url: "https://www.failfailfailfailwin.com/",
    },
    {
        name: "FAIL FAIL FAIL WIN",
        events: [
            {
                stage: "THE GLEBE",
                day: "SUNDAY",
                time: "12:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.failfailfailfailwin.com/",
    },
    {
        name: "FAIRLY FAMOUS FAMILY",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:05 - 17:50",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:10 - 16:55",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:10 - 12:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:40 - 17:25",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:10 - 16:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:10 - 12:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:10 - 16:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:10 - 12:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FAIRLY FRESH FISH",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "12:45 - 13:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.fairplaycomedy.com/",
    },
    {
        name: "FAIRLY FRESH FISH CO",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.fairplaycomedy.com/",
    },
    {
        name: "FAITHLESS (DJ SET)",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "23:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FAITHLESS DJ SET",
        events: [
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "00:35 - 01:45",
            },
        ],
        imgUrl: "",
        url: "https://faithless.co.uk/",
    },
    {
        name: "FAMILY JOOLS",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "11:35 - 12:05",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "SATURDAY",
                time: "17:00 - 17:30",
            },
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "13:00 - 13:40",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/familyjoolsband",
    },
    {
        name: "FAMOS BRAMWELLS (COMPERE)",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "11:30 - 16:15",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "16:15 - 21:00",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "11:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FANFARIA EL CAPITAN",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.lafanfarriadelcapitan.com/",
    },
    {
        name: "FANNY LUMSDEN",
        events: [
            {
                stage: "AVALON STAGE",
                day: "FRIDAY",
                time: "14:15 - 15:05",
            },
        ],
        imgUrl: "",
        url: "https://www.fannylumsden.net/",
    },
    {
        name: "FAR FROM SAINTS",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SUNDAY",
                time: "18:20 - 19:20",
            },
        ],
        imgUrl: "",
        url: "https://farfromsaintsband.com/",
    },
    {
        name: "FAREWELL PARTY - DJ CHRIS TOFU & FRIENDS - K.O.G, DRAG SYNDROME, NEW YORK BRASS BAND, AND MANY MORE!",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://continentaldrifts.co.uk/artist/chris-tofu/",
    },
    {
        name: "FATBOY SLIM",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SATURDAY",
                time: "23:00 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://www.fatboyslim.net/",
    },
    {
        name: "FBR",
        events: [
            {
                stage: "VILLAGE INN",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
            {
                stage: "TOLPUDDLE",
                day: "THURSDAY",
                time: "22:30 - 23:30",
            },
            {
                stage: "TOLPUDDLE",
                day: "SATURDAY",
                time: "15:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/fbrsound",
    },
    {
        name: "FEEDING THE FISH",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "21:32 - 21:42",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "01:01 - 01:09",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "01:01 - 01:09",
            },
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "00:05 - 00:15",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "23:25 - 23:35",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "THURSDAY",
                time: "22:20 - 22:28",
            },
        ],
        imgUrl: "",
        url: "https://www.feedingthefish.com/",
    },
    {
        name: "FELA PARTY!",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "00:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FELIX DICKINSON",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "FRIDAY",
                time: "23:30 - 02:00",
            },
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SUNDAY",
                time: "03:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/felixdickinson",
    },
    {
        name: "FELIX JOY (SWUFM)",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/felixjoy/?hl=en",
    },
    {
        name: "FERAL IS KINKY B2B DAN DONOVAN",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "22:00 - 23:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/feraliskinky",
    },
    {
        name: "FEVER RAY",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "FRIDAY",
                time: "23:00 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://feverray.com/",
    },
    {
        name: "FFSYTHO?",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "12:30 - 12:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FFTP (LIVE)",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/futurefromthepast",
    },
    {
        name: "FIERY JACK FAMILY",
        events: [
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "18:25 - 18:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FIERY JACK FAMILY SHOW",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "16:15 - 16:45",
            },
        ],
        imgUrl: "",
        url: "https://coventgardenentertainment.co.uk/performers/akira-street-performer",
    },
    {
        name: "FILM: DELIKADO (2022) - THE STRUGGLE OF LAND DEFENDERS IN THE PHILLIPINES AS THEY TRY TO SAVE NATURAL RESOURCES FROM BEING PLUNDERED BY CORPORATIONS AND GOVERNMENT. DIR. KARL MALAKUNAS",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "19:00 - 20:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FILM: HARVEST (2020) - THE STRUGGLE OF A SPLINTERED FAMILY LIVING OFF THE WET RICE FIELDS OF NORTHERN VIETNAM. DIR. HARVEY BUNEGAR",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "19:00 - 20:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FILM: LONDON GROWS (2022) - NINE STORIES OF NATURE IN THE CITY DIRECTED BY CRISTINA MONTEIRO",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SUNDAY",
                time: "18:00 - 19:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FILMS: CATALOGUE AVAILABLE",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "THURSDAY",
                time: "11:00 - 12:30",
            },
            {
                stage: "ATCHIN TAN",
                day: "FRIDAY",
                time: "11:00 - 12:30",
            },
            {
                stage: "ATCHIN TAN",
                day: "SATURDAY",
                time: "11:00 - 12:30",
            },
            {
                stage: "ATCHIN TAN",
                day: "SUNDAY",
                time: "11:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FINN FOXELL",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "15:15 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FIRE AND WATER CEREMONY WITH THE WISDOM KEEPERS",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "FRIDAY",
                time: "14:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FIROUZEH",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "19:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FISHERMAN'S FRIENDS",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SATURDAY",
                time: "17:05 - 18:05",
            },
        ],
        imgUrl: "",
        url: "https://thefishermansfriends.com/",
    },
    {
        name: "FIYAHDRED",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FIZZY GILLESPIE",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "23:15 - 23:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FIZZY GILLESPIE (SWING & BASS)",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "02:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/djfizzygillespie/?locale=en_gb",
    },
    {
        name: "FLASH BANG BRASS",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "THURSDAY",
                time: "20:25 - 21:10",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "00:30 - 01:15",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "00:30 - 01:15",
            },
        ],
        imgUrl: "",
        url: "https://flashbangbrass.com/",
    },
    {
        name: "FLAVA D",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "15:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FLAVA D AND CARASEL",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "http://flava%20d%20(@xn--flava_d%29%20%20instagram%20photos%20and%20videos-7s44a/",
    },
    {
        name: "FLEA CIRCUS",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "16:30 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FLEETMAC WOOD",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "21:15 - 22:15",
            },
            {
                stage: "STONEBRIDGE BAR",
                day: "FRIDAY",
                time: "14:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FLISS MAYO B2B DR DUBPLATE",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/flissmayo/?hl=en.%20https://www.instagram.com/dr_dubplate/?hl=en",
    },
    {
        name: "FLISS PREMRU, ROWAN MATARAM & ASSAD REHMAN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SATURDAY",
                time: "10:00 - 11:00",
            },
        ],
        imgUrl: "",
        url: "http://just%20transitions%20trade%20unions/",
    },
    {
        name: "FLO",
        events: [
            {
                stage: "WOODSIES",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://www.flolikethis.com/",
    },
    {
        name: "FLO & JOAN",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "15:15 - 15:45",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "18:15 - 18:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FLO DILL",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "14:00 - 15:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/flollid/?hl=en",
    },
    {
        name: "FLOATING POINTS B2B DAPHNI",
        events: [
            {
                stage: "ARCADIA",
                day: "FRIDAY",
                time: "00:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/daphni%20//%20https://floatingpoints.co.uk/",
    },
    {
        name: "FLOHIO",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SATURDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://www.flohio.uk/",
    },
    {
        name: "FLOWDAN LIVE",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "22:00 - 22:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FLUFF",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "18:30 - 19:15",
            },
        ],
        imgUrl: "",
        url: "https://fluffband.com/",
    },
    {
        name: "FLYING MOJITO BROTHERS B2B NONE MORE RECORDS",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "http://flyingmojitobros.com/",
    },
    {
        name: "FLYING SEAGULL PROJECT",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FOLAMOUR",
        events: [
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "18:00 - 19:30",
            },
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "03:00 - 04:30",
            },
        ],
        imgUrl: "",
        url: "http://folamour%20(@folamour_fhuo%29%20%7C%20instagram/",
    },
    {
        name: "FOLD",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SATURDAY",
                time: "20:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/fold",
    },
    {
        name: "FONZIE",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FONZO B2B A\u00c6E",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/fon.zo/.%20https://www.instagram.com/doubleadoublee/",
    },
    {
        name: "FOOOLS CYCLE",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "18:30 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "FOREST FAIRY FRIENDS",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FOUNDATION FM PRESENTS FRESHTA + SAINT LUDO B2B EMMA KORANTEMA",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "19:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FOUR TET",
        events: [
            {
                stage: "IICON",
                day: "FRIDAY",
                time: "23:45 - 01:45",
            },
        ],
        imgUrl: "",
        url: "https://www.fourtet.net/",
    },
    {
        name: "FRANC MOODY",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "20:15 - 21:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FRANCES FOLEY",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "WEDNESDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://progressive%20alliances%20%26%20climate/",
    },
    {
        name: "FRANK GANE",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/frank-gane/dj-kbs-classic-reggae-mix/?fbclid=iwar2p-8he0zww2wgclvcw8_rd7de8tmoiyg7hpko5rvrnhvxm4djf55t0qhw",
    },
    {
        name: "FRANK SANAZI",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "00:20 - 00:50",
            },
        ],
        imgUrl: "",
        url: "https://franksanazi.com/",
    },
    {
        name: "FRANKIE FRANCIS",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "THURSDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FRANKIE MORROW",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SUNDAY",
                time: "16:35 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/frankiemorrowmusic",
    },
    {
        name: "FRANTIC ANTICS",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FREAKENSTEIN",
        events: [
            {
                stage: "IICON",
                day: "SUNDAY",
                time: "02:00 - 03:30",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/freakenstein",
    },
    {
        name: "FRED AGAIN..",
        events: [
            {
                stage: "OTHER STAGE",
                day: "FRIDAY",
                time: "20:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.fredagain.com/",
    },
    {
        name: "FREDDIE AND THE FREELOADERS",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "22:50 - 00:20",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "SUNDAY",
                time: "23:15 - 00:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/freddie3loadr/?hl=en",
    },
    {
        name: "FREYA MALLARD",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "20:15 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/freyamallard",
    },
    {
        name: "FREYA RIDINGS",
        events: [
            {
                stage: "AVALON STAGE",
                day: "FRIDAY",
                time: "21:35 - 22:35",
            },
        ],
        imgUrl: "",
        url: "https://freyaridings.com/",
    },
    {
        name: "FROM GRASSROOTS CLUBS TO INTERNATIONAL TEAMS -\n'HOW WOMEN'S FOOTBALL & SOCIETY HAS CHANGED SINCE THE EUROS'",
        events: [
            {
                stage: "THE INFORMATION",
                day: "SATURDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FRUIT CUP",
        events: [
            {
                stage: "TOLPUDDLE",
                day: "THURSDAY",
                time: "17:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/georgeserviice/",
    },
    {
        name: "FUNGI AND SOIL BIOSONIFICATION - HELP US CREATE AUDIO SAMPLES FOR THE RHIZOSPHERE",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "WEDNESDAY",
                time: "15:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FUNGI: MEET, GREET AND EAT - TALK AND MYCO FEAST WITH RIGHTS FOR WEEDS",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "WEDNESDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "15:15 - 16:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "FUNKADOOMIC SARCOPHAGUS",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://youtu.be/mp4mhjguwfc",
    },
    {
        name: "FUNKE AND THE TWO TONE BABY",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "18:30 - 19:30",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://funkeandthetwotonebaby.co.uk/",
    },
    {
        name: "FUSE LONDON TAKEOVER - ENZO SIRAGUSA B2B RICH NXT",
        events: [
            {
                stage: "FLYING BUS",
                day: "FRIDAY",
                time: "01:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/richnxt",
    },
    {
        name: "FUSE LONDON TAKEOVER - FELON 5",
        events: [
            {
                stage: "FLYING BUS",
                day: "FRIDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/felon5",
    },
    {
        name: "FUSE LONDON TAKEOVER - GENE ON EARTH",
        events: [
            {
                stage: "FLYING BUS",
                day: "FRIDAY",
                time: "23:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/geneonearth",
    },
    {
        name: "FUSE LONDON TAKEOVER - LAIDLAW B2B TRISTAN",
        events: [
            {
                stage: "FLYING BUS",
                day: "FRIDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/laidlaw-uk",
    },
    {
        name: "FUSE WORKSHOPS",
        events: [
            {
                stage: "JUGGLING TENT",
                day: "FRIDAY",
                time: "15:00 - 18:00",
            },
            {
                stage: "JUGGLING TENT",
                day: "SATURDAY",
                time: "15:00 - 18:00",
            },
            {
                stage: "JUGGLING TENT",
                day: "SUNDAY",
                time: "15:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.fuse.org.uk/",
    },
    {
        name: "FUTURE SHAPE OF SOUND",
        events: [
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/thefutureshapeofsound/",
    },
    {
        name: "FUTURE UTOPIA (AFTER DARK)",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "20:00 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/frasertsmith",
    },
    {
        name: "FUTURE UTOPIA X AVELINO X TOMORROW'S WARRIORS",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SATURDAY",
                time: "16:35 - 16:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "G CLASS BTB RJD",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GABBY GUNN",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djgabbygunn/",
    },
    {
        name: "GABRIEL TEMPLAR",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "12:00 - 12:55",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "16:00 - 16:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GABRIELLE APLIN",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SATURDAY",
                time: "13:30 - 14:30",
            },
            {
                stage: "AVALON STAGE",
                day: "SATURDAY",
                time: "18:35 - 19:35",
            },
        ],
        imgUrl: "",
        url: "https://www.gabrielleaplin.com/",
    },
    {
        name: "GABRIELS",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "FRIDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/__gabriels__/?hl=en",
    },
    {
        name: "GABY KETTLE",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "13:00 - 13:20",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SATURDAY",
                time: "13:00 - 13:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GANZO",
        events: [
            {
                stage: "TOLPUDDLE",
                day: "SUNDAY",
                time: "19:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/sebastagram/",
    },
    {
        name: "GARDNA",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "FRIDAY",
                time: "15:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://gardnamusic.bandcamp.com/",
    },
    {
        name: "GARDNA & FRIENDS - ESK",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GARDNA & FRIENDS - GARDNA & KREED",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/gardna",
    },
    {
        name: "GARDNA & FRIENDS - JEREMIAH ASIAMAH",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.bbc.co.uk/programmes/m0005h4r",
    },
    {
        name: "GARDNA & FRIENDS - LENS",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/lens_dnb",
    },
    {
        name: "GARDNA & FRIENDS - MY NU LENG BTB PJ BRIDGER FT DREAD MC",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://mynuleng.com/",
    },
    {
        name: "GARDNA & FRIENDS - SAM SUPPLIER",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/samsupplier",
    },
    {
        name: "GARDNA & FRIENDS - SARAH STORY",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.bbc.co.uk/programmes/m000zc82",
    },
    {
        name: "GARDNA & FRIENDS - UNGLUED",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "05:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/unglueddnb",
    },
    {
        name: "GARDNA (LIVE)",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "16:45 - 17:45",
            },
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "00:15 - 01:00",
            },
        ],
        imgUrl: "",
        url: "http://gardna%20(@gardnauk%29%20%7C%20instagram/",
    },
    {
        name: "GARETH JONES",
        events: [
            {
                stage: "THE PAVEMENT",
                day: "WEDNESDAY",
                time: "14:00 - 14:30",
            },
            {
                stage: "THE PAVEMENT",
                day: "THURSDAY",
                time: "16:05 - 16:35",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "17:50 - 18:20",
            },
            {
                stage: "THE PAVEMENT",
                day: "SUNDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "THE GATEWAY",
                day: "THURSDAY",
                time: "12:35 - 13:05",
            },
        ],
        imgUrl: "",
        url: "http://nil/",
    },
    {
        name: "GARETH JONES (COMPERE)",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "16:15 - 21:00",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "11:30 - 16:15",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "16:00 - 21:09",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GAUDI",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.gaudimusic.com/",
    },
    {
        name: "GAVIN JAMES",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/gavinjameslive%C2%A0",
    },
    {
        name: "GAZ BROOKFIELD",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SUNDAY",
                time: "14:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://gazbrookfield.com/",
    },
    {
        name: "GECKO",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "15:45 - 16:30",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "12:00 - 12:45",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "THURSDAY",
                time: "22:20 - 22:45",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "18:30 - 18:45",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "18:30 - 18:45",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "17:40 - 17:55",
            },
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "11:30 - 11:55",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "11:30 - 12:00",
            },
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "11:30 - 11:55",
            },
        ],
        imgUrl: "",
        url: "https://geckoofficial.com/",
    },
    {
        name: "GEDZ (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "00:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/gedzdnb",
    },
    {
        name: "GEMMA ROGERS",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "21:00 - 21:30",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "13:30 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.gemmarogersmusic.com/",
    },
    {
        name: "GENERATION SEX",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SATURDAY",
                time: "15:45 - 16:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/generationsex/",
    },
    {
        name: "GENTLEMAN'S DUB CLUB FEAT HOLLIE COOK",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "02:45 - 03:30",
            },
        ],
        imgUrl: "",
        url: "https://gentlemansdubclub.com/https://linktr.ee/holliecookie",
    },
    {
        name: "GEORGE EGG'S 'SET MENU'",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "13:40 - 14:40",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "13:40 - 14:40",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "13:40 - 14:40",
            },
        ],
        imgUrl: "",
        url: "http://georgeegg.com/",
    },
    {
        name: "GEORGE ORANGE",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "13:35 - 14:05",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "16:54 - 17:24",
            },
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "19:35 - 20:05",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SUNDAY",
                time: "12:35 - 13:05",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GEORGIA D'ARCY RODEN",
        events: [
            {
                stage: "CROONER'S CORNER",
                day: "WEDNESDAY",
                time: "17:45 - 18:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "WEDNESDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "CROONER'S CORNER",
                day: "THURSDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "CROONER'S CORNER",
                day: "FRIDAY",
                time: "11:00 - 11:45",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SATURDAY",
                time: "14:30 - 15:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SUNDAY",
                time: "14:45 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/georgiadarcyroden10",
    },
    {
        name: "GEORGIE ELIZA",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "14:00 - 14:20",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SATURDAY",
                time: "12:30 - 12:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GERD JANSON",
        events: [
            {
                stage: "SAN REMO",
                day: "SUNDAY",
                time: "20:30 - 22:00",
            },
            {
                stage: "THE LEVELS",
                day: "SUNDAY",
                time: "18:30 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GET ON TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "13:30 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/getonfestival/",
    },
    {
        name: "GIANT SEAGULLS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "15:15 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "12:30 - 13:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:15 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:30 - 13:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:15 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:30 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://bigrory.com/",
    },
    {
        name: "GIDE\u00d6N",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SATURDAY",
                time: "02:30 - 04:25",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/gideon-uk",
    },
    {
        name: "GILBERT O'SULLIVAN",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "http://www.gilbertosullivan.co.uk/",
    },
    {
        name: "GINA BREEZE",
        events: [
            {
                stage: "SAN REMO",
                day: "SUNDAY",
                time: "14:00 - 15:30",
            },
            {
                stage: "THE MEAT RACK",
                day: "SATURDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "http://ginabreeze.com/",
    },
    {
        name: "GIRLS DON'T SYNC",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "21:30 - 23:00",
            },
            {
                stage: "GLADE",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/girlsdontsync/?hl=en",
    },
    {
        name: "GLASTONBURY FESTIVAL POETRY SLAM",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "17:25 - 19:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GLEN HANSARD",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://glenhansard.com/",
    },
    {
        name: "GLENN TILBROOK AND BEAUTIFUL LANDING",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.glenntilbrook.com/",
    },
    {
        name: "GLITTERBOX TAKEOVER: EATS EVERYTHING B2B ANDY CATO (GROOVE ARMADA)",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "22:30 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://glitterboxibiza.com/",
    },
    {
        name: "GLITTERBOX TAKEOVER: FAT TONY",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "00:30 - 01:15",
            },
        ],
        imgUrl: "",
        url: "https://glitterboxibiza.com/",
    },
    {
        name: "GLITTERBOX TAKEOVER: GINA BREEZE",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "23:45 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://glitterboxibiza.com/",
    },
    {
        name: "GLITTERBOX TAKEOVER: GIRLS OF THE INTERNET LIVE",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "20:50 - 21:50",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/girlsoftheinternetmusic/",
    },
    {
        name: "GLITTERBOX TAKEOVER: LUKE SOLOMON",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "19:50 - 20:50",
            },
        ],
        imgUrl: "",
        url: "https://glitterboxibiza.com/",
    },
    {
        name: "GLITTERBOX TAKEOVER: MELLE BROWN",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "21:50 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://glitterboxibiza.com/",
    },
    {
        name: "GLITTERBOX TAKEOVER: MELVO BAPTISTE",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "01:15 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://glitterboxibiza.com/",
    },
    {
        name: "GLITTERBOX TAKEOVER: SHAPESHIFTERS B2B SOPHIE LLOYD",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://glitterboxibiza.com/",
    },
    {
        name: "GLOBAL COLLECTIVE",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "00:30 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.seventhwavemusic.co.uk/the-global-collective/",
    },
    {
        name: "GLOWBROS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "01:00 - 03:00",
            },
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "22:00 - 00:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "01:00 - 03:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "22:00 - 00:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "01:00 - 03:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "22:00 - 00:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "01:00 - 03:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "22:00 - 00:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "01:00 - 03:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GNARLY",
        events: [
            {
                stage: "TOLPUDDLE",
                day: "SUNDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/gnarly.music/",
    },
    {
        name: "GNARLY (BLENDID TAKEOVER) 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "17:30 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/gnarly",
    },
    {
        name: "GNOMES",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "16:30 - 17:15",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "13:45 - 14:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:25 - 17:10",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:45 - 14:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:15 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.fairplaycomedy.com/",
    },
    {
        name: "GODDARD. W/ TEMPZA",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "12:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GOING BANANAS",
        events: [
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "THE GLEBE",
                day: "SUNDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "17:50 - 18:20",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SUNDAY",
                time: "14:55 - 15:25",
            },
        ],
        imgUrl: "",
        url: "https://www.richardhandley.co.uk/",
    },
    {
        name: "GOK WAN",
        events: [
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "16:10 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/therealgokwan/",
    },
    {
        name: "GOLD DUBS BTB RAGGAMUFFIN SOUND",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GOLDDUBS",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "FRIDAY",
                time: "00:00 - 00:45",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/golddubs?igshid=ymmymta2m2y=",
    },
    {
        name: "GONG BATHS",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SATURDAY",
                time: "15:15 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://yogicsound.com/",
    },
    {
        name: "GONG BATHS WITH MARTINA SAORIN",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "THURSDAY",
                time: "16:30 - 17:15",
            },
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "FRIDAY",
                time: "16:15 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://yogicsound.com/",
    },
    {
        name: "GOOD BOY",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "THURSDAY",
                time: "19:00 - 19:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GOOD HABITS",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "WEDNESDAY",
                time: "18:00 - 18:55",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "13:50 - 14:15",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "18:05 - 18:35",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "12:10 - 12:35",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GORILLA HUGS",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GORILLA TACTICS",
        events: [
            {
                stage: "THE BUG",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/gorillatacticscrew/?hl=en",
    },
    {
        name: "GRACE BILLINGS",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "18:53 - 19:23",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "12:05 - 12:35",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "14:01 - 14:31",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "14:55 - 15:25",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "16:05 - 16:35",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "16:35 - 17:05",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/theamazinggracieb",
    },
    {
        name: "GRACE DIY",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SATURDAY",
                time: "23:25 - 00:55",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/gracesands",
    },
    {
        name: "GRACE MCKAGAN",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://open.spotify.com/artist/763ta6j2nc9dvvg4d8xupg",
    },
    {
        name: "GRAHAM CHILCOTT",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "10:30 - 11:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GRAY",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "FRIDAY",
                time: "05:15 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/graydnb?fbclid=paaabtgjfrsq3bptnsbt2skb_onpdfs2ftuf_ccw7qgguxiwmlcel9xixelkm",
    },
    {
        name: "GREAT APE CHALLENGE",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "THURSDAY",
                time: "13:30 - 14:00",
            },
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "13:30 - 14:00",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SUNDAY",
                time: "13:30 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GREENTEA SELECTA",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "THURSDAY",
                time: "00:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/greenteapeng/",
    },
    {
        name: "GREG BELSON",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "THURSDAY",
                time: "21:20 - 23:20",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djgregbelson/?hl=en",
    },
    {
        name: "GREG BELSON'S DIVINE DISCOTHEQUE",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "SUNDAY",
                time: "01:00 - 02:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djgregbelson/?hl=en",
    },
    {
        name: "GREG MAHON",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "13:50 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "GRIDLOCK IN PARLIAMENT",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SUNDAY",
                time: "20:00 - 02:45",
            },
        ],
        imgUrl: "",
        url: "https://babylonuprising.com/",
    },
    {
        name: "GRIOT GABRIEL",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "11:58 - 12:23",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "15:51 - 16:16",
            },
        ],
        imgUrl: "",
        url: "https://www.the-poetryplace.com/griot-gabriel-1",
    },
    {
        name: "GROOVY GUY",
        events: [
            {
                stage: "THE GLEBE",
                day: "THURSDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "THE PAVEMENT",
                day: "WEDNESDAY",
                time: "16:35 - 17:05",
            },
            {
                stage: "THE PAVEMENT",
                day: "THURSDAY",
                time: "14:20 - 14:50",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "THE PAVEMENT",
                day: "SUNDAY",
                time: "15:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.groovyguyshow.com/",
    },
    {
        name: "GROVE",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "THE TEMPLE",
                day: "FRIDAY",
                time: "00:00 - 00:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/theyisgrove/",
    },
    {
        name: "GROWING BOI",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "12:30 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/growingboi",
    },
    {
        name: "GUESSWERK",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "13:15 - 14:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/guesswerk",
    },
    {
        name: "GUILLERMO THE HAIRY HATTER",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:40 - 18:25",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:10 - 15:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:20 - 18:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:10 - 15:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "17:20 - 18:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:10 - 15:55",
            },
        ],
        imgUrl: "",
        url: "https://www.ciefacilearetenir.com/",
    },
    {
        name: "GUNS N' ROSES",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SATURDAY",
                time: "21:30 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://www.gunsnroses.com/",
    },
    {
        name: "GUNS OF NAVARONE",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "THURSDAY",
                time: "23:15 - 00:30",
            },
            {
                stage: "THE GATEWAY",
                day: "THURSDAY",
                time: "16:00 - 16:30",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.pronghorn.co.uk/",
    },
    {
        name: "GUY WILLIAMS",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "FRIDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/guywilliams",
    },
    {
        name: "GUY.IN.GLASSES",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "13:45 - 14:25",
            },
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "16:00 - 17:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/guyinglasses_/",
    },
    {
        name: "GWENNO",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SUNDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.gwenno.info/",
    },
    {
        name: "GWYN SELECTA",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "H. ELDRITCH",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "19:45 - 20:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "H.ELDRITCH",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "17:00 - 17:40",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SUNDAY",
                time: "17:45 - 18:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/h.eldritch",
    },
    {
        name: "HAAI",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/haaihaaihaai/?hl=en",
    },
    {
        name: "HAAI B2B I. JORDAN",
        events: [
            {
                stage: "THE TEMPLE",
                day: "SATURDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/i.jordan/",
    },
    {
        name: "HAGAN B2B SAM INTERFACE",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "FRIDAY",
                time: "23:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HAGOP TCHAPARIAN",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "13:00 - 14:30",
            },
            {
                stage: "THE LEVELS",
                day: "SUNDAY",
                time: "13:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HAK BAKER",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "20:00 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://www.hakbaker.com/",
    },
    {
        name: "HALFQUEEN",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HAMISH & TOBY",
        events: [
            {
                stage: "FLYING BUS",
                day: "SATURDAY",
                time: "23:30 - 01:30",
            },
            {
                stage: "THE WOW",
                day: "SUNDAY",
                time: "20:30 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HAMISH VS MEG DUCHESS",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "11:00 - 13:30",
            },
            {
                stage: "THE MEETING PLACE BAR",
                day: "SUNDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.heywhat.co.uk/hamish-vs-meg",
    },
    {
        name: "HANDS ON: BADGEMAKING",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "FRIDAY",
                time: "16:15 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HANDS ON: BILL LLOYD, ON THE ROAD - HORSES AND KNOTS",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "WEDNESDAY",
                time: "16:15 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://billlloyd.co.uk/",
    },
    {
        name: "HANDS ON: NFATS OPEN HOUSE / LIBRARY READINGS",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "THURSDAY",
                time: "16:15 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HANNAH FINN",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "17:26 - 17:32",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "21:30 - 21:36",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "19:55 - 20:01",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "16:48 - 16:54",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "13:55 - 14:01",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "13:29 - 13:35",
            },
        ],
        imgUrl: "",
        url: "https://www.contortiongirl.com/",
    },
    {
        name: "HANNAH HOLLAND",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "FRIDAY",
                time: "04:20 - 05:55",
            },
        ],
        imgUrl: "",
        url: "https://www.hannahhollandmusic.co.uk/",
    },
    {
        name: "HANNAH WHITE",
        events: [
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "19:30 - 20:15",
            },
        ],
        imgUrl: "",
        url: "https://www.hannahwhitemusic.com/",
    },
    {
        name: "HANNAH WILLIAMS & THE AFFIRMATIONS",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SUNDAY",
                time: "12:35 - 13:25",
            },
        ],
        imgUrl: "",
        url: "https://hannahsoulwilliams.bandcamp.com/",
    },
    {
        name: "HARDWICKE CIRCUS",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "21:45 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.hardwickecircus.tv/",
    },
    {
        name: "HARRI PEPPER",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "23:15 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/harri.pepper/",
    },
    {
        name: "HARRIET JAXXON",
        events: [
            {
                stage: "THE TEMPLE",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/harrietjaxxon/",
    },
    {
        name: "HARRISON BDP",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "01:40 - 02:55",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/harrisonbdp1/",
    },
    {
        name: "HARVEY HAWKINS",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "17:50 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.harveyhawkinscomedy.co.uk/",
    },
    {
        name: "HARVEY JAY DODGSON",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "17:15 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://harveyjaydodgson.komi.io/",
    },
    {
        name: "HARVEY JUGGLING",
        events: [
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "THE PAVEMENT",
                day: "SUNDAY",
                time: "16:05 - 16:35",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "12:30 - 12:50",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "13:05 - 13:25",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "13:05 - 13:25",
            },
        ],
        imgUrl: "",
        url: "https://www.harveyjuggle.com/",
    },
    {
        name: "HEADMIX",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "21:30 - 22:30",
            },
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "17:30 - 18:15",
            },
        ],
        imgUrl: "",
        url: "https://headmix.bandcamp.com/music",
    },
    {
        name: "HEADSTRUNG ALPACAS",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HEARD COLLECTIVE",
        events: [
            {
                stage: "TOAD HALL",
                day: "WEDNESDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.heardcollective.com/about-heard",
    },
    {
        name: "HEAVENLY JUKEBOX",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://heavenlyjukebox.wordpress.com/",
    },
    {
        name: "HEDEX PRESENTS 'MY HOME IS THE RAVE'",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "23:30 - 00:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HEELS & SOULS",
        events: [
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "14:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/heelsandsouls/?hl=en",
    },
    {
        name: "HEGEMONO",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://hegemono.com/",
    },
    {
        name: "HELENA HAUFF",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HENGE",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SUNDAY",
                time: "23:00 - 00:30",
            },
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "01:30 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://www.hengemusic.com/",
    },
    {
        name: "HENRY BUCK (LIVE)",
        events: [
            {
                stage: "FLYING BUS",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.beatport.com/release/0793/4103322",
    },
    {
        name: "HER MAJESTY'S SECRET CIRCUS",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "14:10 - 14:40",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "12:40 - 13:10",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "17:29 - 17:59",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "16:40 - 17:10",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "16:05 - 16:35",
            },
            {
                stage: "THE PAVEMENT",
                day: "SUNDAY",
                time: "13:10 - 13:40",
            },
        ],
        imgUrl: "",
        url: "https://secretcircusshow.com/",
    },
    {
        name: "HERE COME THE CROWS",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/herecomethecrows/",
    },
    {
        name: "HESSLE AUDIO DAYTIME TAKEOVER: AMALIAH, BEN UFO X PEARSON SOUND X PANGAEA, PARRIS",
        events: [
            {
                stage: "THE WOW",
                day: "FRIDAY",
                time: "12:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HIGH FLYERS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "22:15 - 23:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "20:00 - 20:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "22:15 - 23:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "20:00 - 20:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "22:15 - 23:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "20:00 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://www.apusproductions.co.uk/",
    },
    {
        name: "HIGH SOCIETY",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "20:42 - 21:12",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "17:04 - 17:34",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "14:00 - 14:30",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "17:10 - 17:40",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "14:06 - 14:36",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "13:40 - 14:10",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HIGHERELVES",
        events: [
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "13:30 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HIPPO SOUND SYSTEM",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "14:15 - 15:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/hipposoundsystem/",
    },
    {
        name: "HIPPO SOUND SYSTEM & FRIENDS",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "05:15 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/hipposoundsystem/?locale=en_gb",
    },
    {
        name: "HIXXY",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://m.soundcloud.com/hixxy",
    },
    {
        name: "HMT HARD CRU",
        events: [
            {
                stage: "THE BUG",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/hmthardcru/?hl=en",
    },
    {
        name: "HO99O9 (EARACHE RECORDS TAKEOVER)",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "01:15 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://ho99o9.com/",
    },
    {
        name: "HOBO JONES & THE JUNKYARD DOGS",
        events: [
            {
                stage: "AVALON STAGE",
                day: "FRIDAY",
                time: "13:00 - 13:50",
            },
        ],
        imgUrl: "",
        url: "https://hobojonesthejunkyarddogs.bandcamp.com/",
    },
    {
        name: "HODGE",
        events: [
            {
                stage: "IICON",
                day: "THURSDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/hodge",
    },
    {
        name: "HODMADODDERY",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "19:40 - 20:25",
            },
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "13:25 - 13:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HOLD TIGHT RECORDS TAKEOVER: HAMDI, ICKLE B2B SUPPLYA FT JMAN & WHOKNEW, JOKER, PEACHIN\u2019",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "SUNDAY",
                time: "18:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HOLLIE ROGERS",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "20:00 - 21:00",
            },
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "12:15 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.hollierogers.com/",
    },
    {
        name: "HOLY MOLY",
        events: [
            {
                stage: "THE TEMPLE",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/holymolyuk/",
    },
    {
        name: "HOLY MOLY & THE CRACKERS",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SATURDAY",
                time: "12:50 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://www.holymolyandthecrackers.com/",
    },
    {
        name: "HOLY YOUTH MOVEMENT",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "16:20 - 17:20",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/holyyouthmovement/",
    },
    {
        name: "HOOPS WORKSHOP WITH MERLIN",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "THURSDAY",
                time: "14:30 - 15:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "FRIDAY",
                time: "14:30 - 15:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SATURDAY",
                time: "14:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.msmerlin.com/",
    },
    {
        name: "HOSPITAL DJS",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HOST: ANGEL MEL",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HOT BROWN HONEY",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "23:30 - 00:45",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "00:17 - 01:32",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "00:12 - 01:27",
            },
        ],
        imgUrl: "",
        url: "https://www.hotbrownhoney.com/",
    },
    {
        name: "HOT CHIP",
        events: [
            {
                stage: "WOODSIES",
                day: "FRIDAY",
                time: "22:30 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://www.hot-chip.co.uk/",
    },
    {
        name: "HOT PRESS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HOTSTEPPAS FEAT DUB PRINCESS",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "04:00 - 04:45",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/hotsteppas",
    },
    {
        name: "HOW TO SET UP A COMMUNITY COMPOSTING PROJECT - PRACTICAL TALK BY FIN JORDAO",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SUNDAY",
                time: "16:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HUERTA B2B LIQUID EARTH",
        events: [
            {
                stage: "THE WOW",
                day: "FRIDAY",
                time: "18:50 - 20:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HUMBLEWELL OPENING CEREMONY WITH KARY STEWART + CO",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "WEDNESDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://ig%20@karysjourney/",
    },
    {
        name: "HUMMINGBIRDS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "17:00 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "14:15 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:00 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:15 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "17:45 - 18:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:15 - 16:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HUSBAND",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "SUNDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "HVNTER",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "13:30 - 14:15",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/iamhvnter",
    },
    {
        name: "HYBRID MINDS FT TEMPAZ",
        events: [
            {
                stage: "ARCADIA",
                day: "SUNDAY",
                time: "00:30 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://hybridmindsmusic.com/",
    },
    {
        name: "I AM FYA (DJ SET)",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SUNDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://iamfya.com/",
    },
    {
        name: "I AM FYA (LIVE)",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SUNDAY",
                time: "23:30 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://iamfya.com/",
    },
    {
        name: "I AM WEEKEMDER DOCUMENTRY WITH INTRO Q&A",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "THURSDAY",
                time: "00:30 - 01:45",
            },
        ],
        imgUrl: "",
        url: "https://www.rottentomatoes.com/m/i_am_weekender",
    },
    {
        name: "I-SPY A MICROBE - DROP-IN TO LOOK FOR LIFE THROUGH THE MICROSCOPE",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SUNDAY",
                time: "13:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "I-SPY A MICROBE - DROP-IN TO LOOK FOR LIFE THROUGH THE MICROSCOPE WITH FIN JORDAO",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "WEDNESDAY",
                time: "15:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "I. JORDAN",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "IAN B DUNNE",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "12:45 - 13:15",
            },
        ],
        imgUrl: "",
        url: "http://www.doscience.co.uk/",
    },
    {
        name: "IAN B. DUNNE",
        events: [
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "13:45 - 14:15",
            },
        ],
        imgUrl: "",
        url: "http://www.doscience.co.uk/",
    },
    {
        name: "IAN B. DUNNE - SOUND SCIENCE",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "THURSDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SATURDAY",
                time: "12:45 - 13:15",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SUNDAY",
                time: "14:15 - 14:45",
            },
        ],
        imgUrl: "",
        url: "http://www.doscience.co.uk/",
    },
    {
        name: "IAN STONE",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "14:05 - 14:35",
            },
        ],
        imgUrl: "",
        url: "http://www.ianstonecomedian.co.uk/",
    },
    {
        name: "IAN STONE (COMPERE)",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "12:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "http://www.ianstonecomedian.co.uk/",
    },
    {
        name: "IICON:AV-3D",
        events: [
            {
                stage: "IICON",
                day: "SUNDAY",
                time: "00:15 - 00:30",
            },
            {
                stage: "IICON",
                day: "SATURDAY",
                time: "01:00 - 01:15",
            },
            {
                stage: "IICON",
                day: "FRIDAY",
                time: "23:30 - 23:45",
            },
            {
                stage: "IICON",
                day: "THURSDAY",
                time: "01:15 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ILAEY",
        events: [
            {
                stage: "TOAD HALL",
                day: "WEDNESDAY",
                time: "20:40 - 21:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "IL\u00c6Y & KEZZ",
        events: [
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.sonicbids.com/band/ilaey/",
    },
    {
        name: "IMOGEN",
        events: [
            {
                stage: "THE WOW",
                day: "THURSDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "IN DUB WE TRUST",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "12:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://babylonuprising.com/",
    },
    {
        name: "INCANDESCENCE",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "17:34 - 17:42",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "14:45 - 14:53",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "17:29 - 17:37",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "14:45 - 14:53",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "19:25 - 19:33",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "16:41 - 16:49",
            },
        ],
        imgUrl: "",
        url: "https://www.incandescence.co.uk/",
    },
    {
        name: "INDIAN HEAD MASSAGE WORKSHOP WITH LUCY SAGE",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.wisesagewellbeing.co.uk/",
    },
    {
        name: "INDIGO RUMBELOW",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://how%20to%20just%20stop%20oil/",
    },
    {
        name: "INKLINGS: A DROP-IN DRAWING WORKSHOP WITH BOTANICAL INKS AND EARTH PIGMENTS",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "16:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "INTERMISSION",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "INTRODUCTION TO QUEER THEORY & QUEER FUNGI WITH NINA SCOTT",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "THURSDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bemoremushroom/",
    },
    {
        name: "IONA LEE",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "15:14 - 15:39",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "16:52 - 17:17",
            },
        ],
        imgUrl: "",
        url: "https://www.ionalee.com/",
    },
    {
        name: "IORA",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "FRIDAY",
                time: "16:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ISAAC FERRY",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/isaacferry",
    },
    {
        name: "ISABELLA",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SUNDAY",
                time: "23:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/isabella",
    },
    {
        name: "ITTMAN",
        events: [
            {
                stage: "VILLAGE INN",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "VILLAGE INN",
                day: "SUNDAY",
                time: "19:15 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/itt_man",
    },
    {
        name: "IVICORE",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "00:30 - 02:00",
            },
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "04:45 - 05:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/ivicore/",
    },
    {
        name: "IVO GRAHAM",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "23:40 - 00:10",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "IVY (LIVE)",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "IVY LAB",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "22:15 - 23:10",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "IZCO",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "18:35 - 19:35",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/izzycofie/",
    },
    {
        name: "J-FELIX LIVE",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "SATURDAY",
                time: "23:45 - 00:35",
            },
        ],
        imgUrl: "",
        url: "https://www.jfelixmusic.com/",
    },
    {
        name: "J-MARKS",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "THURSDAY",
                time: "21:30 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/jules_marks_",
    },
    {
        name: "J. ARIA",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "FRIDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/jaria",
    },
    {
        name: "J. NICHOLAS",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "J.A.M. STRING COLLECTIVE",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/@jamstringcollective",
    },
    {
        name: "J9",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "15:50 - 16:20",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.rsvpmusic.co.uk/",
    },
    {
        name: "J9 DJ",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "15:50 - 16:10",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "13:55 - 14:25",
            },
        ],
        imgUrl: "",
        url: "https://www.rsvpmusic.co.uk/",
    },
    {
        name: "JABBA THE SLUT",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "FRIDAY",
                time: "00:00 - 01:30",
            },
            {
                stage: "SWEET CHARITY",
                day: "SATURDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JACK CHARD",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "15:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jckatck/",
    },
    {
        name: "JACK GLEADOW",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "19:15 - 19:45",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "22:15 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://jackgleadow.co.uk/",
    },
    {
        name: "JACK MONTI",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "THURSDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "THE TAPHOUSE",
                day: "SATURDAY",
                time: "23:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/osmaan_jack/",
    },
    {
        name: "JACK TYSON CHARLES",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/jacktysoncharles",
    },
    {
        name: "JACK VALERO",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JACOB COLLIER",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SATURDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://www.jacobcollier.com/#/",
    },
    {
        name: "JACOB REDDY",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "12:30 - 12:50",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "13:30 - 13:50",
            },
        ],
        imgUrl: "",
        url: "https://jacobreddymusic.co.uk/",
    },
    {
        name: "JACOB SZULECKI",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://jacobszulecki.wixsite.com/jacobszulecki",
    },
    {
        name: "JAGUAR PRESENTS UTOPIA W/ AMA + PROSPA",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "FRIDAY",
                time: "19:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JAIA PEPPIATT FROM CIRK HES - NEXT GEN",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "20:01 - 20:07",
            },
        ],
        imgUrl: "",
        url: "https://www.circusworksdevoran.org/",
    },
    {
        name: "JAKE SHEARS",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SATURDAY",
                time: "20:05 - 21:05",
            },
            {
                stage: "NYC DOWNLOW",
                day: "SATURDAY",
                time: "00:55 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JAKE STORM",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "12:00 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/stametshroom",
    },
    {
        name: "JAM SESSION",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "20:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JAMALI MADDIX",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "22:45 - 23:15",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "22:50 - 23:20",
            },
        ],
        imgUrl: "",
        url: "https://www.jamalimaddix.com/",
    },
    {
        name: "JAMES ACASTER IN CONVERSATION WITH NISH KUMAR",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "15:00 - 15:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JAMES ALEXANDER BRIGHT & BENJAMIN SMITH",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://jamesalexanderbright.com/",
    },
    {
        name: "JAMES ELLIS FORD",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SATURDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.jamesellisford.com/",
    },
    {
        name: "JAMES HUMPHRYS",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "13:20 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.jameshumphrys.com/",
    },
    {
        name: "JAMES REES",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "17:15 - 18:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JAMES RILEY",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "19:15 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://jamesrileymusic.com/",
    },
    {
        name: "JAMIE COOK",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "13:30 - 13:50",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "13:00 - 13:20",
            },
        ],
        imgUrl: "",
        url: "https://facebook.com/jamiecookmusic",
    },
    {
        name: "JAMIE KELSEY FRY",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "WEDNESDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://adventures%20in%20democracy/",
    },
    {
        name: "JAMIE KELSEY FRY, CATALINA, LINA JOHNSEN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "http://a22%20europe%20%26%20spreading/",
    },
    {
        name: "JAMIE WEBSTER",
        events: [
            {
                stage: "AVALON STAGE",
                day: "FRIDAY",
                time: "15:35 - 16:35",
            },
        ],
        imgUrl: "",
        url: "https://www.jamiewebstermusic.com/",
    },
    {
        name: "JAMMA DA SAMBA",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JAMZ SUPERNOVA",
        events: [
            {
                stage: "IICON",
                day: "SATURDAY",
                time: "04:45 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/jamzsupernova/biography",
    },
    {
        name: "JAMZ SUPERNOVA B2B BIANCA OBLIVION",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "FRIDAY",
                time: "02:00 - 03:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JANINA VUGURS",
        events: [
            {
                stage: "STORYTELLERS LOUNGE",
                day: "FRIDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JAPANESE BREAKFAST",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SUNDAY",
                time: "12:30 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jbrekkie/",
    },
    {
        name: "JAPPA",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "FRIDAY",
                time: "04:30 - 05:15",
            },
        ],
        imgUrl: "",
        url: "https://open.spotify.com/artist/1yjoqxssa8le5egt7q7rai?si=cnvge5yrtyika75jtncfwg",
    },
    {
        name: "JASPER TYGNER (LIVE)",
        events: [
            {
                stage: "THE WOW",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JASSEEKA DEL",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SATURDAY",
                time: "01:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jasseeka_del/",
    },
    {
        name: "JAY 0117",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "13:00 - 13:25",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JAY CARDER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "16:30 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://jay%20carder%20(@xn--jaycarderdj%29%20%20instagram%20photos%20and%20videos-t807a/",
    },
    {
        name: "JAY RAWLINGS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:30 - 18:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:40 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:30 - 18:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:40 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "17:30 - 18:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:40 - 16:15",
            },
        ],
        imgUrl: "",
        url: "https://www.jayrawlings.com/",
    },
    {
        name: "JAYDA G",
        events: [
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "16:30 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JAYU AND KYLE PARSLEY",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jayu_j_u/.%20https://www.instagram.com/kyle_stfd/",
    },
    {
        name: "JEANIE WHITE",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "14:25 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://li.sten.to/jeaniewhite",
    },
    {
        name: "JEFFREY SFIRE",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "THURSDAY",
                time: "23:25 - 01:25",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/jeffreysfire",
    },
    {
        name: "JEM COOKE",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "22:25 - 23:10",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jemcooke/",
    },
    {
        name: "JEN BRISTER",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "21:35 - 22:05",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "16:15 - 16:45",
            },
        ],
        imgUrl: "",
        url: "http://www.jenbrister.co.uk/",
    },
    {
        name: "JEREMIAH ASIAMAH: VILLAGE CUTS TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jeremiahasiamah/",
    },
    {
        name: "JEREMY DELLER",
        events: [
            {
                stage: "FREE UNIVERSITY OF GLASTONBURY",
                day: "SATURDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/jeremydeller?lang=en",
    },
    {
        name: "JEROME HILL",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djjeromehill/",
    },
    {
        name: "JERRELL",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jerrellcumberbatch/",
    },
    {
        name: "JERRI HART",
        events: [
            {
                stage: "CROONER'S CORNER",
                day: "WEDNESDAY",
                time: "15:15 - 16:00",
            },
            {
                stage: "CROONER'S CORNER",
                day: "THURSDAY",
                time: "15:45 - 16:30",
            },
            {
                stage: "CROONER'S CORNER",
                day: "FRIDAY",
                time: "12:00 - 12:45",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SATURDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SUNDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.jerrihart.com/",
    },
    {
        name: "JERSEY GIRLS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:10 - 15:40",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:30 - 12:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:10 - 15:40",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:30 - 12:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:10 - 15:40",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:30 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.danthehat.co.uk/",
    },
    {
        name: "JESHI",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "14:15 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JESSE ANGELORO",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "15:00 - 15:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JFB",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "20:00 - 21:00",
            },
            {
                stage: "THE BUG",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "THE MEETING PLACE BAR",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "VILLAGE INN",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "VILLAGE INN",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/jfbdj",
    },
    {
        name: "JFB (BLENDID TAKEOVER) 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "23:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://jfbscratch.com/",
    },
    {
        name: "JIM BITCH AND STIVS",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SUNDAY",
                time: "03:45 - 05:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JIMMY GOODRICH",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "11:45 - 12:15",
            },
        ],
        imgUrl: "",
        url: "https://www.goodrichmusic.co.uk/",
    },
    {
        name: "JJ STERRY",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "18:00 - 18:40",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jjsterry/",
    },
    {
        name: "JO GIRL",
        events: [
            {
                stage: "DELUXE DINER",
                day: "SATURDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOANNE SHAW TAYLOR",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SATURDAY",
                time: "15:35 - 16:35",
            },
        ],
        imgUrl: "",
        url: "https://www.joanneshawtaylor.com/",
    },
    {
        name: "JOB JOBSE",
        events: [
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "20:30 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jobjobse/?hl=en",
    },
    {
        name: "JOCKSTRAP",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SATURDAY",
                time: "15:15 - 16:15",
            },
        ],
        imgUrl: "",
        url: "https://jockstrapmusic.com/",
    },
    {
        name: "JODIE HARSH",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "19:30 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://jodieharsh.com/",
    },
    {
        name: "JOE ARMON JONES & MAXWELL OWIN",
        events: [
            {
                stage: "THE WOW",
                day: "THURSDAY",
                time: "18:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOE JACOBS",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "20:50 - 21:20",
            },
        ],
        imgUrl: "",
        url: "https://www.joejacobs.website/",
    },
    {
        name: "JOE ROONEY (COMPERE)",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "17:30 - 20:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOE STROUZER",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.joestrouzer.com/",
    },
    {
        name: "JOEI SUPERNOVA",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/joeisupernova/",
    },
    {
        name: "JOELLE TAYLOR",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "17:53 - 18:23",
            },
        ],
        imgUrl: "",
        url: "http://www.joelletaylor.co.uk/",
    },
    {
        name: "JOESEF",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOEY BADA$$",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.joeybadass.com/",
    },
    {
        name: "JOHN E VISTIC",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "15:00 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://vistic.co.uk/",
    },
    {
        name: "JOHN E VISTIC AND HOLLY CARTER",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "16:05 - 16:50",
            },
        ],
        imgUrl: "",
        url: "https://www.cordeliagartside.com/",
    },
    {
        name: "JOHN FRANCIS FLYNN",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SUNDAY",
                time: "11:30 - 12:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/johnfrancisflynnmusic/?hl=en",
    },
    {
        name: "JOHN HEGLEY",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "18:10 - 18:55",
            },
        ],
        imgUrl: "",
        url: "https://www.johnhegley.co.uk/",
    },
    {
        name: "JOHN OSBORNE",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "14:46 - 15:11",
            },
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "13:05 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/johnosradiohead",
    },
    {
        name: "JOHN ROBB",
        events: [
            {
                stage: "FREE UNIVERSITY OF GLASTONBURY",
                day: "FRIDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/johnrobb77",
    },
    {
        name: "JOHN ROBERTSON - THE DARK ROOM",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "23:00 - 23:50",
            },
        ],
        imgUrl: "",
        url: "https://www.thejohnrobertson.com/",
    },
    {
        name: "JOHN ROW",
        events: [
            {
                stage: "STORYTELLERS LOUNGE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOHNNY RAY & THE WASTERS",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "21:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/jonnyrayandthewasters/",
    },
    {
        name: "JOIN ARTISIT IN RESIDENCE JENG AU IN MYCO NETWORK BUILDING USING SOIL AND COB TECHNIQUES",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SUNDAY",
                time: "13:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOLYON MAUGHAM",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://good%20law%20vs%20goliath/",
    },
    {
        name: "JOLYON MAUGHAM, EBEN LAZARUS -JSO, SOPHIE COWEN  - CHAIR ROGER HARRABIN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://stopping%20new%20oil/",
    },
    {
        name: "JOLYON RUBINSTEIN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "http://rage%20against%20the%20machine/",
    },
    {
        name: "JON CARTER",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "22:45 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jonrichardcarter",
    },
    {
        name: "JON KENZIE",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "13:15 - 13:45",
            },
        ],
        imgUrl: "",
        url: "http://www.jonkenzie.com/",
    },
    {
        name: "JON UDRY",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "16:23 - 16:48",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "15:01 - 15:26",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "14:35 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://jonudry.com/",
    },
    {
        name: "JONATHAN PIE",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "THURSDAY",
                time: "21:20 - 22:20",
            },
        ],
        imgUrl: "",
        url: "https://www.jonathanpie.com/",
    },
    {
        name: "JONESY WALES & GUTTY PRESENT: SUNDAY CABARET",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jonesy_wales/%20https://www.instagram.com/tommytuffbda/",
    },
    {
        name: "JONNY AWSUM",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "13:00 - 13:30",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "14:50 - 15:20",
            },
        ],
        imgUrl: "",
        url: "https://www.jonnyawsum.com/",
    },
    {
        name: "JONNY RAY & THE WASTERS",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "WEDNESDAY",
                time: "15:30 - 16:15",
            },
        ],
        imgUrl: "",
        url: "https://jonnyrayandthewasters.bandcamp.com/",
    },
    {
        name: "JONNY RAY AND THE WASTERS",
        events: [
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JORDSS",
        events: [
            {
                stage: "PLATFORM 23",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jordss.dj/",
    },
    {
        name: "JORDSS PRESENTS GIRLS CAN'T DJ: JORDSS, NALA BROWN, OH ANNIE OH, TAYLAH ELAINE",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "SATURDAY",
                time: "12:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOSH BARRY",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/joshbarrymusic",
    },
    {
        name: "JOSH CAFF\u00c9",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SUNDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/joshcaffe",
    },
    {
        name: "JOSH WIDDICOMBE & ROB BECKETT",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "12:50 - 13:35",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOY (ANONYMOUS)",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOY ANONYMOUS",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "JOY IN DANCE - WISDOM OF POP (DANCE WORKSHOP)",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "11:15 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/thejoyindance/",
    },
    {
        name: "JUICE MENACE",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "FRIDAY",
                time: "18:00 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://juicemenace.bandcamp.com/",
    },
    {
        name: "JUNGLE CAKES TAKEOVER: KARA + ED SOLO B2B DEEKLINE B2B TOBY ROSS HOSTED BY JUNIOR RED",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://hotcakes.info/artists/",
    },
    {
        name: "JUNIOR BILL",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "20:30 - 21:30",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "22:35 - 23:05",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "21:05 - 21:35",
            },
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "15:45 - 16:30",
            },
        ],
        imgUrl: "",
        url: "http://juniorbill.co.uk/",
    },
    {
        name: "JUST A COUPLE OF MUMS",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/justacoupleofmums",
    },
    {
        name: "JUST GEO",
        events: [
            {
                stage: "VILLAGE INN",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "TOLPUDDLE",
                day: "THURSDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/justgeouk/",
    },
    {
        name: "JYOTY & FRIENDS PRESENTS: CHARISSE C B2B KILIMANJARO, JAEL, JYOTY, KITTY AMOR, LIL SILVA , SBTRKT (DJ)",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "THURSDAY",
                time: "19:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "K MOTIONZ",
        events: [
            {
                stage: "THE TEMPLE",
                day: "SUNDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/voltage_uk_/",
    },
    {
        name: "K-KLASS",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "17:40 - 18:40",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/officialkklass",
    },
    {
        name: "KAISHA",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/kaisha_dnb?igshid=ymmymta2m2y=",
    },
    {
        name: "KAJAMAGOO ARTS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KANDA BONGO MAN",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/kandabongom/?locale=en_gb",
    },
    {
        name: "KANE AND ABEL",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:15 - 11:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:15 - 11:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:15 - 11:45",
            },
        ],
        imgUrl: "",
        url: "https://www.kaneandabelmagic.com/",
    },
    {
        name: "KANE AND ABLE",
        events: [
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "14:00 - 14:20",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "14:00 - 14:20",
            },
            {
                stage: "THE GLEBE",
                day: "SUNDAY",
                time: "14:00 - 14:20",
            },
        ],
        imgUrl: "",
        url: "https://www.kaneandabelmagic.com/",
    },
    {
        name: "KANGAROO MOON",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "21:30 - 22:30",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "16:20 - 16:50",
            },
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "https://www.kangaroomoon.com/",
    },
    {
        name: "KANINE",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KAREN CARNEY MBE & DAVID WHEELER",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://football%20%26%20climate/",
    },
    {
        name: "KAREN NYAME KG",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "16:00 - 17:10",
            },
        ],
        imgUrl: "",
        url: "https://www.karennyamekg.com/",
    },
    {
        name: "KASAI MASAI",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://kasaimasai.com/",
    },
    {
        name: "KASRA",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "http://kasra%20%7C%20critical%20(@xn--kasracritical%29%20%20instagram%20photos%20and%20videos-mh48a/",
    },
    {
        name: "KATE EVANS & TOM DALY",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://refugee%20stories%20%26%20cartoons/",
    },
    {
        name: "KATE FOX",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "17:20 - 17:50",
            },
        ],
        imgUrl: "",
        url: "https://katefoxwriter.wordpress.com/",
    },
    {
        name: "KATE HUTCHINSON",
        events: [
            {
                stage: "SAN REMO",
                day: "SUNDAY",
                time: "10:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/katehutchinsonpow/",
    },
    {
        name: "KATHRYN ROBERTS & SEAN LAKEMAN",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "13:00 - 13:40",
            },
        ],
        imgUrl: "",
        url: "https://www.kathrynrobertsandseanlakeman.com/",
    },
    {
        name: "KATIE AILES",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "16:23 - 16:48",
            },
        ],
        imgUrl: "",
        url: "https://katieailes.com/",
    },
    {
        name: "KATOIK KARTEL",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://open.spotify.com/artist/5ukrxynstlbd0avysx9km1?si=gepfxwy6sdklviuweur_3w",
    },
    {
        name: "KATY B B2B EMERALD",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "23:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KATYA",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "12:10 - 12:40",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/katyatheartist/",
    },
    {
        name: "KAVUS TORABI",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://kavustorabi.bandcamp.com/",
    },
    {
        name: "KEKE MANIKII",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "12:30 - 12:50",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "14:00 - 14:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KELIS",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "FRIDAY",
                time: "22:15 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kelis/?hl=en",
    },
    {
        name: "KELSEY BELL AS BETTY CONFETTI",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "15:06 - 15:12",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "12:30 - 12:36",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "22:18 - 22:24",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "21:18 - 21:24",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "15:05 - 15:11",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "12:10 - 12:16",
            },
        ],
        imgUrl: "",
        url: "https://www.flyingbells.com/",
    },
    {
        name: "KELVIN 373",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "FRIDAY",
                time: "01:45 - 02:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kelvin373/?igshid=mzrlodbinwflza%3d%3d",
    },
    {
        name: "KENNY BEATS",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "18:45 - 19:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KERRY GODLIMAN",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "14:40 - 15:10",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KEV MUD",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "20:35 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://www.kevmud.com/",
    },
    {
        name: "KEVIN & PERRY IBIZA RAVE",
        events: [
            {
                stage: "VILLAGE INN",
                day: "THURSDAY",
                time: "00:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KEVIN AND PERRY GO LARGE 15",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "THURSDAY",
                time: "17:30 - 18:53",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt0205177/",
    },
    {
        name: "KEVIN ANDERSON",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://the%20new%20denialism:%20net-zero/",
    },
    {
        name: "KEVIN MCLEAN",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "17:06 - 17:31",
            },
        ],
        imgUrl: "",
        url: "https://www.iamloud.co/",
    },
    {
        name: "KEZZ",
        events: [
            {
                stage: "TOAD HALL",
                day: "WEDNESDAY",
                time: "21:30 - 22:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KI/KI",
        events: [
            {
                stage: "THE LEVELS",
                day: "THURSDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KID HYENA",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KID KAPICHI",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SATURDAY",
                time: "20:00 - 20:50",
            },
        ],
        imgUrl: "",
        url: "https://www.kidkapichi.com/",
    },
    {
        name: "KILIMANJARO",
        events: [
            {
                stage: "PLATFORM 23",
                day: "FRIDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kilimanjaromusic/",
    },
    {
        name: "KIMMY BEATBOX",
        events: [
            {
                stage: "NOMAD",
                day: "SUNDAY",
                time: "00:45 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kimmybeatbox/",
    },
    {
        name: "KIMMY BEATBOX & BEATFOX",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "16:15 - 16:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kimmybeatbox",
    },
    {
        name: "KIMMY BEATBOX & BEATFOX (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "17:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kimmybeatbox",
    },
    {
        name: "KING ROCKER +Q&A CERT TBC",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "THURSDAY",
                time: "21:45 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt10451082/",
    },
    {
        name: "KIRIS RIVIERE & THE DELTA DU BRUIT",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "22:35 - 23:05",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "21:05 - 21:35",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KIRRIS RIVIERE & THE DELTA DU BRUIT",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "23:30 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/kirrisriviereandthedeltadubruit/",
    },
    {
        name: "KITTEN CLUB",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://on.soundcloud.com/pcfusf7byhpjywey8",
    },
    {
        name: "KITTY AMOR: VILLAGE CUTS TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djkittyamor/",
    },
    {
        name: "KITTY STEWART",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "13:15 - 14:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KLEPTONES",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "14:00 - 16:00",
            },
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.kleptones.com/",
    },
    {
        name: "KLEU B2B RESIST",
        events: [
            {
                stage: "THE TEMPLE",
                day: "THURSDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kleu.dnb/?hl=en",
    },
    {
        name: "KLOSE ONE",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "17:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KOCAPOLI",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "11:45 - 12:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kocapoli/?hl=en",
    },
    {
        name: "KRAY-Z LEGZ (LIVE)",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KRAZY KOALA",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "KREPT & KONAN",
        events: [
            {
                stage: "OTHER STAGE",
                day: "FRIDAY",
                time: "17:15 - 18:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kreptandkonan/?hl=en",
    },
    {
        name: "KUNDALINI RISE WITH KARY STEWART",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "FRIDAY",
                time: "08:45 - 09:45",
            },
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SATURDAY",
                time: "09:00 - 10:00",
            },
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SUNDAY",
                time: "11:15 - 12:15",
            },
        ],
        imgUrl: "",
        url: "http://ig%20@karysjourney/",
    },
    {
        name: "KURUPT FM",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kuruptfm/",
    },
    {
        name: "KWABANA LINDSAY",
        events: [
            {
                stage: "THE PAVEMENT",
                day: "THURSDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "17:50 - 18:20",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "18:25 - 18:55",
            },
        ],
        imgUrl: "",
        url: "http://www.kwabanalindsay.com/",
    },
    {
        name: "KWABANA LINDSAY RIVER WALK",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "WEDNESDAY",
                time: "21:00 - 21:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "21:00 - 21:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "21:00 - 21:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "21:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "http://www.kwabanalindsay.com/",
    },
    {
        name: "K\u00d6LSCH",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kolschofficial/",
    },
    {
        name: "LA FAMILIA ROSSO",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "16:45 - 17:20",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "15:17 - 15:52",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "12:41 - 13:16",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "15:42 - 16:17",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "12:47 - 13:22",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "12:21 - 12:56",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "16:54 - 17:29",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "19:21 - 19:56",
            },
        ],
        imgUrl: "",
        url: "https://santimutante.com/",
    },
    {
        name: "LA FANFARRIA DEL CAPITAN",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.lafanfarriadelcapitan.com/",
    },
    {
        name: "LA FANFARRIA DEL CAPIT\u00c1N",
        events: [
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "23:15 - 00:30",
            },
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LA LA",
        events: [
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "15:00 - 16:30",
            },
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "16:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LADY OF THE HOUSE TAKEOVER W HANNAH LAING, CARLY WILFORD, ABEL, ANGEL MEL",
        events: [
            {
                stage: "NOWHERE",
                day: "SUNDAY",
                time: "18:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/officialladyofthehouse",
    },
    {
        name: "LADY SHAKA",
        events: [
            {
                stage: "NOWHERE",
                day: "SUNDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "http://lady%20shaka%20(@xn--ladyshaka%29%20%20instagram%20photos%20and%20videos-0075a/",
    },
    {
        name: "LADYGREY",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "THURSDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/georgia_dmiles/",
    },
    {
        name: "LAGOON FEMSHAYMA",
        events: [
            {
                stage: "NOMAD",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "NOMAD",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/lagoon_femshayma/?hl=en",
    },
    {
        name: "LAIDLAW",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "00:30 - 01:40",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/_laidlaw/",
    },
    {
        name: "LANA DEL REY",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SATURDAY",
                time: "22:30 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://www.lanadelrey.com/",
    },
    {
        name: "LANCE DESARDI",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "THURSDAY",
                time: "23:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/lancedesardi",
    },
    {
        name: "LAND OF THE GIANTS",
        events: [
            {
                stage: "THE GATEWAY",
                day: "THURSDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "THE GATEWAY",
                day: "FRIDAY",
                time: "12:05 - 12:35",
            },
            {
                stage: "THE GATEWAY",
                day: "SATURDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "THE GATEWAY",
                day: "SUNDAY",
                time: "12:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://landofthegiants.live/",
    },
    {
        name: "LARA SMILES",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "http://www.larasmiles.com/",
    },
    {
        name: "LASER KIWI",
        events: [
            {
                stage: "THE GLEBE",
                day: "THURSDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "THE GATEWAY",
                day: "FRIDAY",
                time: "16:05 - 16:35",
            },
            {
                stage: "THE GATEWAY",
                day: "SATURDAY",
                time: "16:50 - 17:20",
            },
            {
                stage: "THE GATEWAY",
                day: "SUNDAY",
                time: "14:20 - 14:50",
            },
        ],
        imgUrl: "",
        url: "https://laserkiwi.com/",
    },
    {
        name: "LASER KIWI ROPE RAP",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "00:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://laserkiwi.com/",
    },
    {
        name: "LATE NIGHT SESSIONS: ANIL, ELLIE STOKES X CHEZ DE MILO",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "SATURDAY",
                time: "00:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LATE NIGHT SESSIONS: BUDDEN AND FRIENDS",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "SUNDAY",
                time: "00:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LATE NIGHT SESSIONS: OBSIDIAN TAKEOVER - BOOTY BASS & SHADE CARTEL",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "FRIDAY",
                time: "00:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LATE NIGHT SESSIONS: RUN IN THE JUNGLE FT D*MINDS & T>I, I AM JAKES, T LEX B2B KENDRICK, TS2W",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "THURSDAY",
                time: "00:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LATE NIGHT SHOPPER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/latenightshopper/",
    },
    {
        name: "LATIN PARTY",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "01:30 - 03:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "01:30 - 03:00",
            },
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "01:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LAUGHTER YOGA WORKSHOP",
        events: [
            {
                stage: "JUGGLING TENT",
                day: "FRIDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "JUGGLING TENT",
                day: "SATURDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "JUGGLING TENT",
                day: "SUNDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.joehoare.co.uk/",
    },
    {
        name: "LAURA CANTRELL",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "17:30 - 18:10",
            },
        ],
        imgUrl: "",
        url: "https://lauracantrell.com/home",
    },
    {
        name: "LAURA LONDON",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:10 - 17:55",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:05 - 14:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:15 - 15:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "17:15 - 18:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:15 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.lauralondonmagic.co.uk/",
    },
    {
        name: "LAURA MVULA",
        events: [
            {
                stage: "AVALON STAGE",
                day: "FRIDAY",
                time: "18:35 - 19:35",
            },
        ],
        imgUrl: "",
        url: "https://www.lauramvula.com/",
    },
    {
        name: "LAUREN LO SUNG",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "01:15 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/laurenlosung/reels/",
    },
    {
        name: "LAVINIA BLACKWALL",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "15:00 - 15:40",
            },
        ],
        imgUrl: "",
        url: "https://laviniablackwall.bandcamp.com/",
    },
    {
        name: "LAZY BONES",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/djlazybones",
    },
    {
        name: "LAZY TECHNICIAN",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "14:00 - 16:00",
            },
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/thelazytechnician/",
    },
    {
        name: "LEANDER MORALES",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/leandermoralesmusic",
    },
    {
        name: "LEAPS & BOUNDS",
        events: [
            {
                stage: "LITTLE KIDZ AREA",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LED BY DONKEYS - ART, ACTIVISM AND ACCOUNTABILITY",
        events: [
            {
                stage: "THE INFORMATION",
                day: "FRIDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LEE & YOU",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "13:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LEEON",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "FRIDAY",
                time: "01:45 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/leeon-co",
    },
    {
        name: "LEFTFIELD",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SATURDAY",
                time: "21:15 - 22:15",
            },
        ],
        imgUrl: "",
        url: "https://www.leftfieldmusic.com/",
    },
    {
        name: "LEFTO EARLY BIRD B2B JAMZ SUPERNOVA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SUNDAY",
                time: "03:30 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jamzsupernova/",
    },
    {
        name: "LEILA DEEN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://babies%20or%20boomers%20-%20who%20will%20save%20us/?",
    },
    {
        name: "LEKIDDO - LORD OF THE LOBSTERS!",
        events: [
            {
                stage: "THE GATEWAY",
                day: "THURSDAY",
                time: "14:00 - 14:30",
            },
            {
                stage: "THE GATEWAY",
                day: "FRIDAY",
                time: "14:40 - 15:10",
            },
            {
                stage: "THE GATEWAY",
                day: "SATURDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "THE GATEWAY",
                day: "SUNDAY",
                time: "14:55 - 15:25",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "17:30 - 18:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "17:30 - 18:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "17:10 - 17:40",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "21:00 - 21:45",
            },
        ],
        imgUrl: "",
        url: "https://www.lekiddo.com/",
    },
    {
        name: "LENS",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://l%20e%20n%20s%20(@xn--lens_dnb%29%20%20instagram%20photos%20and%20videos-mf15a/",
    },
    {
        name: "LEON VYNEHALL",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "http://www.vynehall.com/",
    },
    {
        name: "LES OOH LA LAS",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "21:15 - 21:25",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "20:55 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://oohlalas.wixsite.com/mysite",
    },
    {
        name: "LESULA",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jsprlwe_/",
    },
    {
        name: "LEWIS CAPALDI",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SATURDAY",
                time: "17:35 - 18:35",
            },
        ],
        imgUrl: "",
        url: "https://www.lewiscapaldi.com/",
    },
    {
        name: "LEWIS CARROLL",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "21:15 - 22:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/lewiscarroll__/",
    },
    {
        name: "LEYLA JOSEPHINE",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "13:22 - 13:47",
            },
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "14:57 - 15:22",
            },
        ],
        imgUrl: "",
        url: "https://www.leylajosephine.co.uk/",
    },
    {
        name: "LF SYSTEM",
        events: [
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIA BURGE - CRYING INTO BINS",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "13:35 - 14:25",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/liaburge",
    },
    {
        name: "LIELA MOSS",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "20:00 - 20:45",
            },
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIFE DRAWING",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SATURDAY",
                time: "12:40 - 13:40",
            },
        ],
        imgUrl: "",
        url: "https://www.linkedin.com/in/fra-beecher-31578620/",
    },
    {
        name: "LIFE DRAWING WITH FRA",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "FRIDAY",
                time: "13:45 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://www.linkedin.com/in/fra-beecher-31578620/",
    },
    {
        name: "LIFE DRAWING WITH FRA BEECHER",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "THURSDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SUNDAY",
                time: "13:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.linkedin.com/in/fra-beecher-31578620/",
    },
    {
        name: "LIFEGUARDS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "18:30 - 19:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "18:30 - 19:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:30 - 19:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:30 - 16:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIGHTING OF THE FIRE FOR THE PAST",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "FRIDAY",
                time: "12:30 - 14:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIGHTING OF THE FIRE FOR THE PRESENT",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "SATURDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIGHTNING SEEDS",
        events: [
            {
                stage: "OTHER STAGE",
                day: "FRIDAY",
                time: "14:15 - 15:15",
            },
        ],
        imgUrl: "",
        url: "https://lightningseeds.co.uk/",
    },
    {
        name: "LIL MISS MOTOWN",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIL NAS X",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SUNDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.welcometomontero.com/",
    },
    {
        name: "LIME GARDEN",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SUNDAY",
                time: "18:15 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/limegardenband/",
    },
    {
        name: "LIQUID ROSS",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "22:25 - 23:35",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/liquidross",
    },
    {
        name: "LISSIE",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SUNDAY",
                time: "19:50 - 20:50",
            },
        ],
        imgUrl: "",
        url: "https://lissie.com/",
    },
    {
        name: "LITTER CRITTERS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LITTLE BIG TOP",
        events: [
            {
                stage: "LITTLE KIDZ AREA",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LITTLE MISS DJ",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIVE P.E. WITH JOE WICKS",
        events: [
            {
                stage: "THE GATEWAY",
                day: "FRIDAY",
                time: "11:15 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://thebodycoach.com/",
    },
    {
        name: "LIVER COTTAGE KITCHEN",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:45 - 16:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:15 - 13:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:45 - 16:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:15 - 13:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:45 - 16:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:15 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIZ HALL'S BOOGIE BUM BUMS",
        events: [
            {
                stage: "LITTLE KIDZ AREA",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIZARD DJS",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "13:00 - 15:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "20:00 - 20:30",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LIZZO",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SATURDAY",
                time: "19:30 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://www.lizzomusic.com/",
    },
    {
        name: "LOGY ON FIRE",
        events: [
            {
                stage: "THE GLEBE",
                day: "THURSDAY",
                time: "13:10 - 13:40",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "17:15 - 17:45",
            },
            {
                stage: "THE PAVEMENT",
                day: "SUNDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "THURSDAY",
                time: "14:10 - 14:40",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "19:35 - 20:05",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "14:55 - 15:25",
            },
        ],
        imgUrl: "",
        url: "https://logyonfire.com/",
    },
    {
        name: "LONDON ELEKTRICITY",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://london%20elektricity%20%F0%9F%8C%BB%20(@londonelek%29%20%7C%20instagram/",
    },
    {
        name: "LONDON TRANS+ PRIDE & THE CHATEAU PRESENT: THE SUMMER OF RAGE",
        events: [
            {
                stage: "NOMAD",
                day: "SATURDAY",
                time: "00:00 - 06:00",
            },
            {
                stage: "NOMAD",
                day: "SATURDAY",
                time: "17:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/londontranspride",
    },
    {
        name: "LOONALOOP",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "00:00 - 01:15",
            },
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "01:30 - 02:30",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "17:45 - 18:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/loonaloop",
    },
    {
        name: "LORD DEBDEN WITH ROGER HARRABIN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://net%20zero/",
    },
    {
        name: "LORD DEBEN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://lord%20deben%20-%20chair%20climate%20change%20committee/",
    },
    {
        name: "LORRAINE",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "00:45 - 01:55",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/djlorrainepsilocybetribe",
    },
    {
        name: "LOS BITCHOS",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://losbitchos.com/",
    },
    {
        name: "LOS DEDOS",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "THURSDAY",
                time: "00:30 - 01:45",
            },
        ],
        imgUrl: "",
        url: "https://www.losdedosband.com/",
    },
    {
        name: "LOST SOULS OF SATURN (LIVE)",
        events: [
            {
                stage: "IICON",
                day: "FRIDAY",
                time: "21:35 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://lostsoulsofsaturn.bandcamp.com/album/lost-souls-of-saturn",
    },
    {
        name: "LOTTERY WINNERS",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "AVALON STAGE",
                day: "FRIDAY",
                time: "17:05 - 18:05",
            },
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "19:00 - 19:30",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LOUIS COLE",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/louiscolemusic/?hl=en",
    },
    {
        name: "LOUISE HART",
        events: [
            {
                stage: "CROONER'S CORNER",
                day: "WEDNESDAY",
                time: "16:30 - 17:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "THURSDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "CROONER'S CORNER",
                day: "FRIDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SATURDAY",
                time: "11:00 - 11:45",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SUNDAY",
                time: "13:45 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.louise-hart.com/",
    },
    {
        name: "LOVE COME DOWN",
        events: [
            {
                stage: "VILLAGE INN",
                day: "SATURDAY",
                time: "23:45 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.lovecomedown.co.uk/",
    },
    {
        name: "LOVEJOY",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SUNDAY",
                time: "18:00 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://www.lvjyonline.com/",
    },
    {
        name: "LOYLE CARNER",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SATURDAY",
                time: "22:15 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://loylecarner.com/",
    },
    {
        name: "LSDJ",
        events: [
            {
                stage: "BIMBLE INN",
                day: "SUNDAY",
                time: "01:30 - 03:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LTJ BUKEM",
        events: [
            {
                stage: "IICON",
                day: "SATURDAY",
                time: "01:15 - 02:45",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/ltjbukem",
    },
    {
        name: "LUCI:D",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "15:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://spokenlabel.bandcamp.com/album/luci-d-spoken-label-june-2020",
    },
    {
        name: "LUCKY HOUSE TAKEOVER FT ASHER SIMMONS, DASH VILLZ, FRILLA + GUESTS",
        events: [
            {
                stage: "NOMAD",
                day: "SUNDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LUKE KEMP",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "http://catastrophic%20climate%20scenarios/",
    },
    {
        name: "LUKE LOVEMONEY",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LUKE SOLOMON & ROB MELLO",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "FRIDAY",
                time: "22:00 - 23:25",
            },
        ],
        imgUrl: "",
        url: "http://lukesolomon.com/%20https://ra.co/dj/robmello",
    },
    {
        name: "LUKE UNA",
        events: [
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "17:00 - 19:00",
            },
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "13:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "LUKE WELSH B2B MIKE MORRISEY",
        events: [
            {
                stage: "FLYING BUS",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/libero_records",
    },
    {
        name: "LUKE WRIGHT",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "16:25 - 16:55",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "16:19 - 16:49",
            },
        ],
        imgUrl: "",
        url: "https://www.lukewright.co.uk/",
    },
    {
        name: "LYDIA MAY",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.canva.com/design/dafdtk2l9bg/mi6bxeslwrd2imdzfczaia/view?utm_content=dafdtk2l9bg&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton&fbclid=iwar0faq3iz8clnwkr-ekqvhbqbq0-t-vfoqz-6ryz68hea4ird10fpfzii08",
    },
    {
        name: "LYLLA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "FRIDAY",
                time: "21:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/lylla.collins/",
    },
    {
        name: "LYRIX ORGANIX HOUSE PARTY; HOSTED BY NATTY SPEAKS & KIMMY BEATBOX",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "THURSDAY",
                time: "20:00 - 20:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/lyrixorganix/",
    },
    {
        name: "LYZA",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "17:45 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/lyza.jane_/",
    },
    {
        name: "M3GAN 15",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "FRIDAY",
                time: "17:00 - 18:41",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt8760708/",
    },
    {
        name: "MACLO",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "FRIDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/deejaymaclo",
    },
    {
        name: "MAD MIRAN B2B IDENTIFIED PATIENT",
        events: [
            {
                stage: "THE WOW",
                day: "SATURDAY",
                time: "23:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MADAME D'ORIFICIO",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "11:15 - 12:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:15 - 12:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:15 - 12:00",
            },
        ],
        imgUrl: "",
        url: "http://www.akustrik.com/",
    },
    {
        name: "MADAME ELECTRIFIE",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "04:45 - 05:15",
            },
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "03:30 - 04:00",
            },
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "02:15 - 02:45",
            },
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "23:45 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://www.madameelectrifie.com/",
    },
    {
        name: "MADAME ELECTRIFIE (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "21:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.madameelectrifie.com/",
    },
    {
        name: "MADDIE MOATE",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAE STEPHENS",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAGGIE ROGERS",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SATURDAY",
                time: "17:15 - 18:15",
            },
        ],
        imgUrl: "",
        url: "https://www.maggierogers.com/",
    },
    {
        name: "MAGICAL MILLINERS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAGPIE'S FORTUNE",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "THURSDAY",
                time: "12:00 - 18:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "12:00 - 18:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "12:00 - 18:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "12:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAHA QUEST",
        events: [
            {
                stage: "THE BUG",
                day: "SUNDAY",
                time: "19:00 - 20:15",
            },
        ],
        imgUrl: "",
        url: "https://open.spotify.com/artist/6d2lviehw3vmuitlymglen",
    },
    {
        name: "MAHALIA",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SATURDAY",
                time: "20:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.mahaliamusic.co.uk/",
    },
    {
        name: "MAIRI",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "12:20 - 12:50",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "14:50 - 15:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAISIE ADAM",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "17:45 - 18:15",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "14:20 - 14:50",
            },
        ],
        imgUrl: "",
        url: "https://maisieadam.com/",
    },
    {
        name: "MAISIE PETERS",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "18:00 - 18:40",
            },
            {
                stage: "PYRAMID STAGE",
                day: "FRIDAY",
                time: "13:15 - 14:15",
            },
        ],
        imgUrl: "",
        url: "https://www.maisiepeters.co.uk/",
    },
    {
        name: "MAKENDOO",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAKING THE INVISIBLE VISIBLE: HOW THE MICRO SHAPES THE MACRO \n JENG AU IS ARTIST-IN-RESIDENCE FOR THE DAY, PLUS CREATIVE WORKSHOPS AND DROP-IN ACTIVITIES HOSTED BY FIN JORDAO.",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SUNDAY",
                time: "12:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAL WEBB & KYLIE MORRIGAN",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "18:00 - 18:50",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "WEDNESDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "10:45 - 11:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MALA",
        events: [
            {
                stage: "IICON",
                day: "SATURDAY",
                time: "23:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/mala",
    },
    {
        name: "MALIBU HOT FLUSH",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://malibuhotflush.bandcamp.com/track/too-much-radio-edit",
    },
    {
        name: "MALIKA",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "15:45 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/strictlymalika/?hl=en",
    },
    {
        name: "MALWEBB & KYLIE MORRAGAN",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "12:00 - 13:00",
            },
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "13:15 - 14:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAMA MOONSHINE",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "15:00 - 15:45",
            },
        ],
        imgUrl: "",
        url: "https://mamamoonshine.bandcamp.com/album/mama-moonshine",
    },
    {
        name: "MAMA TOKUS",
        events: [
            {
                stage: "CROONER'S CORNER",
                day: "THURSDAY",
                time: "18:30 - 19:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "THURSDAY",
                time: "14:45 - 15:30",
            },
            {
                stage: "CROONER'S CORNER",
                day: "FRIDAY",
                time: "17:15 - 18:00",
            },
            {
                stage: "CROONER'S CORNER",
                day: "FRIDAY",
                time: "14:30 - 15:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SATURDAY",
                time: "16:30 - 17:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SATURDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.mamatokus.com/",
    },
    {
        name: "MAN POWER",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "15:00 - 16:30",
            },
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "FRIDAY",
                time: "02:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/manpower-1",
    },
    {
        name: "MANAMI B2B DEMI RIQU\u00cdSIMO",
        events: [
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "13:30 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MANDIDEXTROUS X BISH",
        events: [
            {
                stage: "NOWHERE",
                day: "SUNDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "http://mandidextrous%20(@xn--mandidextrous_23%29%20%20instagram%20photos%20and%20videos%20%20%20%20%20%20https-dd65c//www.instagram.com/dj.bishh/",
    },
    {
        name: "MANGO JACKSON",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MANGO PARK (BAILE LDN)",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/djmangopark/",
    },
    {
        name: "MANIC STREET PREACHERS",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SATURDAY",
                time: "18:45 - 19:45",
            },
        ],
        imgUrl: "",
        url: "https://www.manicstreetpreachers.com/",
    },
    {
        name: "MANTRA B2B DOUBLE O (RUPTURE) W/ CHICKABOO",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MANTRA OF THE COSMOS",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "20:20 - 21:20",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/mantraofthecosmos/",
    },
    {
        name: "MANTRA X TASHA",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "00:05 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dj.mantra/%20%20%20%20%20%20%20%20https://www.instagram.com/tasha_neighbourhood/",
    },
    {
        name: "MARC BURROWS",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "17:35 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://www.marcburrows.co.uk/comedy",
    },
    {
        name: "MARCEL DETTMANN",
        events: [
            {
                stage: "IICON",
                day: "SUNDAY",
                time: "21:15 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/marceldettmann",
    },
    {
        name: "MARCEL LUCONT'S CABARET FANTASTIQUE",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "20:30 - 21:10",
            },
        ],
        imgUrl: "",
        url: "https://www.marcellucont.com/",
    },
    {
        name: "MARCHING SKALETHONS",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.marchingskaletons.co.uk/",
    },
    {
        name: "MARCUS DU SAUTOY",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "12:00 - 12:50",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "12:00 - 12:50",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "12:00 - 12:50",
            },
        ],
        imgUrl: "",
        url: "https://www.simonyi.ox.ac.uk/",
    },
    {
        name: "MARIA PEVCHIKH, ODESSA RAE, SYDNEY LIMA",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://alexi%20navalny%20q%26a%20%26%20film/",
    },
    {
        name: "MARIO MORRIS MAGIC",
        events: [
            {
                stage: "THE GLEBE",
                day: "THURSDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "THE PAVEMENT",
                day: "WEDNESDAY",
                time: "17:45 - 18:15",
            },
            {
                stage: "BELLA'S FIELD",
                day: "THURSDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "14:30 - 15:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "14:30 - 15:00",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "12:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/mariomorrisevents/",
    },
    {
        name: "MARK GALLIE",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "16:38 - 17:03",
            },
        ],
        imgUrl: "",
        url: "https://www.iamloud.co/",
    },
    {
        name: "MARK OLVER (COMPERE)",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "22:30 - 02:00",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "14:25 - 14:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MARK SINCLAIR",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "00:00 - 03:00",
            },
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "13:00 - 14:10",
            },
        ],
        imgUrl: "",
        url: "http://djmarksinclair.com/",
    },
    {
        name: "MARTIN CRANDON",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "FRIDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "THE TAPHOUSE",
                day: "SUNDAY",
                time: "21:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/martincrandon/",
    },
    {
        name: "MARTIN STEPHENSON & THE DAINTEES",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "14:00 - 14:40",
            },
        ],
        imgUrl: "",
        url: "https://daintees.co.uk/home",
    },
    {
        name: "MARY BOURKE",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "19:50 - 20:20",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "18:10 - 18:40",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/marybourkecomic",
    },
    {
        name: "MARY HARP",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SATURDAY",
                time: "05:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/queerky.sets/",
    },
    {
        name: "MAS QUE NADA TAKEOVER FEATURING:\n - EIBHLIN\n - HOLLIE PROFIT\n - KYLE PARSLEY\n - JAY U\n - JUNIOR SIMBA\n - MAS QUE NADA BROTHERS\n - TOMMY TICKLE\n - TIBASKO",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "19:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://www.masquenada.co.uk/",
    },
    {
        name: "MASH P",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "00:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/wayoutmash/",
    },
    {
        name: "MASTER MUSICIANS OF JOUJOUKA",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "http://www.joujouka.org/",
    },
    {
        name: "MASTERS OF THE KAZOONIVERSE",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:20 - 17:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:20 - 17:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:20 - 17:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAT RICARDO",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "14:45 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.matricardo.com/",
    },
    {
        name: "MATT GINNO",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mattginno.com/",
    },
    {
        name: "MATT OWEN & THE D.V.P (NOAH & THE WHALE)",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "18:30 - 19:15",
            },
        ],
        imgUrl: "",
        url: "https://www.mattowensmusic.com/about",
    },
    {
        name: "MATTER",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "16:10 - 16:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MATTHEW ONE MAN",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "20:45 - 21:45",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAUVEY",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "23:50 - 00:30",
            },
            {
                stage: "BIMBLE INN",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mauvey.com/",
    },
    {
        name: "MAWAAN RIZWAN WITH MUSICIANS & DANCERS",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "23:20 - 00:00",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "21:30 - 22:10",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAX COOPER",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MAX RICHTER",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SATURDAY",
                time: "11:10 - 12:10",
            },
        ],
        imgUrl: "",
        url: "https://www.maxrichtermusic.com/",
    },
    {
        name: "MAXO\u00d9",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SATURDAY",
                time: "04:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/max0u___/",
    },
    {
        name: "MAYITO RIVERA & THE SONS OF CUBA",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "SUNDAY",
                time: "22:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "http://mayitorivera.net/",
    },
    {
        name: "MAZAIKA",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "23:00 - 00:15",
            },
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "13:15 - 13:45",
            },
        ],
        imgUrl: "",
        url: "http://mazaika-music.com/",
    },
    {
        name: "MAZE",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "SUNDAY",
                time: "02:15 - 03:30",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/maze-es",
    },
    {
        name: "MEARE GENTLEMAN'S SPORTS & LEISURE",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "12:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://babylonuprising.com/",
    },
    {
        name: "MEDLAR B2B NOWT",
        events: [
            {
                stage: "VILLAGE INN",
                day: "SUNDAY",
                time: "23:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/medlar",
    },
    {
        name: "MEEKZ",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "20:30 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MEG WARD",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "23:10 - 00:25",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/meggyward",
    },
    {
        name: "MEGA B2B ALL DJ\u2019S",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "18:30 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://(@xn--elizarosemuzik%29%20%20instagram%20photos%20and%20videos%20%20%20%20%20https-gb32c//www.instagram.com/jeanie_crystal/",
    },
    {
        name: "MEGAN LANGLOIS",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/watch?v=hfpioqmdwyq",
    },
    {
        name: "MELANIE C",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SATURDAY",
                time: "21:35 - 22:35",
            },
        ],
        imgUrl: "",
        url: "https://melaniec.net/",
    },
    {
        name: "MELLA DEE",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "01:40 - 02:55",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/melladee_/",
    },
    {
        name: "MELLA DEE B2B TAI LOKUN",
        events: [
            {
                stage: "THE LEVELS",
                day: "SUNDAY",
                time: "14:30 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MELLOWMATIC",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "FRIDAY",
                time: "20:00 - 20:30",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "FRIDAY",
                time: "18:30 - 19:00",
            },
            {
                stage: "THE GATEWAY",
                day: "THURSDAY",
                time: "14:35 - 15:20",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "17:45 - 18:30",
            },
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "13:15 - 14:20",
            },
        ],
        imgUrl: "",
        url: "https://www.mellowmaticmusic.com/",
    },
    {
        name: "MEMORIES 'PODCAST' WITH KERRY GODLIMAN & JEN BRISTER",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "13:00 - 13:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MENS CIRCLE WITH JULIAN VON DUEFFEL",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "FRIDAY",
                time: "12:30 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/julian_vondueffel",
    },
    {
        name: "MERCADONEGRO",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "FRIDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.mercadonegro.ch/",
    },
    {
        name: "MERCEDES BENSON",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MEREKI",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "15:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.merekimusic.com/",
    },
    {
        name: "MERRY GO ROUND",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "12:00 - 17:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "12:00 - 17:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SUNDAY",
                time: "12:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://nil/",
    },
    {
        name: "MERRY MCCLOUD",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MERRY MCLOUD",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://suriyarecordings.bandcamp.com/album/the-false-bride",
    },
    {
        name: "MESSY NESSIE",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MEYNELL GAMES",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MICA PARIS",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SUNDAY",
                time: "21:20 - 22:20",
            },
        ],
        imgUrl: "",
        url: "https://www.micaparis.com/",
    },
    {
        name: "MICHAEL BAKER",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "18:00 - 18:45",
            },
        ],
        imgUrl: "",
        url: "https://michaelbaker.komi.io/",
    },
    {
        name: "MICHAEL UPSON",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "THURSDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/michaelupson",
    },
    {
        name: "MICHELE & ROMEO STODART (MAGIC NUMBERS & FRIENDS)",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "01:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/themagicnumbers",
    },
    {
        name: "MICHELE STODART",
        events: [
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "18:15 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.michelestodart.com/",
    },
    {
        name: "MIDLAND",
        events: [
            {
                stage: "IICON",
                day: "THURSDAY",
                time: "20:00 - 21:15",
            },
            {
                stage: "NYC DOWNLOW",
                day: "FRIDAY",
                time: "02:50 - 04:15",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/midland",
    },
    {
        name: "MIDNIGHT PLAYGROUND",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "WEDNESDAY",
                time: "22:30 - 00:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "23:00 - 01:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "23:00 - 01:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "23:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.themidnightplayground.com/",
    },
    {
        name: "MIDNIGHT ZU",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "18:00 - 18:50",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/themidnightzu",
    },
    {
        name: "MIGHTY J VS TILLY B",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "11:50 - 12:00",
            },
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "11:50 - 12:00",
            },
            {
                stage: "BABYLON UPRISING",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://babylonuprising.com/",
    },
    {
        name: "MIK ARTISTIK",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mikartistik.com/",
    },
    {
        name: "MIK ARTISTIK'S EGO TRIP",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mikartistik.com/live",
    },
    {
        name: "MIKE DENNIS",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SATURDAY",
                time: "14:30 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://bowjangles.org/",
    },
    {
        name: "MIKE FREEAR",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "00:45 - 01:15",
            },
        ],
        imgUrl: "",
        url: "https://continentaldrifts.co.uk/artist/chris-tofu/https://www.johnswale.com/",
    },
    {
        name: "MIKE FREEAR AND REBECCA CROW PRESSENT TAPE DECK TAROT",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "01:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kingkatherine_/?hl=enhttps://www.instagram.com/freear/?hl=en",
    },
    {
        name: "MIKE SKINNER",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MIKI BERENYI",
        events: [
            {
                stage: "FREE UNIVERSITY OF GLASTONBURY",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/berenyi_miki?lang=en",
    },
    {
        name: "MILF FM TAKOVER",
        events: [
            {
                stage: "BLIND TIGER",
                day: "FRIDAY",
                time: "20:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MILLIE MCKEE",
        events: [
            {
                stage: "SAN REMO",
                day: "SUNDAY",
                time: "12:00 - 14:00",
            },
            {
                stage: "PLATFORM 23",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/millimckee/",
    },
    {
        name: "MILLIE WATSON",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MILLY ON AIR",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "FRIDAY",
                time: "03:00 - 04:30",
            },
        ],
        imgUrl: "",
        url: "https://bandcamp.com/mlyc%20https://www.instagram.com/milly_on_air_/?hl=en",
    },
    {
        name: "MIMI'S",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "22:55 - 00:00",
            },
        ],
        imgUrl: "",
        url: "http://www.thecashcowsrock.com/",
    },
    {
        name: "MINISTRY OF HAPPY",
        events: [
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "12:00 - 12:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "12:00 - 12:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:00 - 12:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MISTA TRICK COLLECTIVE",
        events: [
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "20:15 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://mistatrick.com/",
    },
    {
        name: "MITCHELL & VINCENT",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "14:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MITZI",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "02:00 - 02:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/mitzi_sw/",
    },
    {
        name: "MIYAM JAPANESE JUGGLER",
        events: [
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "16:45 - 17:15",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "16:10 - 16:40",
            },
            {
                stage: "THE GLEBE",
                day: "SUNDAY",
                time: "15:00 - 15:30",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "14:20 - 14:50",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "14:20 - 14:50",
            },
            {
                stage: "THE PAVEMENT",
                day: "SUNDAY",
                time: "12:35 - 13:05",
            },
        ],
        imgUrl: "",
        url: "https://miyamu.jimdo.com/",
    },
    {
        name: "MK",
        events: [
            {
                stage: "ARCADIA",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/marckinchen/",
    },
    {
        name: "MO'S MOSAICS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MOANING LISA AND LEO",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "18:30 - 19:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:45 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "18:30 - 19:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:45 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:30 - 19:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:45 - 16:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MOBO UNSUNG SHOWCASE: CRAE WOLF, DJ SAV SIMMS, MACE THE GREAT, SARAH IKUMU, ZITAH",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MODULAR ADVENTURES WITH KAFF BENDERS",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "10:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/joe_hot_chip/?hl=en",
    },
    {
        name: "MOLLIE RUSH",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "THURSDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://on.soundcloud.com/wbiya",
    },
    {
        name: "MOLLY SCOTT CATO",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "10:00 - 11:00",
            },
        ],
        imgUrl: "",
        url: "http://people%2C%20energy%20%26%20ownership/",
    },
    {
        name: "MOLLY WHITEHOUSE",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "19:24 - 19:30",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "16:12 - 16:18",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "14:35 - 14:41",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "19:56 - 20:02",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "16:37 - 16:43",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "16:04 - 16:10",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/mollywhitehouse/",
    },
    {
        name: "MONROLLER",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SUNDAY",
                time: "03:00 - 03:45",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/monroller_uk_?igshid=ymmymta2m2y=",
    },
    {
        name: "MOOD II SWING",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "FRIDAY",
                time: "01:00 - 02:45",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/moodiiswing",
    },
    {
        name: "MOONSHINE MALARKEY",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MORE TIME RECORDS TAKEOVER: AHADADREAM B2B SAM INTERFACE B2B A\u00c6E, FIYAHDRED, KASS KASS RIZER, SHANNEN SP",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "SUNDAY",
                time: "12:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MORNING SIDE",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "11:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MORNING SINGALONG",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "09:30 - 10:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MORNING TOURIST",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "10:55 - 11:25",
            },
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "12:00 - 12:40",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/morningtourist",
    },
    {
        name: "MOSS KISSING",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/moss_kissing",
    },
    {
        name: "MOTH PHYSICAL THEATRE",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MOTHER EARTH TBA",
        events: [
            {
                stage: "FLYING BUS",
                day: "SATURDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/motherearth",
    },
    {
        name: "MOTHER SKY",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SUNDAY",
                time: "13:00 - 13:30",
            },
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MOTU",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/motu_sw/",
    },
    {
        name: "MOVE YOURSELF BY THE MEDIA WORKSHOP",
        events: [
            {
                stage: "GLEBELAND",
                day: "WEDNESDAY",
                time: "22:30 - 04:30",
            },
            {
                stage: "GLEBELAND",
                day: "THURSDAY",
                time: "22:30 - 04:30",
            },
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "22:30 - 04:30",
            },
            {
                stage: "GLEBELAND",
                day: "SATURDAY",
                time: "22:30 - 04:30",
            },
            {
                stage: "GLEBELAND",
                day: "SUNDAY",
                time: "22:30 - 04:30",
            },
        ],
        imgUrl: "",
        url: "https://www.themediaworkshop.co.uk/",
    },
    {
        name: "MOVIMIENTOS TAKEOVER: CAL JADER, BUSHBBY, IVICORE, PAPAOUL",
        events: [
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "14:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/movimientoslondon/",
    },
    {
        name: "MOXIE",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SUNDAY",
                time: "23:15 - 00:25",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/moxie",
    },
    {
        name: "MOXIE B2B LEON VYNEHALL",
        events: [
            {
                stage: "THE WOW",
                day: "SATURDAY",
                time: "19:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MOZART ESTATE",
        events: [
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "15:45 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MR BANANA SHOW",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "12:40 - 13:10",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "18:46 - 19:16",
            },
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "16:10 - 16:40",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "15:00 - 15:30",
            },
            {
                stage: "THE GLEBE",
                day: "SUNDAY",
                time: "17:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.ahumaproductions.com/",
    },
    {
        name: "MR BANANASHOW",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "15:31 - 16:01",
            },
        ],
        imgUrl: "",
        url: "https://www.ahumaproductions.com/",
    },
    {
        name: "MR BURN - RAMSHACKLICIOUS",
        events: [
            {
                stage: "THE GLEBE",
                day: "THURSDAY",
                time: "21:15 - 21:45",
            },
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "21:15 - 21:45",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "21:15 - 21:45",
            },
        ],
        imgUrl: "",
        url: "http://www.ramshacklicious.com/",
    },
    {
        name: "MR CARROT",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MR KEY",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "17:15 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/lukekeysmb/",
    },
    {
        name: "MR PEEWEE AND THE DRUMMING PUPPET",
        events: [
            {
                stage: "CROONER'S CORNER",
                day: "THURSDAY",
                time: "12:15 - 12:45",
            },
            {
                stage: "THE PAVEMENT",
                day: "WEDNESDAY",
                time: "18:20 - 18:50",
            },
            {
                stage: "BELLA'S FIELD",
                day: "THURSDAY",
                time: "15:00 - 15:30",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "12:15 - 12:45",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "12:15 - 12:45",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "16:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MR PEEWEE DRUMMING PUPPET",
        events: [
            {
                stage: "CROONER'S CORNER",
                day: "FRIDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SATURDAY",
                time: "13:45 - 14:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SUNDAY",
                time: "12:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/thedrummingpuppet/",
    },
    {
        name: "MR PINKS",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "12:00 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://m.mixcloud.com/misterpinksdj/",
    },
    {
        name: "MR REDLEY",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "13:30 - 15:00",
            },
            {
                stage: "THE MEAT RACK",
                day: "THURSDAY",
                time: "21:30 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/mrredley",
    },
    {
        name: "MR TOOLEY",
        events: [
            {
                stage: "DELUXE DINER",
                day: "FRIDAY",
                time: "21:00 - 22:30",
            },
            {
                stage: "DELUXE DINER",
                day: "SATURDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MR WOLF COLLECTIVE",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MUDD CLUB",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.themuddclubband.com/",
    },
    {
        name: "MULTIPLICITY OF NATURE: QUEER AND TRANS LIBERATION, RACIAL JUSTICE, AFRO-FUTURISM \n A DAY OF CREATIVE WORKSHOPS, TALKS AND DROP-IN ACTTIVITIES HOSTED BY LION - LAND IN OUR NAMES.",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "12:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MURMURATION OWL & PUSSYCAT",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MURRAY LACHLAN YOUNG",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "17:34 - 18:07",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/murrayly/",
    },
    {
        name: "MUSIC HOUSE FOR CHILDREN",
        events: [
            {
                stage: "LITTLE KIDZ AREA",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MUSIC MIKE",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MUSIC OF PLANTS",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "11:45 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/pages/keryda/1581443128776181?fref=ts",
    },
    {
        name: "MUSIC: BILL LLOYD AND MARNIE KAPUTSTINSKY",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "FRIDAY",
                time: "14:45 - 15:15",
            },
            {
                stage: "ATCHIN TAN",
                day: "SUNDAY",
                time: "14:45 - 15:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MUSIC: OPEN SESSION SINGAROUND",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "SUNDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MUSIC: OPEN SESSION, GUESTS AND THE GORJA BAND",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "THURSDAY",
                time: "18:00 - 19:30",
            },
            {
                stage: "ATCHIN TAN",
                day: "FRIDAY",
                time: "18:00 - 19:30",
            },
            {
                stage: "ATCHIN TAN",
                day: "SATURDAY",
                time: "18:00 - 19:30",
            },
            {
                stage: "ATCHIN TAN",
                day: "SUNDAY",
                time: "18:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MUSIC: PADDY ROGAN",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "THURSDAY",
                time: "14:45 - 15:15",
            },
            {
                stage: "ATCHIN TAN",
                day: "SATURDAY",
                time: "16:30 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MUSIC: TERENA WORLIDGE / LEARN TO PLAY THE TIN WHISTLE",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "SATURDAY",
                time: "14:45 - 15:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MUSIC: THE GORJA BAND",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "THURSDAY",
                time: "12:30 - 13:00",
            },
            {
                stage: "ATCHIN TAN",
                day: "FRIDAY",
                time: "12:30 - 13:00",
            },
            {
                stage: "ATCHIN TAN",
                day: "SATURDAY",
                time: "12:30 - 13:00",
            },
            {
                stage: "ATCHIN TAN",
                day: "SUNDAY",
                time: "12:30 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MUSIC: THOMAS MCCARTHY",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "THURSDAY",
                time: "17:00 - 17:45",
            },
            {
                stage: "ATCHIN TAN",
                day: "FRIDAY",
                time: "17:00 - 17:45",
            },
            {
                stage: "ATCHIN TAN",
                day: "SATURDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://thomasmccarthyfolk.com/",
    },
    {
        name: "MUSICA/NORDOFF-ROBBINS",
        events: [
            {
                stage: "MUZIKADEMY",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MY NU LENG",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://my%20nu%20leng%20(@mynuleng%29%20%7C%20instagram/",
    },
    {
        name: "MY-R FT. KRAYZ-LEGZ",
        events: [
            {
                stage: "THE TEMPLE",
                day: "THURSDAY",
                time: "01:15 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/krayzlegz/",
    },
    {
        name: "MYA-ROSE CRAIG IN CONVERSATION WITH GREENPEACE UK CO-EXECUTIVE DIRECTOR, AREEBA HAMID",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "MYSTICAL BEAST WANDS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "M\u00c5NESKIN",
        events: [
            {
                stage: "WOODSIES",
                day: "SATURDAY",
                time: "19:30 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/maneskinofficial/",
    },
    {
        name: "N'FAMADY KOUYAT\u00c9",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "12:30 - 13:15",
            },
            {
                stage: "CROISSANT NEUF",
                day: "SATURDAY",
                time: "23:30 - 00:30",
            },
            {
                stage: "AVALON STAGE",
                day: "SUNDAY",
                time: "11:30 - 12:10",
            },
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "20:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.nfamady.com/",
    },
    {
        name: "N4 RECORDS TAKEOVER - SAMURAI BREAKS, BENTON, IVAN CARGO & MORE!",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "20:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://n4records.bandcamp.com/",
    },
    {
        name: "NADINE NOOR",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/nadine_noor/",
    },
    {
        name: "NAD\u00cf",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/nadi_bpm/",
    },
    {
        name: "NAD\u012a",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "14:30 - 15:25",
            },
        ],
        imgUrl: "",
        url: "https://www.thisisnadi.com/",
    },
    {
        name: "NAKEDPRESENTS",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://nakedpresents.co.uk/",
    },
    {
        name: "NAOMI KIMPENU (ETC FINALIST)",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "12:10 - 12:40",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/naomikimpenu?igshid=ymmymta2m2y=",
    },
    {
        name: "NAPES",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SUNDAY",
                time: "00:00 - 00:45",
            },
        ],
        imgUrl: "",
        url: "https://on.soundcloud.com/wn3ncxsa27miy5za6",
    },
    {
        name: "NARX",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "00:30 - 02:00",
            },
            {
                stage: "NOWHERE",
                day: "SUNDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NATALIE CHARMERS",
        events: [
            {
                stage: "STORYTELLERS LOUNGE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NATSUMA",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/channel/ucdv7ej0sdzd2q8sdxyed8lg",
    },
    {
        name: "NATURAL DIVERSIONS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "11:30 - 12:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:50 - 14:35",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:45 - 12:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:45 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://naturaltheatre.co.uk/",
    },
    {
        name: "NATURAL THEATRE COMPANY",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "11:30 - 12:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:30 - 12:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:30 - 12:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:30 - 12:15",
            },
        ],
        imgUrl: "",
        url: "https://naturaltheatre.co.uk/",
    },
    {
        name: "NAYTIIVE",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SUNDAY",
                time: "23:30 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/naytiive",
    },
    {
        name: "NCT BABY CARE TENT",
        events: [
            {
                stage: "LITTLE KIDZ AREA",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NDA: ABBIE MCCARTHY BIRTHDAY PARTY",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "17:45 - 18:45",
            },
        ],
        imgUrl: "",
        url: "https://abbiemccarthy.co.uk/",
    },
    {
        name: "NEMO & CASTRO",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SUNDAY",
                time: "22:00 - 23:10",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/nemo%20https://ra.co/dj/castromoore",
    },
    {
        name: "NEMZZZ",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "19:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NEON MOON",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "01:35 - 01:50",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "00:25 - 00:40",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "23:05 - 23:20",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "01:35 - 01:50",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "00:00 - 00:15",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "22:45 - 23:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "00:30 - 01:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "23:30 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://www.neonmoon.co.uk/",
    },
    {
        name: "NEVILLE STAPLE - FROM THE SPECIALS",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SUNDAY",
                time: "22:50 - 23:50",
            },
        ],
        imgUrl: "",
        url: "http://www.fromthespecials.com/",
    },
    {
        name: "NEW YORK BRASS BAND",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "SUNDAY",
                time: "04:00 - 05:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "23:45 - 00:40",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "23:45 - 00:40",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "20:14 - 20:59",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "20:12 - 20:57",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "20:24 - 21:09",
            },
            {
                stage: "THE GATEWAY",
                day: "THURSDAY",
                time: "13:10 - 13:55",
            },
            {
                stage: "THE GATEWAY",
                day: "FRIDAY",
                time: "16:40 - 17:25",
            },
            {
                stage: "THE GATEWAY",
                day: "SATURDAY",
                time: "17:25 - 18:10",
            },
            {
                stage: "THE GATEWAY",
                day: "SUNDAY",
                time: "17:10 - 17:55",
            },
        ],
        imgUrl: "",
        url: "https://www.newyorkbrassband.co.uk/",
    },
    {
        name: "NEWTON FAULKNER",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/newtonfaulkner",
    },
    {
        name: "NEXT LEVEL PRESENTS: ASHER SIMMONS, B3NJI, REBEKAH DINNALL,G U Y, RED, SOLO JANE",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NGAIO (LIVE)",
        events: [
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "12:35 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://ngaiomusic.com/",
    },
    {
        name: "NIA ARCHIVES",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NIA ARCHIVES PRESENTS UP YA ARCHIVES: NIA ARCHIVES, IZCO & REEK0, VANESSA MARIA",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "00:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NICADA TRAD PUNCH & JUDY",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SATURDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NICK DAVIES, KIRSTY KENNEY & AJAI AHLUWALIA",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SUNDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://2033%20no%20uk%20fossil%20fuels/",
    },
    {
        name: "NICK MAY- EX WHIMWISE",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NICK THE HEDGE",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NIEVE ELLA",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "FRIDAY",
                time: "14:00 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.nieveella.com/",
    },
    {
        name: "NIGEL SHAW",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SUNDAY",
                time: "11:45 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://seventhwavemusic.com/",
    },
    {
        name: "NII AYIKWEI PARKES",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "15:51 - 16:21",
            },
        ],
        imgUrl: "",
        url: "https://www.niiparkes.com/",
    },
    {
        name: "NIK WARD",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "11:10 - 11:40",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/niksmusic.co.uk",
    },
    {
        name: "NIKI STEVENS",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/nikistevens",
    },
    {
        name: "NIKKI NAIR B2B WAGER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "17:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/nikki__nair/%20https://www.instagram.com/wagerdj/",
    },
    {
        name: "NIKS",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "SUNDAY",
                time: "23:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/niks%20https://blackartistdatabase.co/?#/",
    },
    {
        name: "NINA CONTI",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "16:25 - 16:55",
            },
        ],
        imgUrl: "",
        url: "https://www.ninaconti.net/",
    },
    {
        name: "NINJA RIVER",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SUNDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/indyflows/",
    },
    {
        name: "NINOTCHKA",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "18:05 - 18:35",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "11:45 - 12:15",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "15:00 - 15:40",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/ninotchkaband",
    },
    {
        name: "NIPSY",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "10:00 - 12:00",
            },
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "14:00 - 16:00",
            },
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "10:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/nipsyiow",
    },
    {
        name: "NISH KUMAR",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "17:40 - 18:10",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NO STRINGS PUPPETS",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SATURDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NOBLE AND HEATH",
        events: [
            {
                stage: "DELUXE DINER",
                day: "FRIDAY",
                time: "03:00 - 04:30",
            },
            {
                stage: "DELUXE DINER",
                day: "THURSDAY",
                time: "01:30 - 03:00",
            },
            {
                stage: "DELUXE DINER",
                day: "SUNDAY",
                time: "23:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NOEL FITZPATRICK SUPER VET",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NOEL WATSON",
        events: [
            {
                stage: "DELUXE DINER",
                day: "SATURDAY",
                time: "00:00 - 01:30",
            },
            {
                stage: "DELUXE DINER",
                day: "FRIDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NOFIT HOWIE",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "13:21 - 13:29",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "13:27 - 13:35",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "13:01 - 13:09",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NONSENSE YOGA",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:20 - 15:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:20 - 16:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:10 - 13:55",
            },
        ],
        imgUrl: "",
        url: "http://www.petethetemp.co.uk/om-skanky-the-nonsense-yoga-show/",
    },
    {
        name: "NOONA'S PUPPET STEW",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NOORIYAH PRESENTS MIDDLE OF NOWHERE: FRESHTA, NOORIYAH, PEKODJINN",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "THURSDAY",
                time: "18:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NORSICAA",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "THURSDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NORTHBASE B2B MARK XTC",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "12:30 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/markxtc",
    },
    {
        name: "NOT BAD FOR A GIRL PRESENTS: COLLECTIVE POWER! HOW TO RUN YOUR OWN DJ COLLECTIVE",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "FRIDAY",
                time: "16:30 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/notbadforagirlmcr/",
    },
    {
        name: "NOTTING HILL CARNIVAL - SUPER SOCA SHOW",
        events: [
            {
                stage: "THE BUG",
                day: "THURSDAY",
                time: "13:00 - 15:00",
            },
            {
                stage: "THE BUG",
                day: "SUNDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://nhcarnival.org/",
    },
    {
        name: "NOTTING HILL CARNIVAL SOUND SYSTEM PAYS TRIBUTE TO CARNIVAL PIONEER & LEGEND JAH SHAKA",
        events: [
            {
                stage: "NOTTING HILL CARNIVAL SOUNDSYSTEM",
                day: "SATURDAY",
                time: "16:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/jahshakamusic/?locale=en_gb",
    },
    {
        name: "NOVA TWINS",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SUNDAY",
                time: "13:45 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://novatwins.co.uk/",
    },
    {
        name: "NOVARA MEDIA PRESENT : THE DUSTBIN OF HISTORY - ARTIFICIAL INTELLIGENCE",
        events: [
            {
                stage: "NOMAD",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://novaramedia.com/",
    },
    {
        name: "NOVARA MEDIA PRESENT : THE DUSTBIN OF HISTORY - LANDLORDS",
        events: [
            {
                stage: "NOMAD",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NOVARA MEDIA PRESENT : THE DUSTBIN OF HISTORY - MASCULINITY",
        events: [
            {
                stage: "NOMAD",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "NOVARA MEDIA PRESENT : THE DUSTBIN OF HISTORY - POLICE",
        events: [
            {
                stage: "NOMAD",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://novaramedia.com/",
    },
    {
        name: "NOWT",
        events: [
            {
                stage: "TOLPUDDLE",
                day: "FRIDAY",
                time: "15:30 - 17:30",
            },
            {
                stage: "TOLPUDDLE",
                day: "SATURDAY",
                time: "19:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/nowttunes/",
    },
    {
        name: "NULA HULA SHOW",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "16:50 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/nulahula",
    },
    {
        name: "NUTKHUT - SWYRON",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "21:45 - 22:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:10 - 17:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "21:45 - 22:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:10 - 17:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "21:45 - 22:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "17:10 - 17:55",
            },
        ],
        imgUrl: "",
        url: "https://www.nutkhut.co.uk/",
    },
    {
        name: "O.P. GROOVER & PUTTYRUBBER",
        events: [
            {
                stage: "THE HIVE",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/opgroover/",
    },
    {
        name: "O.P. GROOVER + PUTTYRUBBER (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/opgroover",
    },
    {
        name: "OBONGJAYAR",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SATURDAY",
                time: "16:45 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://obongjay.ar/",
    },
    {
        name: "OBRA",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/electricbluedog1/",
    },
    {
        name: "OCTOGON",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "19:15 - 20:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OFF YELLOW RADIO X NATTY SPEAKS + SPECIAL GUESTS",
        events: [
            {
                stage: "NOMAD",
                day: "SUNDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/offyellowradio/?hl=en",
    },
    {
        name: "OGAZ\u00d3N",
        events: [
            {
                stage: "THE WOW",
                day: "SUNDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OH ANNIE OH",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/ohannieoh/",
    },
    {
        name: "OH JEREMY CORBYN - THE BIG LIE 18",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SUNDAY",
                time: "14:45 - 16:35",
            },
        ],
        imgUrl: "",
        url: "https://www.platformfilms.co.uk/",
    },
    {
        name: "OH MY GOD! IT'S THE CHURCH",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "23:25 - 00:25",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "00:25 - 01:25",
            },
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.sexy-jesus.com/#oh-my-god",
    },
    {
        name: "OLD BABY MACKEREL",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "12:30 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.oldbabymackerel.com/",
    },
    {
        name: "OLD SKOOL DANCE PARTY W/ FRAME + PETE WHEELER",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "FRIDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OLD TIME RAGS TRIO",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OLD TIME SAILORS",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "THURSDAY",
                time: "21:45 - 22:45",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "15:00 - 15:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "THURSDAY",
                time: "15:55 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://oldtimesailors.com/",
    },
    {
        name: "OLD TIME SAILORS!",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://oldtimesailors.com/",
    },
    {
        name: "OLE",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "17:30 - 18:30",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "17:30 - 18:30",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "16:40 - 17:40",
            },
        ],
        imgUrl: "",
        url: "https://olecomedy.com/",
    },
    {
        name: "OLI LAMBOURNE - CIRK HES (NEXT GEN)",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "20:20 - 20:26",
            },
        ],
        imgUrl: "",
        url: "https://www.circusworksdevoran.org/",
    },
    {
        name: "OLIVE BPM VS MOMO TRACTOR BOY",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "FRIDAY",
                time: "02:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OLIVER SUDDEN",
        events: [
            {
                stage: "TOLPUDDLE",
                day: "SATURDAY",
                time: "21:30 - 23:30",
            },
            {
                stage: "TOLPUDDLE",
                day: "SUNDAY",
                time: "17:30 - 19:30",
            },
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "10:00 - 12:00",
            },
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "14:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/cronxdon",
    },
    {
        name: "OLIVER SUDDEN 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "18:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/cronxdon",
    },
    {
        name: "OLIVIA DEAN",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "18:00 - 18:45",
            },
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SATURDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OPEN",
        events: [
            {
                stage: "BIMBLE INN",
                day: "WEDNESDAY",
                time: "12:00 - 03:00",
            },
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "12:00 - 14:00",
            },
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "12:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.bimbleinn.com/",
    },
    {
        name: "OPEN CONVERSATION: WHERE DO WE GO FROM HERE",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OPEN FORUM: WHERE DO WE GO FROM HERE?",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "SUNDAY",
                time: "15:15 - 16:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OPEN MIC",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SUNDAY",
                time: "17:00 - 17:30",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SUNDAY",
                time: "12:30 - 13:00",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "12:56 - 13:56",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OPENING CEREMEONY MAIN SITE",
        events: [
            {
                stage: "TOAD HALL",
                day: "WEDNESDAY",
                time: "22:30 - 23:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OPTIMO",
        events: [
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/optimoespacio/?hl=en",
    },
    {
        name: "OR:LA",
        events: [
            {
                stage: "THE WOW",
                day: "FRIDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ORAM",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SUNDAY",
                time: "01:30 - 02:15",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/oramdnb?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
    },
    {
        name: "ORCA SOUND",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "00:15 - 01:25",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/iamorcasound",
    },
    {
        name: "ORIGINAL MIXTURE",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:15 - 18:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:00 - 12:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:15 - 18:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:00 - 12:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "17:15 - 18:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:00 - 12:45",
            },
        ],
        imgUrl: "",
        url: "https://originalmixture.co.uk/",
    },
    {
        name: "OSCAR BROWN",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/watch?v=qvivwimdopg",
    },
    {
        name: "OTHER HALF PRODUCTIONS - STORM IN A TEACUP",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:50 - 16:50",
            },
        ],
        imgUrl: "",
        url: "https://www.otherhalfproductions.com/",
    },
    {
        name: "OTHER HALF PRODUCTIONS- STORM IN A TEACUP",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "12:00 - 13:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:50 - 16:50",
            },
        ],
        imgUrl: "",
        url: "https://www.otherhalfproductions.com/",
    },
    {
        name: "OTHERWORLD ARTS",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "OUISSAM",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "THURSDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/ouissam/biography",
    },
    {
        name: "OUT OF SORTS RECORDS",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/outofsortsrecs/",
    },
    {
        name: "OVEREASY DJS",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "THE MEETING PLACE BAR",
                day: "THURSDAY",
                time: "14:00 - 17:00",
            },
            {
                stage: "THE MEETING PLACE BAR",
                day: "SATURDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/overeasydjs/",
    },
    {
        name: "OZMOSES",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "14:30 - 15:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "18:15 - 19:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:30 - 15:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "18:15 - 19:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:30 - 15:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/ozmosesmagi/",
    },
    {
        name: "P MONEY AND WHINEY",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "http://p%20money%20(@xn--kingpmoney%29%20%20instagram%20photos%20and%20videos-fn46a/",
    },
    {
        name: "P-RALLEL",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "19:35 - 20:50",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/paralleltheory/",
    },
    {
        name: "PADDY STEER",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "SUNDAY",
                time: "01:30 - 02:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PAIGE TOMLINSON",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "22:15 - 23:20",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/paigetomlinson_dj/",
    },
    {
        name: "PALE BLUE EYES",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "15:15 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/pbemusic",
    },
    {
        name: "PALE STRANGER",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "13:15 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://palestranger.bandcamp.com/",
    },
    {
        name: "PALE WAVES",
        events: [
            {
                stage: "WOODSIES",
                day: "FRIDAY",
                time: "16:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.palewaves.co.uk/",
    },
    {
        name: "PALMS TRAX",
        events: [
            {
                stage: "SAN REMO",
                day: "SUNDAY",
                time: "01:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/palmstrax/?hl=en",
    },
    {
        name: "PALMS TRAX B2B JOB JOBSE",
        events: [
            {
                stage: "THE LEVELS",
                day: "THURSDAY",
                time: "19:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PANDA AND THE MONIUMS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "15:45 - 16:45",
            },
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "17:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/pandaandthemoniums/",
    },
    {
        name: "PANEL DISCUSSION BIRTH THE NEW EARTH",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "FRIDAY",
                time: "15:45 - 17:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PANEL DISCUSSION PLANTS FOR MAGIC & MEDICINE",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "SATURDAY",
                time: "14:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PANIC SHACK",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "22:00 - 22:30",
            },
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "20:00 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/panicshack",
    },
    {
        name: "PAPA NUGS",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/papanugs/",
    },
    {
        name: "PARADE SIRENS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PARANOID LONDON (LIVE)",
        events: [
            {
                stage: "THE LEVELS",
                day: "THURSDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PARANOID LONDON LIVE",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "04:30 - 06:00",
            },
        ],
        imgUrl: "",
        url: "http://paranoid%20london%20(@paranoid_london%29%20%7C%20instagram/",
    },
    {
        name: "PARAORCHESTRA - SMOOSH!",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "18:22 - 19:07",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PARRIS",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "18:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/parris.dj/?hl=en",
    },
    {
        name: "PARTOK",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "FRIDAY",
                time: "04:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/partok",
    },
    {
        name: "PATRICK GREENFIELD",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "http://carbon%20off-setting%20pirates/",
    },
    {
        name: "PAUL CARRACK",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "21:30 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://www.paulcarrack.net/",
    },
    {
        name: "PAUL CURRIE",
        events: [
            {
                stage: "THE PAVEMENT",
                day: "WEDNESDAY",
                time: "15:10 - 15:40",
            },
            {
                stage: "THE PAVEMENT",
                day: "THURSDAY",
                time: "13:10 - 13:40",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "16:55 - 17:25",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "14:55 - 15:25",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "THURSDAY",
                time: "14:45 - 15:15",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "14:55 - 15:25",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "13:10 - 13:40",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PAUL FOOT",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "17:00 - 17:40",
            },
        ],
        imgUrl: "",
        url: "https://www.paulfoot.tv/",
    },
    {
        name: "PAUL LAMBOURNE",
        events: [
            {
                stage: "CROONER'S CORNER",
                day: "THURSDAY",
                time: "17:45 - 18:15",
            },
            {
                stage: "CROONER'S CORNER",
                day: "THURSDAY",
                time: "14:00 - 14:30",
            },
            {
                stage: "CROONER'S CORNER",
                day: "FRIDAY",
                time: "16:30 - 17:00",
            },
            {
                stage: "CROONER'S CORNER",
                day: "FRIDAY",
                time: "13:00 - 13:30",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SATURDAY",
                time: "17:30 - 18:00",
            },
            {
                stage: "CROONER'S CORNER",
                day: "SATURDAY",
                time: "12:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PAUL MOROCCO & MARCIAL HEREDIA - OLE!",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://olecomedy.com/",
    },
    {
        name: "PAULA TAPE",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "20:30 - 22:00",
            },
            {
                stage: "THE WOW",
                day: "SATURDAY",
                time: "21:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PAULINE CORDINER",
        events: [
            {
                stage: "STORYTELLERS LOUNGE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PAUL\u2019S MOBILE DISCO",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "16:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PAVEL PLASTIKK",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/pavelplastikk",
    },
    {
        name: "PEARL",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "THURSDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/pearlectro/",
    },
    {
        name: "PEBBLES, BUBBLES AND BRACELETS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PEEWEE (COMPERE)",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "23:32 - 02:00",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "23:30 - 23:35",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "23:32 - 01:52",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PENG DELI: DREAM MCLEAN, HARLEY MAXWELL, WALLACE RICE, DAME, PADDY BARS, STRAYWAVE",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/pengdeli",
    },
    {
        name: "PERRI KAYE",
        events: [
            {
                stage: "DELUXE DINER",
                day: "THURSDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "DELUXE DINER",
                day: "FRIDAY",
                time: "01:30 - 03:00",
            },
            {
                stage: "DELUXE DINER",
                day: "SUNDAY",
                time: "21:30 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PETE & BAS",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "01:15 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/pete_and_bas/",
    },
    {
        name: "PETE ANDERSON (COMPERE)",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "12:00 - 18:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "12:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PETE GASKELL & HIS BAGGY TROUSERED PHILANTHROPISTS",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PETE SINCLAIR AS NEIL DIAMOND",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "21:50 - 22:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PETE THE TEMP",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "http://www.petethetemp.co.uk/",
    },
    {
        name: "PETER HEMSLEY",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "02:00 - 02:45",
            },
        ],
        imgUrl: "",
        url: "http://www.petehemsley.com/",
    },
    {
        name: "PHIL HARTNOLL (ORBITAL)",
        events: [
            {
                stage: "FLYING BUS",
                day: "SUNDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PHIL HARTNOLL (ORBITAL) DJ SET",
        events: [
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "03:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/phil-hartnoll-orbital/",
    },
    {
        name: "PHIL KING",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "11:45 - 12:15",
            },
        ],
        imgUrl: "",
        url: "http://www.phil-king.net/",
    },
    {
        name: "PHIL WANG",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "21:00 - 21:30",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "18:45 - 19:15",
            },
        ],
        imgUrl: "",
        url: "https://www.philwang.co.uk/",
    },
    {
        name: "PHILL WELCH & MASLOW UNKNOWN",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "14:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://www.phillcreatesstudio.co.uk/",
    },
    {
        name: "PHOEBE WESTON",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "http://the%20crisis%20in%20nature/",
    },
    {
        name: "PHOENIX",
        events: [
            {
                stage: "WOODSIES",
                day: "SUNDAY",
                time: "21:30 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://wearephoenix.com/",
    },
    {
        name: "PICNIC DAYTIME TAKEOVER: GENE ON EARTH, ANDY LUFF B2B TRULY MADLY, MOTHER EARTH",
        events: [
            {
                stage: "THE WOW",
                day: "SUNDAY",
                time: "12:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PIGEON",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "17:30 - 18:00",
            },
            {
                stage: "SWEET CHARITY",
                day: "THURSDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PIRATE TAXI",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SUNDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "18:00 - 18:40",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PIXELS TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SUNDAY",
                time: "15:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/pixels_bris/",
    },
    {
        name: "PLACID",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "FRIDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/placid",
    },
    {
        name: "PLANETA POLAR",
        events: [
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "WEDNESDAY",
                time: "20:15 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://www.planetapolar.lt/",
    },
    {
        name: "PLANTFOOD",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PLASTICIAN B2B CONDUCTA",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "FRIDAY",
                time: "03:30 - 05:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PLUMM",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "15:30 - 16:30",
            },
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "POCKETS OF POWER",
        events: [
            {
                stage: "A LITTLE MORE SENSATION",
                day: "THURSDAY",
                time: "13:00 - 13:30",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "16:40 - 17:10",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "19:00 - 19:30",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SUNDAY",
                time: "15:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://scarylittlegirls.co.uk/",
    },
    {
        name: "POET RS",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "14:27 - 14:52",
            },
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "15:24 - 15:49",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/poet_rs",
    },
    {
        name: "POLITE SOCIETY 12A",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "WEDNESDAY",
                time: "17:30 - 19:14",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt17499492/",
    },
    {
        name: "POLY-RITMO",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "12:00 - 13:30",
            },
            {
                stage: "PLATFORM 23",
                day: "SUNDAY",
                time: "01:00 - 01:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/poly_ritmo/",
    },
    {
        name: "PONY MONTANA",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "02:15 - 02:45",
            },
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "01:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/ponymontanaofficial/",
    },
    {
        name: "PORIJ",
        events: [
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "20:45 - 21:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/porij_/",
    },
    {
        name: "POSITIVE FOCUS DJS",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "POWER BALLAD YOGA",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "10:00 - 11:00",
            },
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "10:00 - 11:00",
            },
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "10:00 - 11:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PRACTICES OF INTIMACY AND RESISTANCE: CREATIVE OFFERINGS TO THE EARTH \n IONE MARIE ROJAS IS ARTIST-IN-RESIDENCE FOR THE DAY, SHARING THEIR WORK AS PART OF PIR COLLECTIVE, PLUS HOSTING WORKSHOPS AND A MYCO-FEAST",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "12:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PRACTICES OF INTIMACY AND RESISTANCE: INVITATIONS & DROP-IN HAPPENINGS BY PIR COLLECTIVE",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "12:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PRAH DJS",
        events: [
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "10:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://prahrecordings.greedbag.com/",
    },
    {
        name: "PRE-HUMAN",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "22:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.jetpackdog.com/links",
    },
    {
        name: "PRETTY GIRL",
        events: [
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "12:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PRIMA QUEEN",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SATURDAY",
                time: "12:15 - 13:00",
            },
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SUNDAY",
                time: "14:00 - 14:30",
            },
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "20:00 - 20:45",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/primaqueen",
    },
    {
        name: "PRINTMAKING FLAGS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PRIYA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/deejaypri/",
    },
    {
        name: "PROF ALICE ROBERTS WITH DR REBECCA WRAGG SYKES",
        events: [
            {
                stage: "FREE UNIVERSITY OF GLASTONBURY",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.alice-roberts.co.uk/",
    },
    {
        name: "PROFESSOR EEK",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PROFESSOR ELEMENTAL",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PROFESSOR JOE",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SUNDAY",
                time: "TBA",
            },
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SATURDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PROFESSOR PATEL\u2019S ELEPHANTS ON PARADE",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PROFESSOR SPROUT'S DISCO INFERNO",
        events: [
            {
                stage: "VILLAGE INN",
                day: "THURSDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PRONGHORN",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "THURSDAY",
                time: "22:00 - 23:15",
            },
            {
                stage: "THE GATEWAY",
                day: "THURSDAY",
                time: "15:25 - 15:55",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.pronghorn.co.uk/",
    },
    {
        name: "PROSPA",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://prospa%20(@prospa__%29%20%7C%20instagram/",
    },
    {
        name: "PROSUMER",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SUNDAY",
                time: "03:30 - 04:55",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/prosumer",
    },
    {
        name: "PSYCHO-ACOUSTIC GOAT",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "PUSS IN BOOTS: THE LAST WISH PG",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "WEDNESDAY",
                time: "14:30 - 16:12",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt3915174/",
    },
    {
        name: "PUTTYRUBBER + O.P. GROOVER (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/puttyrubber",
    },
    {
        name: "PXSSY PALACE TAKEOVER: NADINE NOOR, RYAN LOVELL, MYA MEHMI + GUESTS",
        events: [
            {
                stage: "NOMAD",
                day: "FRIDAY",
                time: "00:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.pxssypalace.com/",
    },
    {
        name: "Q&A: HOW TO SAVE CINEMA",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "WEDNESDAY",
                time: "19:15 - 20:15",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt18257464/",
    },
    {
        name: "QUEENS OF THE STONE AGE",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SUNDAY",
                time: "21:45 - 23:15",
            },
        ],
        imgUrl: "",
        url: "https://qotsa.com/",
    },
    {
        name: "RABBIT HOLE DJS",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "13:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RADICAL ROUND UP:  BILLY BRAGG, TARA LILY, SAM LEE, DAVID ROVICS",
        events: [
            {
                stage: "LEFT FIELD",
                day: "FRIDAY",
                time: "15:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RADICAL ROUND UP: BILLY BRAGG, HANNAH GRAE, TYLA JAY, MICK THOMAS AND JEN ANDERSON",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SUNDAY",
                time: "15:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RADICAL ROUND UP: BILLY BRAGG, JAMIE WEBSTER, RIANNE DOWNEY",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RADIOACTIVE MAN",
        events: [
            {
                stage: "THE WOW",
                day: "SATURDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RANDALL",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "18:00 - 19:05",
            },
        ],
        imgUrl: "",
        url: "http://www.facebook.com/randall.macrecs",
    },
    {
        name: "RANSOM NOTE W/ ALLY TROPICAL, MATT COWELL + ROSIE AMA",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "FRIDAY",
                time: "17:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RAVERS 2 RUNNERS X GREENPEACE FUNDRAISER CHARITY RUN",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "10:00 - 10:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/ravers2runners/",
    },
    {
        name: "RAVES R US",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "01:14 - 01:59",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "01:14 - 01:59",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "01:02 - 01:52",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RAYE",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SATURDAY",
                time: "13:15 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://rayeofficial.com/",
    },
    {
        name: "RAYMONDS LUXURY YACHT ROCK ALL-STARS",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://m.mixcloud.com/soulcake-sound-system/",
    },
    {
        name: "RE:PLAY",
        events: [
            {
                stage: "MUZIKADEMY",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MUZIKADEMY",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "REASON SOUND B2B MISS CHILLY",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/reason.sound.system/",
    },
    {
        name: "REBECCA COONEY",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "12:26 - 12:51",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "13:59 - 14:24",
            },
        ],
        imgUrl: "",
        url: "https://rebeccakcooney.wordpress.com/",
    },
    {
        name: "REBECCA GIBBS",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "WEDNESDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "http://living%20and%20working%20like%20the%20climate%20changes/",
    },
    {
        name: "REBECCA VASMANT",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SUNDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/rebeccavasmant/",
    },
    {
        name: "RECYCLED JEWELLERY",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "REDLIGHT B2B CONDUCTA W/ DREAD MC",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "REEL NEWS FILMS Q & A",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "WEDNESDAY",
                time: "20:00 - 22:00",
            },
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "10:00 - 11:00",
            },
            {
                stage: "SPEAKERS FORUM",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://harm%20to%20harmony:%20stop%20ecocide%20with%20kelly%20roberts/",
    },
    {
        name: "REEL NEWS FILMS Q & A - FLISS PREMRU & SARAH WOOLEY",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "http://trade%20union%20metu/",
    },
    {
        name: "RELATIONSHIPS BETWEEN TECHNOLOGY AND NATURE - Q&A WITH GORDON BLAIR",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "THURSDAY",
                time: "12:45 - 13:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "REMOVE ME",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "THURSDAY",
                time: "20:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/remove-me",
    },
    {
        name: "RENFIELD 15",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SATURDAY",
                time: "15:00 - 16:33",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt11358390",
    },
    {
        name: "REV DR. JO TURK; COCOLOCO",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "17:50 - 18:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "REVOLUTION OF RECORDED SOUND",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "17:30 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RHYTHM OF THE 90'S",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://rot90s.com/",
    },
    {
        name: "RICHARD STAMP",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:50 - 18:35",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:50 - 16:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:50 - 18:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:50 - 16:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "17:50 - 18:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:50 - 16:35",
            },
        ],
        imgUrl: "",
        url: "https://dotcomedy.info/",
    },
    {
        name: "RICHARD THOMPSON",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.richardthompson-music.com/",
    },
    {
        name: "RICK ASTLEY",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SATURDAY",
                time: "12:00 - 12:45",
            },
        ],
        imgUrl: "",
        url: "https://rickastley.co.uk/",
    },
    {
        name: "RICK WADE",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SATURDAY",
                time: "01:00 - 02:25",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/rickwade",
    },
    {
        name: "RICKIE LEE JONES",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "21:30 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://rickieleejones.com/",
    },
    {
        name: "RIGHT TO ROAM CAMPAIGN TALK",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "FRIDAY",
                time: "18:00 - 18:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RIGHT TO ROAM WATER, WILDNESS & WONDER",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "SATURDAY",
                time: "16:15 - 17:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RIMSKI & HANDKERCHIEF WIND UP AT HOME",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "15:00 - 17:00",
            },
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "RIMSKI & HANDKERCHIEF\u2019S MIDNIGHT VARIETY",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "00:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "RIMSKI & HANDKERCHIEF\u2019S SUNDAY NIGHT VARIETY",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "22:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "RIMSKI & HANDKERCHIEF\u2019S THURSDAY NIGHT VARIETY",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "RIMSKI\u2019S RADIO HOUR",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RIMSKI\u2019S YARD SATURDAY AFTERNOON VARIETY",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "RIMSKI\u2019S YARD SUNDAY AFTERNOON VARIETY",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "15:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "RIMSKI\u2019S YARD \u2018TEA TIME\u2019 VARIETY",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "19:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "RINA SAWAYAMA",
        events: [
            {
                stage: "WOODSIES",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.rina.online/",
    },
    {
        name: "RIO & RHYMES (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://youtu.be/3kvkifawc8i",
    },
    {
        name: "RISE + SHINE YOGA WITH LANA SMITH",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "THURSDAY",
                time: "08:30 - 09:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "FRIDAY",
                time: "08:30 - 09:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SATURDAY",
                time: "08:30 - 09:30",
            },
        ],
        imgUrl: "",
        url: "http://ig%20@lanagsmith/",
    },
    {
        name: "RISHI GORDON",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:25 - 17:10",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:20 - 15:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:45 - 18:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:20 - 14:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:20 - 19:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:40 - 17:25",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RISKY BUSINESS",
        events: [
            {
                stage: "THE PAVEMENT",
                day: "WEDNESDAY",
                time: "17:10 - 17:40",
            },
            {
                stage: "THE PAVEMENT",
                day: "THURSDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "THURSDAY",
                time: "13:35 - 14:05",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "19:00 - 19:30",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "17:50 - 18:20",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SUNDAY",
                time: "16:05 - 16:35",
            },
        ],
        imgUrl: "",
        url: "https://fitupproductions.com/",
    },
    {
        name: "RIVER ROOTS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "12:00 - 13:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "14:30 - 15:30",
            },
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "12:30 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.riverrootsband.com/bio/",
    },
    {
        name: "RIVER, D-LOW & ALEXINHO - BEATBOX MASTERS OF THE UNIVERSE",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "21:00 - 22:00",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "SATURDAY",
                time: "20:00 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dlowmusic/?hl=en",
    },
    {
        name: "RO-G1",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/j_pring/",
    },
    {
        name: "ROALD DAHL'S MATILDA THE MUSICAL PG",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "FRIDAY",
                time: "11:00 - 12:57",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt3447590/",
    },
    {
        name: "ROB DA BANK & TAYO - PURPLE RAVE",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "THURSDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/purplerave/rob-da-bank-tayo-present-purple-rave-october-mix/",
    },
    {
        name: "ROB KEMP",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "19:55 - 20:25",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ROB KEMP - ELVIS DEAD",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "00:55 - 01:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ROB ROY COLLINS",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "15:40 - 15:50",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "19:28 - 19:58",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "14:10 - 14:40",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "19:38 - 20:08",
            },
            {
                stage: "THE PAVEMENT",
                day: "THURSDAY",
                time: "12:00 - 12:30",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "14:55 - 15:25",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "12:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://coventgardenentertainment.co.uk/performers/rob-roy-collins-escapologist/",
    },
    {
        name: "ROB SMOUGHTON (BLACK PEACHES /HOT CHIP)",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://twitter.com/grovesnor?lang=en",
    },
    {
        name: "ROB VINCENT",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "21:00 - 21:45",
            },
        ],
        imgUrl: "",
        url: "https://robertvincentmusic.com/",
    },
    {
        name: "ROBIN TYRONE PIGOTT",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "15:15 - 15:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/robinpigottmusic/",
    },
    {
        name: "ROD LAVER",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "13:20 - 13:35",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "13:20 - 13:35",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "13:20 - 13:35",
            },
        ],
        imgUrl: "",
        url: "https://www.rodlaver.co.uk/",
    },
    {
        name: "RODNEY BRANIGAN",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "16:50 - 17:35",
            },
        ],
        imgUrl: "",
        url: "https://brokenguitars.com/",
    },
    {
        name: "ROGER HARRABIN, SARAH LUNNON JSO, PATRICK GREENFIELD, CLARE FARRELL",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://media%20%26%20climate/",
    },
    {
        name: "ROGER MCGOUGH'S MONEY-GO-ROUND",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ROGUE OTHERWORLD",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "22:30 - 23:45",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "23:30 - 00:45",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "23:00 - 01:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SUNDAY",
                time: "23:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://rogueotherworld.co.uk/",
    },
    {
        name: "ROGUE WAVE (RIVER & COLAPS) FEAT. ALEXINHO & D-LOW",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "20:15 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/roguewave.bbx",
    },
    {
        name: "ROI PEREZ",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SUNDAY",
                time: "21:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/roiperez",
    },
    {
        name: "ROMPA'S REGGAE SHACK DJS (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/rompasreggaeshack",
    },
    {
        name: "ROMPAS REGGAE SHACK",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "23:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/rompasreggaeshack/?hl=en",
    },
    {
        name: "ROMY",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "SAN REMO",
                day: "SUNDAY",
                time: "19:00 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://www.romyromyromy.com/",
    },
    {
        name: "ROO PANES",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "13:00 - 13:40",
            },
        ],
        imgUrl: "",
        url: "http://%20https//www.roopanes.uk/",
    },
    {
        name: "ROOFTOP ASSEMBLY",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "CROISSANT NEUF",
                day: "SUNDAY",
                time: "17:30 - 18:30",
            },
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "16:00 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/rooftopassembly",
    },
    {
        name: "ROOM SERVICE",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "10:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/sanremoglasto",
    },
    {
        name: "RORTY CRANKLE",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "16:45 - 17:15",
            },
        ],
        imgUrl: "",
        url: "https://www.rortycrankle.net/",
    },
    {
        name: "RORY MORAN",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "11:50 - 12:35",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ROSA HOOPS' ROTATION MOTIVATION",
        events: [
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "12:30 - 13:30",
            },
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ROSCO SHAKES",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://facebook.com/roscoshakes",
    },
    {
        name: "ROSE ALDRIDGE",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "14:00 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/rosie.freyax/",
    },
    {
        name: "ROSE POPAY AND SAFFY SIDEKICK",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "17:00 - 17:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "14:45 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://rosepopay.co.uk/",
    },
    {
        name: "ROSE POPAY AND SIDEKICK SAFFY",
        events: [
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:15 - 15:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:00 - 12:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:15 - 15:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:00 - 12:45",
            },
        ],
        imgUrl: "",
        url: "https://rosepopay.co.uk/",
    },
    {
        name: "ROSENWYN LYNCH FROM CIRK HES - NEXT GEN",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "13:30 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://www.charliebicknell.com/",
    },
    {
        name: "ROSIE EADE FOLK PIXIE",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "THURSDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SUNDAY",
                time: "16:00 - 16:45",
            },
        ],
        imgUrl: "",
        url: "http://www.rosieeade.co.uk/",
    },
    {
        name: "ROSSI.",
        events: [
            {
                stage: "FLYING BUS",
                day: "SATURDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/rossi",
    },
    {
        name: "ROUGH BUT SWEET + LOVE TKO",
        events: [
            {
                stage: "NOTTING HILL CARNIVAL SOUNDSYSTEM",
                day: "SUNDAY",
                time: "16:00 - 20:00",
            },
            {
                stage: "NOTTING HILL CARNIVAL SOUNDSYSTEM",
                day: "FRIDAY",
                time: "16:00 - 20:00",
            },
            {
                stage: "NOTTING HILL CARNIVAL SOUNDSYSTEM",
                day: "THURSDAY",
                time: "16:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "http://www.roughbutsweetsoundsystem.com/",
    },
    {
        name: "ROWENA ALICE",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "THURSDAY",
                time: "00:00 - 01:30",
            },
            {
                stage: "THE TAPHOUSE",
                day: "SATURDAY",
                time: "01:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/rowena.alice/",
    },
    {
        name: "ROYAL BLOOD",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "FRIDAY",
                time: "20:15 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://www.royalbloodband.com/",
    },
    {
        name: "ROZI PLAIN",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SATURDAY",
                time: "16:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://roziplain.co.uk/",
    },
    {
        name: "RPM DISPLAYS",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "WEDNESDAY",
                time: "15:00 - 15:20",
            },
            {
                stage: "CIRCUS FIELD",
                day: "WEDNESDAY",
                time: "13:00 - 13:20",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "15:00 - 15:20",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "13:00 - 13:20",
            },
        ],
        imgUrl: "",
        url: "http://rpmdisplay.co.uk/",
    },
    {
        name: "RSVP",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "19:20 - 20:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "23:00 - 23:50",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "16:50 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.rsvpmusic.co.uk/",
    },
    {
        name: "RSVP - WORKSHOP",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "18:20 - 19:05",
            },
        ],
        imgUrl: "",
        url: "https://www.rsvpmusic.co.uk/",
    },
    {
        name: "RSVP BHANGRA (TBC)",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.rsvpmusic.co.uk/",
    },
    {
        name: "RUBY GILLMAN, TEENAGE KRAKEN PG",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SATURDAY",
                time: "11:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt27155038/",
    },
    {
        name: "RUDIMENTAL",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SUNDAY",
                time: "21:45 - 23:15",
            },
        ],
        imgUrl: "",
        url: "https://www.rudimental.co.uk/",
    },
    {
        name: "RUF DUG",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "19:00 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/rufdug/?hl=en",
    },
    {
        name: "RUF DUG B2B TIA COUSINS",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "17:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RUFFNECK TING 30 FT DAZEE, EUPHONIQUE, JENNI GROVES & JAKES",
        events: [
            {
                stage: "ARCADIA",
                day: "SUNDAY",
                time: "21:00 - 21:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/dazeeruffneck/",
    },
    {
        name: "RUKUS",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/nico_rukus/",
    },
    {
        name: "RUM BUFFALO",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "THURSDAY",
                time: "01:30 - 03:00",
            },
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "18:45 - 19:45",
            },
        ],
        imgUrl: "",
        url: "https://www.rumbuffalo.com/",
    },
    {
        name: "RUM SHACK WILD CARD",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "THE RUM SHACK",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "22:20 - 23:00",
            },
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "21:40 - 22:20",
            },
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "21:00 - 21:40",
            },
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "22:20 - 22:30",
            },
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "21:40 - 22:20",
            },
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "21:00 - 21:40",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RUMBLE IN THE JUNGLE TAKEOVER - KATALYST BTB MONROLLER FT YDOTT",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://rumbleinthejungleevents.com/",
    },
    {
        name: "RUMBLE IN THE JUNGLE TAKEOVER - ZORO BTB NOISY ANTICS FT RIVIBES",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "RUMER",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "14:00 - 14:40",
            },
        ],
        imgUrl: "",
        url: "https://www.rumer.co.uk/",
    },
    {
        name: "RUN DJS",
        events: [
            {
                stage: "THE BUG",
                day: "SATURDAY",
                time: "20:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.theblast.co.uk/",
    },
    {
        name: "RUN LOGAN RUN",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SATURDAY",
                time: "13:00 - 13:30",
            },
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "http://www.runloganrun.com/",
    },
    {
        name: "RUPERT READ",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "http://climate%20-%20canary%20in%20the%20coalmine/",
    },
    {
        name: "RUSS RYAN + MO FINGAZ + J-FELIX",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "SUNDAY",
                time: "23:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/mrrussryan/?hl=en",
    },
    {
        name: "RUSTLE",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:05 - 17:50",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:05 - 13:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:00 - 17:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:15 - 13:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:45 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.thevortexes.com/",
    },
    {
        name: "RUSTY COMPASS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "01:45 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SADSUGAR",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "THURSDAY",
                time: "23:30 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/_sadsugar_/",
    },
    {
        name: "SAFENATH",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "14:30 - 15:50",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "14:30 - 14:50",
            },
            {
                stage: "THE TAPHOUSE",
                day: "FRIDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/safenath/",
    },
    {
        name: "SAINT LUDO",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/saintludo/",
    },
    {
        name: "SALLY JENKINSON",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "14:55 - 15:20",
            },
        ],
        imgUrl: "",
        url: "https://sallyjenkinson.com/",
    },
    {
        name: "SALLY-ANNE HAYWARD (COMPERE)",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "11:00 - 15:15",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "15:15 - 20:35",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "11:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://sallyannehayward.co.uk/",
    },
    {
        name: "SALUTE",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://ffm.bio/salute",
    },
    {
        name: "SALUTE B2B DJ BORING",
        events: [
            {
                stage: "THE LEVELS",
                day: "SUNDAY",
                time: "16:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SALUTE B2B PRETTY GIRL",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SAM BROOKS",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "15:20 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.sambrookes.com/",
    },
    {
        name: "SAM DIVINE",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "http://s%20%E2%98%81%EF%B8%8Fm%20%E2%9A%A1%EF%B8%8F%20d%20i%20%F0%9F%94%BB%20i%20n%20e%20(@samdivinedj%29%20%7C%20instagram/",
    },
    {
        name: "SAM LEE",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "THURSDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://samleesong.co.uk/",
    },
    {
        name: "SAM LOWE",
        events: [
            {
                stage: "VILLAGE INN",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/samlowedj",
    },
    {
        name: "SAM PICONE",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "18:05 - 18:20",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/sampicone",
    },
    {
        name: "SAM SEBASTIAN MAGIC",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "THURSDAY",
                time: "13:00 - 13:30",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "14:30 - 15:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "13:00 - 13:30",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "14:30 - 15:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "13:00 - 13:30",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "13:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://eventmagic.si/english.html",
    },
    {
        name: "SAMANTHA LOVE",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "18:30 - 19:10",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/samanthalove7065",
    },
    {
        name: "SAMI RHYMES",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "FRIDAY",
                time: "13:50 - 14:15",
            },
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "12:03 - 12:28",
            },
        ],
        imgUrl: "",
        url: "https://samirhymes.com/",
    },
    {
        name: "SAMURAI BREAKS",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SUNDAY",
                time: "00:45 - 01:30",
            },
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/samurai_breaks/",
    },
    {
        name: "SANDY YIDAKI WORKSHOP",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "11:15 - 11:45",
            },
        ],
        imgUrl: "",
        url: "https://didjeridu.co.uk/",
    },
    {
        name: "SAOIRSE",
        events: [
            {
                stage: "THE LEVELS",
                day: "SUNDAY",
                time: "23:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SAOIRSE B2B SHANTI CELESTE",
        events: [
            {
                stage: "THE TEMPLE",
                day: "SATURDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/shanticeleste/",
    },
    {
        name: "SARAH GRANT - SPARK",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://www.sparkeducationprogramme.com/",
    },
    {
        name: "SARAH STORY",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "15:30 - 16:30",
            },
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/sarahstory/",
    },
    {
        name: "SAV - @HEAD_OF_MAGIC",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:30 - 14:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:30 - 14:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.headofmagic.co.uk/",
    },
    {
        name: "SAY SHE SHE",
        events: [
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "19:00 - 20:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "19:00 - 19:45",
            },
            {
                stage: "WEST HOLTS STAGE",
                day: "SATURDAY",
                time: "11:30 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.saysheshe.com/",
    },
    {
        name: "SCALPING",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "02:45 - 03:30",
            },
        ],
        imgUrl: "",
        url: "https://scalpingmusic.com/",
    },
    {
        name: "SCARLETT O\u2019MALLEY PRESENTS CLUB COWGIRL",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "THURSDAY",
                time: "21:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/club_cowgirl/",
    },
    {
        name: "SCARY & SPOOKY SKELETONS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "19:35 - 20:20",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "19:35 - 20:20",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:10 - 16:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "19:00 - 19:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://www.dadoshow.com/",
    },
    {
        name: "SCIENCE STORYTELLING WITH JENNY JOPSON",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "FRIDAY",
                time: "10:30 - 11:00",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SATURDAY",
                time: "10:30 - 11:00",
            },
            {
                stage: "LABORATORY STAGE",
                day: "SUNDAY",
                time: "10:30 - 11:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SCOTT DIAZ",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SATURDAY",
                time: "04:30 - 05:55",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/scottdiaz",
    },
    {
        name: "SCOTT WALKER",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "13:00 - 17:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "13:00 - 17:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "13:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SCRIBES",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "16:35 - 17:05",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SEANI B PRESENTS FROM THEN TO NOW': BIG ZEEKS, BRIXX, YUNG SABER, DJ LARNI",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "13:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SEAS OF MIRTH",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://seasofmirth.com/",
    },
    {
        name: "SEB BAILEY",
        events: [
            {
                stage: "VILLAGE INN",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.sebbailey.com/",
    },
    {
        name: "SEDEF ADASI",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SATURDAY",
                time: "23:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/sedefadasi",
    },
    {
        name: "SEDEF ADAS\u00cf",
        events: [
            {
                stage: "THE WOW",
                day: "SUNDAY",
                time: "01:00 - 02:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SEIKOU SUSSOU",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SEIZE THE DAY",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "19:15 - 20:10",
            },
        ],
        imgUrl: "",
        url: "https://seizetheday.org/",
    },
    {
        name: "SELECT-A-CHIEF & HER PUPPETS: ALICE & ALICE",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SELECTA JMAN",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "FRIDAY",
                time: "02:45 - 03:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SENSORY ALCHEMISTS: OPEN CEREMONY",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "THURSDAY",
                time: "15:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/the_sensory_alchemists/",
    },
    {
        name: "SENSORY ALCHEMISTS: QUEER FAMILY HANG OUT",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "THURSDAY",
                time: "18:30 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/the_sensory_alchemists/",
    },
    {
        name: "SERKUS",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/serkus1",
    },
    {
        name: "SETH LAKEMAN",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "16:00 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://www.sethlakeman.co.uk/",
    },
    {
        name: "SETH TROXLER",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "22:15 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/stroxler",
    },
    {
        name: "SETTLE DOWN",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/settledown_uk",
    },
    {
        name: "SHAKA LOVES YOU",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "15:15 - 16:05",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "SATURDAY",
                time: "00:45 - 01:45",
            },
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "FRIDAY",
                time: "22:15 - 23:30",
            },
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "01:45 - 02:45",
            },
        ],
        imgUrl: "",
        url: "https://shakalovesyou.com/",
    },
    {
        name: "SHAKA LOVES YOU (BLENDID TAKEOVER) 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SUNDAY",
                time: "16:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://shakalovesyou.com/",
    },
    {
        name: "SHAKTI SHAKE - DINA + MARV",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "THURSDAY",
                time: "17:30 - 18:30",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SATURDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/martin-brookes",
    },
    {
        name: "SHAKTI SHAKE - KARY STEWART",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "FRIDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "http://ig%20@karysjourney/",
    },
    {
        name: "SHAME",
        events: [
            {
                stage: "WOODSIES",
                day: "SATURDAY",
                time: "16:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://shame.world/",
    },
    {
        name: "SHANNEN SP B2B RAJI RAGS",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "FRIDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/rajirags/%20https://www.instagram.com/shannensp_/",
    },
    {
        name: "SHANNON SMY (SEIZE THE DAY)",
        events: [
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "https://seizetheday.org/",
    },
    {
        name: "SHANTI CELESTE B2B DANIELLE",
        events: [
            {
                stage: "THE LEVELS",
                day: "THURSDAY",
                time: "18:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SHAUN KEAVENY'S COMMUNITY GARDEN RADIO",
        events: [
            {
                stage: "FREE UNIVERSITY OF GLASTONBURY",
                day: "FRIDAY",
                time: "13:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.communitygardenradio.co.uk/",
    },
    {
        name: "SHAY MALT",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SATURDAY",
                time: "22:00 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/shaymalt/?hl=en",
    },
    {
        name: "SHAZAM! FURY OF THE GODS 12A",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "FRIDAY",
                time: "13:00 - 15:10",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt10151854/",
    },
    {
        name: "SHA\u00c9 UNIVERSE",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "15:45 - 16:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SHELF LIVES",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "THURSDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.shelflives.co/",
    },
    {
        name: "SHERELLE",
        events: [
            {
                stage: "ARCADIA",
                day: "FRIDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "STONEBRIDGE BAR",
                day: "SUNDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SHERELLE B2B I. JORDAN",
        events: [
            {
                stage: "THE LEVELS",
                day: "THURSDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SHERIKA SHERARD",
        events: [
            {
                stage: "TOAD HALL",
                day: "FRIDAY",
                time: "14:45 - 15:30",
            },
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.sherikasherard.com/",
    },
    {
        name: "SHIVUM SHARMA",
        events: [
            {
                stage: "NOMAD",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "NOMAD",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/s.hivum",
    },
    {
        name: "SHORT FILMS SCREENING - SELECTED AND HOSTED BY LION",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "18:15 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SHOSH",
        events: [
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "http://shosh%20(@shosh_ukg%29%20%7C%20instagram/",
    },
    {
        name: "SHOWHAWK DUO",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "CROISSANT NEUF",
                day: "THURSDAY",
                time: "21:00 - 21:30",
            },
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "17:20 - 18:00",
            },
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "00:15 - 01:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/showhawkduo/",
    },
    {
        name: "SHY FX FT STAMINA MC",
        events: [
            {
                stage: "ARCADIA",
                day: "SUNDAY",
                time: "23:30 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/shyfx/",
    },
    {
        name: "SHYGIRL",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "FRIDAY",
                time: "19:45 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://shygirl.tv/",
    },
    {
        name: "SIAN'S WORKSHOP",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SICARIA",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "18:00 - 18:45",
            },
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "04:00 - 04:45",
            },
        ],
        imgUrl: "",
        url: "http://sicaria%20(@sicariaonline%29%20%7C%20instagram/",
    },
    {
        name: "SICARIA B2B NOORIYAH",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "FRIDAY",
                time: "00:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SICARIA W/ P MONEY",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "18:45 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SIKISA",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "22:10 - 22:40",
            },
        ],
        imgUrl: "",
        url: "https://www.sikisacomedy.com/",
    },
    {
        name: "SIKISA (COMPERE)",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "19:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.sikisacomedy.com/",
    },
    {
        name: "SILKY DISTURBANCE",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "18:45 - 19:45",
            },
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "19:45 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://silkydisturbance.wordpress.com/",
    },
    {
        name: "SILVIA PAVONE",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "21:47 - 21:55",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "22:34 - 22:42",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "21:06 - 21:14",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "22:29 - 22:37",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "21:29 - 21:37",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "15:11 - 15:19",
            },
        ],
        imgUrl: "",
        url: "https://silviapavone.com/",
    },
    {
        name: "SIMO CELL",
        events: [
            {
                stage: "IICON",
                day: "SUNDAY",
                time: "20:00 - 21:15",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/simocell",
    },
    {
        name: "SISTA SELECTA TAKEOVER",
        events: [
            {
                stage: "NOMAD",
                day: "THURSDAY",
                time: "22:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SISTER SUZIE",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/123ganradge/?locale=en_gb",
    },
    {
        name: "SISTERS OF PERCY",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SI\u00c2NAGEDDON",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "23:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/siansmusicbox/",
    },
    {
        name: "SKATE RAMP KIDS SESSION",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "10:30 - 11:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SKATE RAMP PRO SESSION",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "11:15 - 12:00",
            },
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SKEPTA B2B JAMMER",
        events: [
            {
                stage: "ARCADIA",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/skepta/",
    },
    {
        name: "SKEPTICAL & MEDIC",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "23:10 - 00:05",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SKINDRED (EARACHE RECORDS TAKEOVER)",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "23:45 - 00:45",
            },
        ],
        imgUrl: "",
        url: "https://webstore.earache.com/skindred",
    },
    {
        name: "SKINNY PELEMBE",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SUNDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/skinnypelembe/?hl=en",
    },
    {
        name: "SKREAM",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "18:00 - 18:30",
            },
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "04:45 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/skreamizm/",
    },
    {
        name: "SKREAM B2B INTERPLANETARY CRIMINAL",
        events: [
            {
                stage: "ARCADIA",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/skreamizm/%20%20%20%20//%20https://www.instagram.com/interplanetary_criminal93",
    },
    {
        name: "SLACKLINE SCHOOL",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "WEDNESDAY",
                time: "11:30 - 15:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "11:30 - 15:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "11:00 - 18:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "11:00 - 18:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SUNDAY",
                time: "11:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "http://www.theslacklineschool.co.uk/",
    },
    {
        name: "SLAMBOREE",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "THURSDAY",
                time: "22:48 - 23:48",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.slamboree.co.uk/",
    },
    {
        name: "SLEAZE",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "23:00 - 23:45",
            },
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "20:15 - 21:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SLICK AND BOBBIE TAKEOVER",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "23:00 - 23:30",
            },
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "22:00 - 22:30",
            },
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "21:00 - 21:30",
            },
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "20:00 - 20:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SLOWDIVE",
        events: [
            {
                stage: "WOODSIES",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/slowdiveofficial/?hl=en",
    },
    {
        name: "SMALLEST RACE ON EARTH",
        events: [
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:10 - 11:40",
            },
        ],
        imgUrl: "",
        url: "http://www.compagniemiaow.com/",
    },
    {
        name: "SMASH HITS",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SMIRKINS",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://youtu.be/b2ohxmddo6a",
    },
    {
        name: "SMOOVE & TURRELL LIVE",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "FRIDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://smooveandturrell.com/",
    },
    {
        name: "SNAZZBACK",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "19:30 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://snazzback.bandcamp.com/album/ruins-everything",
    },
    {
        name: "SNAZZBACK MEETS FLOWDAN AND GROVE",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "22:30 - 23:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/snazzback/",
    },
    {
        name: "SNIFF 'N' THE TEARS",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "13:00 - 13:40",
            },
        ],
        imgUrl: "",
        url: "https://www.sniffnthetears.com/",
    },
    {
        name: "SOICHI TERADA (LIVE)",
        events: [
            {
                stage: "THE WOW",
                day: "SUNDAY",
                time: "18:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SOIL SESSIONS: JOURNEY BENEATH THE RAVE TREE - MUSICIANS AND DJS",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "22:00 - 02:00",
            },
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "22:00 - 02:00",
            },
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "21:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SOL CINEMA",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "THURSDAY",
                time: "13:30 - 16:30",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "12:00 - 18:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "12:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://www.thesolcinema.org/",
    },
    {
        name: "SOLAR + MOZHGAN",
        events: [
            {
                stage: "THE WOW",
                day: "THURSDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SOLSTICE",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "23:00 - 23:50",
            },
        ],
        imgUrl: "",
        url: "https://www.solsticeprog.uk/",
    },
    {
        name: "SONG WORKSHOPS",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SUNDAY",
                time: "11:45 - 12:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/listentoleti/",
    },
    {
        name: "SONGWRITING WORKSHOP WITH LETI",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "THURSDAY",
                time: "12:15 - 13:15",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "FRIDAY",
                time: "12:15 - 13:15",
            },
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SATURDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/listentoleti/",
    },
    {
        name: "SONIA STEIN",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "14:00 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/soniasteinmusic/?hl=en",
    },
    {
        name: "SONIC SOIL MEDITATION: DROP-IN 10 MINUTE SENSORY HEALING PRACTICE CONNECTING HUMANS AND NON-HUMANS IN A SONIC COMPOST. FACILITATED BY ECOLOGICAL THEATRE MAKER HANNAH CALASCIONE WITH SOUNDS BY HARI BYLES AND JAS BUTT, COMPOST MENTIS",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SONIDO TUPINAMBA",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "THURSDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "SWEET CHARITY",
                day: "SATURDAY",
                time: "04:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SONWAH",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SOPHIE COWEN",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "http://d0%20i%20have%20the%20power%20to%20tackle%20the%20fossil%20fuel%20industry/?%20the%20answer%20is%20in%20your%20pocket",
    },
    {
        name: "SOPHIE ELLIS-BEXTOR",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SUNDAY",
                time: "12:15 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://sophieellisbextor.net/",
    },
    {
        name: "SOREL REGAN FROM CIRK HES - NEXT GEN",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "20:03 - 20:09",
            },
        ],
        imgUrl: "",
        url: "https://www.circusworksdevoran.org/",
    },
    {
        name: "SPACE CADETS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "13:15 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:15 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:30 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://www.fairplaycomedy.com/",
    },
    {
        name: "SPACE HAWKS TRIBUTE TO NIK TURNER AND MICK SLATTERY- FEATURING MEMBERS AND FRIENDS OF SPACE RITUAL",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/mandalastage/videos/587130079899958/",
    },
    {
        name: "SPACE MISTRESS",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/spacemistresss/",
    },
    {
        name: "SPARKS",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "FRIDAY",
                time: "21:15 - 22:15",
            },
        ],
        imgUrl: "",
        url: "https://allsparks.com/",
    },
    {
        name: "SPARROW",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "12:00 - 14:00",
            },
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "10:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SPEAKERS CORNER QUARTET",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SUNDAY",
                time: "15:30 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/speakerscornerquartet/?hl=en-gb",
    },
    {
        name: "SPECIAL GUEST: DANIEL GONCALVES",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "17:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "http://danielgoncalves.eu/",
    },
    {
        name: "SPENCER JONES",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "14:35 - 14:55",
            },
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "13:40 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.spendals.co.uk/",
    },
    {
        name: "SPFDJ",
        events: [
            {
                stage: "THE TEMPLE",
                day: "FRIDAY",
                time: "03:30 - 04:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/spfd.j/",
    },
    {
        name: "SPIDER-MAN: ACROSS THE SPIDER-VERSE PG",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SATURDAY",
                time: "12:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt9362722/",
    },
    {
        name: "SPLASH TEST DUMMIES",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "11:00 - 12:00",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.dummiescorp.com/",
    },
    {
        name: "SPLINTERS",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "14:00 - 14:40",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SPORTS BANGER",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "18:45 - 20:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SPOT MY G",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SATURDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/spot.my.g/",
    },
    {
        name: "SPYRO",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/yesspyro?igshid=ymmymta2m2y=",
    },
    {
        name: "SQUISH",
        events: [
            {
                stage: "TOLPUDDLE",
                day: "THURSDAY",
                time: "19:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.mixcloud.com/squish-squish-squish/",
    },
    {
        name: "STACKY",
        events: [
            {
                stage: "VILLAGE INN",
                day: "THURSDAY",
                time: "16:00 - 18:00",
            },
            {
                stage: "TOLPUDDLE",
                day: "FRIDAY",
                time: "21:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/stacky/",
    },
    {
        name: "STANLAEY",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "11:45 - 12:15",
            },
        ],
        imgUrl: "",
        url: "https://www.stanlaey.com/",
    },
    {
        name: "STANTON WARRIORS",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SATURDAY",
                time: "01:00 - 02:30",
            },
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "03:30 - 05:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/stantonwarriors/",
    },
    {
        name: "STAR FEMININE BAND",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "FRIDAY",
                time: "11:30 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/starfeminineband/?hl=en",
    },
    {
        name: "STAR ONE",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "http://star.one%20(@xn--staroneuk%29%20%20instagram%20photos%20and%20videos-0075a/",
    },
    {
        name: "STARKIDS",
        events: [
            {
                stage: "KIDZFIELD BIG TOP",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "KIDZFIELD BIG TOP",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STARTING POINT FOR SOLSTICE PROCESSION",
        events: [
            {
                stage: "THE CROW'S NEST",
                day: "WEDNESDAY",
                time: "19:30 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STAY HUNGRY",
        events: [
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://stay-hungry.co.uk/",
    },
    {
        name: "STEFFLON DON",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "FRIDAY",
                time: "14:45 - 15:45",
            },
        ],
        imgUrl: "",
        url: "https://officialstefflondon.com/",
    },
    {
        name: "STEPHEN FROST IMPRO ALLSTARS",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "15:20 - 16:20",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "15:20 - 16:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STEPHEN K AMOS",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "18:45 - 19:15",
            },
        ],
        imgUrl: "",
        url: "https://www.stephenkamos.com/",
    },
    {
        name: "STEVE DAVIS & KAVUS TORABI",
        events: [
            {
                stage: "GLADE DOME",
                day: "FRIDAY",
                time: "01:25 - 02:55",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/kavustorab",
    },
    {
        name: "STEVE EARLE",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "http://steveearle.com/",
    },
    {
        name: "STEVE FAULKNER",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "14:15 - 15:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "12:15 - 13:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:15 - 15:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:15 - 13:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:00 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://stevefaulkner.com/",
    },
    {
        name: "STEVE KNIGHTLEY",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "21:00 - 21:45",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "19:00 - 19:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STEVE RAWLINGS",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "21:41 - 22:01",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "21:42 - 22:02",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "15:39 - 15:59",
            },
        ],
        imgUrl: "",
        url: "https://steverawlingsjuggler.com/",
    },
    {
        name: "STEVEN JULIEN",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "17:30 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/stevenjulien/?hl=en",
    },
    {
        name: "STICKY FINGERS CREW",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STILT AFFECTION",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STONE",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "FRIDAY",
                time: "19:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.stone.band/",
    },
    {
        name: "STORM MOLLISON",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STORY DON",
        events: [
            {
                stage: "STORYTELLERS LOUNGE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "STORYTELLERS LOUNGE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STORY TELLING WITH EMMA CHARLTON",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SUNDAY",
                time: "12:15 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://www.earthflowertherapies.com/story-telling",
    },
    {
        name: "STRANDZ",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "19:45 - 20:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STRIKING WORKER",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "15:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STRUMMERVILLE DJS",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "13:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STRUMMERVILLE SESSIONS",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "12:00 - 13:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "STUART GOLDSMITH",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "17:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.stuartgoldsmith.com/",
    },
    {
        name: "STUART GOLDSMITH (COMPERE)",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "THURSDAY",
                time: "19:00 - 00:05",
            },
        ],
        imgUrl: "",
        url: "https://www.stuartgoldsmith.com/",
    },
    {
        name: "SUB ATOMIC SOULS",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/subatomicsoulspage/?locale=en_gb",
    },
    {
        name: "SUB FOCUS B2B DIMENSION FT. ID",
        events: [
            {
                stage: "THE TEMPLE",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/subfocus/%20https://www.instagram.com/dimension/",
    },
    {
        name: "SUB FOCUS DJ SET & ID",
        events: [
            {
                stage: "THE LEVELS",
                day: "SATURDAY",
                time: "20:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SUBB-AN",
        events: [
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "23:45 - 01:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/subb_an/",
    },
    {
        name: "SUCHI",
        events: [
            {
                stage: "THE LEVELS",
                day: "SUNDAY",
                time: "12:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SUDAN ARCHIVES",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SATURDAY",
                time: "14:30 - 15:30",
            },
        ],
        imgUrl: "",
        url: "https://sudanarchives.com/",
    },
    {
        name: "SUGARBEAR AND NINEBOB",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "FRIDAY",
                time: "04:30 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/habanawax_records/?hl=en%20https://www.facebook.com/thenycdownlow/photos/a.3024906544259089/3635530256530045/?type=3",
    },
    {
        name: "SUN KINGS",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "22:40 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/user-909871868",
    },
    {
        name: "SUNDAY HOST: DRAG SYNDROME & FRIENDS",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SUNS OF ACID",
        events: [
            {
                stage: "FLYING BUS",
                day: "SUNDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SUPER SOCA SHOW",
        events: [
            {
                stage: "THE BUG",
                day: "THURSDAY",
                time: "18:00 - 20:30",
            },
        ],
        imgUrl: "",
        url: "https://ujimaradio.com/show/super-soca-show/",
    },
    {
        name: "SURF JAZ",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/watch?v=anogior0hpw",
    },
    {
        name: "SURUSINGHE",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "04:00 - 05:00",
            },
            {
                stage: "NOWHERE",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://suze%20gurusinghe%20(@surusinghe%29%20%7C%20instagram/",
    },
    {
        name: "SWANK",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "11:15 - 12:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:45 - 18:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:15 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:45 - 18:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:15 - 14:00",
            },
        ],
        imgUrl: "",
        url: "http://www.swank-streettheatre.com/",
    },
    {
        name: "SWEET CHARITY DJS",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "SUNDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SWEET CHARITY\u2019S COSMIC GARDEN DJ\u2019S",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "THURSDAY",
                time: "12:00 - 19:00",
            },
            {
                stage: "SWEET CHARITY",
                day: "FRIDAY",
                time: "12:00 - 20:00",
            },
            {
                stage: "SWEET CHARITY",
                day: "SATURDAY",
                time: "12:00 - 20:00",
            },
            {
                stage: "SWEET CHARITY",
                day: "SUNDAY",
                time: "12:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SWINGBOATS",
        events: [
            {
                stage: "GLEBELAND",
                day: "THURSDAY",
                time: "12:00 - 18:00",
            },
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "11:00 - 19:00",
            },
            {
                stage: "GLEBELAND",
                day: "SATURDAY",
                time: "11:00 - 19:00",
            },
            {
                stage: "GLEBELAND",
                day: "SUNDAY",
                time: "11:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SYD AND NIK",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "15:05 - 15:35",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SYREETA",
        events: [
            {
                stage: "GLADE",
                day: "FRIDAY",
                time: "18:45 - 20:00",
            },
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "23:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/syreetamusic",
    },
    {
        name: "SYREETA (UK GARAGE SET)",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "THURSDAY",
                time: "20:30 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "SYSTEM OLYMPIA",
        events: [
            {
                stage: "SAN REMO",
                day: "SATURDAY",
                time: "15:30 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/systemolympia/",
    },
    {
        name: "SYZ",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/olisyz/",
    },
    {
        name: "T. JACQUES",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "SUNDAY",
                time: "03:30 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/tjacques",
    },
    {
        name: "T>I",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SUNDAY",
                time: "02:15 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/t-i",
    },
    {
        name: "T>I B2B D-MINDS (RUN IN THE JUNGLE SHOWCASE)",
        events: [
            {
                stage: "THE TEMPLE",
                day: "SUNDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/the_infuriator/%20https://www.instagram.com/dminds__/",
    },
    {
        name: "TAAHLIAH",
        events: [
            {
                stage: "THE LEVELS",
                day: "SUNDAY",
                time: "20:00 - 21:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TAIKO MEANTIME",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "19:50 - 20:35",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "19:50 - 20:35",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "19:00 - 19:45",
            },
        ],
        imgUrl: "",
        url: "https://facebook.com/taikomeantime",
    },
    {
        name: "TAILOR BIRDS",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SATURDAY",
                time: "16:00 - 16:30",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SUNDAY",
                time: "15:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://bowjangles.org/",
    },
    {
        name: "TAKE THE JUMP",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "SATURDAY",
                time: "13:30 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:05 - 13:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://takethejump.org/",
    },
    {
        name: "TAKE THE JUMP TO A WORLD OF LESS STUFF AND MORE JOY",
        events: [
            {
                stage: "TOAD HALL",
                day: "WEDNESDAY",
                time: "16:10 - 16:50",
            },
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "16:00 - 16:40",
            },
        ],
        imgUrl: "",
        url: "https://takethejump.org/",
    },
    {
        name: "TALIESIN",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "13:45 - 14:15",
            },
        ],
        imgUrl: "",
        url: "https://fanlink.to/taliesin",
    },
    {
        name: "TALK: BELA VERADI / ROMA CULTURE",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.studio90s.com/i-see-my-father-s-gypsy-soul-everywhere",
    },
    {
        name: "TALK: BILLY WELCH, DAMIAN LE BAS, JOHN DOE / ROMANY HISTORY AND CULTURE",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "THURSDAY",
                time: "15:15 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://billy:%20https//www.applebyfair.org;%20damian:%20https://www.penguin.co.uk/authors/237991/damian-le-bas?tab=penguin-books",
    },
    {
        name: "TALK: JOHN HENRY PHILLIPS / ROMANI ARCHAEOLOGY",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "THURSDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TALK: MARC WILLERS KC AND SIMON RUSTON",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "SATURDAY",
                time: "15:30 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://www.gardencourtchambers.co.uk/barristers/marc-willers-kc/sao",
    },
    {
        name: "TALK: MIKE DOHERTY / NATIONAL BARGEE TRAVELLERS ASSOCIATION",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "SATURDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TALK: ON THE ROAD WITH THE HORSES /JOHN DOE AND BILL LLOYD",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "WEDNESDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TALK: RUTH AND MICHELLE, TRAVELLERS PRIDE / INTERSECTIONAL IDENTITY",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "FRIDAY",
                time: "15:15 - 16:15",
            },
        ],
        imgUrl: "",
        url: "https://www.lgbttravellerpride.com/",
    },
    {
        name: "TALK: SINDY JOYCE / EVERYDAY RACISM",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://www.ul.ie/ecsh/itaj/meet-research-team/dr-sindy-joyce",
    },
    {
        name: "TALK: SINDY JOYCE AND THOMAS MCCARTHY / IRISH TRAVELLER CULTURE",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "THURSDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.ul.ie/ecsh/itaj/meet-research-team/dr-sindy-joyce",
    },
    {
        name: "TALK: VAGZ WRIGHT / NEW TRAVELLER HISTORY",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "WEDNESDAY",
                time: "15:15 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TALK: VAGZ WRIGHT, TERENA WORLIDGE, MIKE DOHERTY / NEW TRAVELLERS",
        events: [
            {
                stage: "ATCHIN TAN",
                day: "FRIDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TANK HOWLS",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TANUKICHI",
        events: [
            {
                stage: "THE SALON CAROUSEL",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/tanukichi",
    },
    {
        name: "TARA LILY",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SUNDAY",
                time: "19:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.taralilymood.com/",
    },
    {
        name: "TARZSA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/tarzsa_williams/",
    },
    {
        name: "TASH LC",
        events: [
            {
                stage: "IICON",
                day: "FRIDAY",
                time: "04:30 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/tash-lc",
    },
    {
        name: "TASHA",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "17:30 - 18:00",
            },
        ],
        imgUrl: "",
        url: "http://tasha%20(@xn--tasha_neighbourhood%29%20%20instagram%20photos%20and%20videos-0432b/",
    },
    {
        name: "TATTY BUMPKIN",
        events: [
            {
                stage: "LITTLE KIDZ AREA",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "LITTLE KIDZ AREA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TAUTUMEITAS",
        events: [
            {
                stage: "TOAD HALL",
                day: "SATURDAY",
                time: "00:15 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.tautumeitas.lv/home",
    },
    {
        name: "TBA",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SATURDAY",
                time: "19:45 - 20:45",
            },
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "15:30 - 17:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "12:00 - 12:00",
            },
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SATURDAY",
                time: "17:30 - 17:55",
            },
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SUNDAY",
                time: "17:00 - 17:30",
            },
            {
                stage: "THE LEVELS",
                day: "FRIDAY",
                time: "00:00 - 01:30",
            },
            {
                stage: "THE GATEWAY",
                day: "FRIDAY",
                time: "12:40 - 13:10",
            },
            {
                stage: "THE GATEWAY",
                day: "SATURDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "THE GATEWAY",
                day: "SUNDAY",
                time: "12:35 - 13:05",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "15:25 - 16:20",
            },
            {
                stage: "MAVERICKS",
                day: "FRIDAY",
                time: "00:00 - 03:00",
            },
            {
                stage: "MAVERICKS",
                day: "SATURDAY",
                time: "00:00 - 03:00",
            },
            {
                stage: "MAVERICKS",
                day: "SUNDAY",
                time: "00:00 - 02:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "BIMBLE INN",
                day: "SUNDAY",
                time: "15:45 - 16:30",
            },
            {
                stage: "WOODSIES",
                day: "FRIDAY",
                time: "19:30 - 20:30",
            },
            {
                stage: "THE TEMPLE",
                day: "SATURDAY",
                time: "03:00 - 04:30",
            },
            {
                stage: "THE TEMPLE",
                day: "SATURDAY",
                time: "00:00 - 01:30",
            },
            {
                stage: "WOODSIES",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "NOWHERE",
                day: "SUNDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "NOWHERE",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "01:30 - 02:15",
            },
        ],
        imgUrl: "",
        url: "http://tbc/",
    },
    {
        name: "TEA LADIES ON TOUR",
        events: [
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "11:00 - 11:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "11:00 - 11:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:00 - 11:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:00 - 11:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/tealadiesontour",
    },
    {
        name: "TEACHINGS IN DUB TAKEOVER: DUBKASM, KING ORIGINAL SOUND (FEAT FOOTSIE, SIR SPYRO & JAH MODEL), ISHMAEL ENSEMBLE & RIDER SHAFIQUE (DJ SET), QUEEN BEE (BRISTOL HIFI)",
        events: [
            {
                stage: "THE FIRMLY ROOTED SOUNDSYSTEM",
                day: "FRIDAY",
                time: "12:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TEAM CANTEEN PRESENTS: 'OUR RIGHT TO EAT WELL'",
        events: [
            {
                stage: "THE INFORMATION",
                day: "SUNDAY",
                time: "13:15 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TEAM LOVE X BLACK BRITISH BOOK FESTIVAL PRESENTS: 'GOING AGAINST THE GRAIN'",
        events: [
            {
                stage: "THE INFORMATION",
                day: "SUNDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TEE BAGS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TELMARY",
        events: [
            {
                stage: "GLASTO LATINO",
                day: "SATURDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://telmary.com/",
    },
    {
        name: "TELMARY (PA)",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "FRIDAY",
                time: "23:45 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/_telmary_/",
    },
    {
        name: "TENTED TALK:  'LIFE CHANGING CIRCUS' - CIRCUS ELDER, AND NOFIT STATE FOUNDER, ALI WILLIAMS TAKES US ON A GLOBAL JOURNEY EXAMINING NON PROFESSIONAL CIRCUS AND ITS SOCIAL IMPACT ON PEOPLE COMMUNITY.",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "10:30 - 11:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TENTED TALK:  THE DECONSTRUCTED LIFE OF A SWINGING TRAPEZE ARTISTE - LYNDALL MERRY TALKS ABOUT HIS JOURNEY, FROM HIS TRAPEZE.",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "11:20 - 12:05",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TENTED TALK: CHRIS BARLTROP A WORLD RENOWNED RING MASTER TALKS ABOUT THE LIFESTYLE OF CLASSIC CIRCUS AND ITS HISTORY WITH CIRCUS FUNTASIA",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "10:30 - 11:15",
            },
        ],
        imgUrl: "",
        url: "https://www.centreforcircusculture.org/",
    },
    {
        name: "TENTED TALK: DECOLONISE AND MOISTURISE' - HOT BROWN HONEY THE GENRE DEFYING FIERCE FEMME CREW OF GLOBAL FIRST NATIONS GAME CHANGERS TAKE TO MIC TO CHAT ABOUT JOYOUS RAGE CENTRE STAGE.",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "11:20 - 12:05",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TENTED TALK: JANI FOLDI - LIFE AS A TRIPLE CLOUDSWING ARTISTE AND THE TECHNIQUES OF THE SKILLS BROKEN DOWN.",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "11:20 - 12:05",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TENTED TALK: PAVEMENTOLOGY - THE STORY OF STREET PERFORMING WITH DAVE SOUTHERN",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "10:30 - 11:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TEXAS",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "FRIDAY",
                time: "16:15 - 17:15",
            },
        ],
        imgUrl: "",
        url: "https://www.texas.uk.com/",
    },
    {
        name: "THAT RAY'S TRANS CABARET. PERFORMERS: PURINA ALPHA, RUBIE, OEDIPUSSY REX, JO TYABJI, GORDIE SPORE AND STAR ANISE",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "FRIDAY",
                time: "00:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/itsthat_ray/%20,%20https://www.instagram.com/purina.alpha/%20,%20https://www.instagram.com/rubie____/%20,%20https://www.instagram.com/oedipussi.rex/%20,",
    },
    {
        name: "THE ANUNNAKI FANCLUB",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SUNDAY",
                time: "19:15 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://instagram.com/anunnakifanclub?igshid=mzrlodbinwflza==",
    },
    {
        name: "THE AUTUMN SAINTS",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "16:35 - 17:05",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "10:30 - 11:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE BAD EGGS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:50 - 17:35",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:45 - 14:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:50 - 17:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:45 - 14:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:50 - 17:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:45 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://thebadeggtheatre.wixsite.com/mysite",
    },
    {
        name: "THE BAGHDADDIES",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "00:20 - 01:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE BEATBOX COLLECTIVE",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "18:15 - 19:00",
            },
            {
                stage: "THE BUG",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thebeatboxcollective.com/",
    },
    {
        name: "THE BEATBOX COLLECTIVE & FRIENDS",
        events: [
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "17:00 - 17:40",
            },
        ],
        imgUrl: "",
        url: "https://www.thebeatboxcollective.com/",
    },
    {
        name: "THE BEATLES DUB CLUB",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "19:30 - 20:00",
            },
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "18:15 - 18:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/beatlesdubclub/?hl=en",
    },
    {
        name: "THE BIG HEADS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "16:10 - 16:50",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "14:10 - 14:50",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "12:10 - 12:50",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:10 - 16:50",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:10 - 14:50",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:10 - 12:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:10 - 16:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:10 - 14:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:10 - 12:50",
            },
        ],
        imgUrl: "",
        url: "https://www.bimmason.com/",
    },
    {
        name: "THE BIG MOON",
        events: [
            {
                stage: "WOODSIES",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thebigmoon.co.uk/",
    },
    {
        name: "THE BIRDS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "00:00 - 00:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "23:00 - 23:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "00:00 - 00:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "22:15 - 23:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "00:00 - 00:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "22:15 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.apusproductions.co.uk/",
    },
    {
        name: "THE BIRTHDAY PARTY",
        events: [
            {
                stage: "JUGGLING TENT",
                day: "FRIDAY",
                time: "18:30 - 19:30",
            },
            {
                stage: "JUGGLING TENT",
                day: "SATURDAY",
                time: "18:30 - 19:30",
            },
            {
                stage: "JUGGLING TENT",
                day: "SUNDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/glastonburybirthdays",
    },
    {
        name: "THE BLACK EAGLES",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "19:14 - 19:39",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "19:15 - 19:40",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "16:26 - 16:51",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "12:55 - 13:20",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "12:55 - 13:20",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "12:55 - 13:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE BLESSED MADONNA",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "FRIDAY",
                time: "00:00 - 01:45",
            },
        ],
        imgUrl: "",
        url: "https://tbm.theblessedmadonna.co.uk/",
    },
    {
        name: "THE BODYGUARD (1992) SING A LONG 15",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SATURDAY",
                time: "00:30 - 02:39",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt0103855/",
    },
    {
        name: "THE BOOTLEG BEATLES",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/bootlegbeatles",
    },
    {
        name: "THE BRISTOL REGGAE ORCHESTRA AND WINDRUSH CHOIR",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SUNDAY",
                time: "11:00 - 11:45",
            },
        ],
        imgUrl: "",
        url: "https://www.bristolreggaeorchestra.com/",
    },
    {
        name: "THE BURNING GLASS",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "WEDNESDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/theburningglassmusic",
    },
    {
        name: "THE BUSY TWIST",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "FRIDAY",
                time: "23:30 - 00:30",
            },
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "04:00 - 04:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/thebusytwist/",
    },
    {
        name: "THE BUSY TWIST: VILLAGE CUTS TAKEOVER",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/thebusytwist/",
    },
    {
        name: "THE CALL OF THE QUETZALCOATL PROPHECY",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "SUNDAY",
                time: "14:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE CARRY NATION",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "THURSDAY",
                time: "01:30 - 02:55",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/thecarrynation",
    },
    {
        name: "THE CHEMICAL BROTHERS (DJ SET)",
        events: [
            {
                stage: "ARCADIA",
                day: "FRIDAY",
                time: "22:30 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/thechemicalbrothers/",
    },
    {
        name: "THE CHESHIRE CAT",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SUNDAY",
                time: "01:30 - 02:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE CHICKS",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SUNDAY",
                time: "13:30 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://thechicks.com/",
    },
    {
        name: "THE CHILL OUT TENT FEAT. CHRIS COCO, SADEEDO, JULIA TUPINAMBA, JONNY HENFRY & FORMENTERA LADY",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "SATURDAY",
                time: "21:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://chillouttent.com/",
    },
    {
        name: "THE CHRIS JAGGER TRIO",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE CHURNUPS",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "FRIDAY",
                time: "18:15 - 19:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE CLOUDMEN",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:30 - 18:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://www.lagaleriemobile.com/",
    },
    {
        name: "THE COMET IS COMING",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "FRIDAY",
                time: "18:15 - 19:15",
            },
        ],
        imgUrl: "",
        url: "https://www.thecometiscoming.co.uk/",
    },
    {
        name: "THE CRATE STACK CHALLENGE",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "10:30 - 11:30",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "10:30 - 11:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE CRAZY GOLF COMPANY",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "THURSDAY",
                time: "11:00 - 20:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "11:00 - 20:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "11:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thecrazygolfcompany.com/",
    },
    {
        name: "THE CREASE",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "SATURDAY",
                time: "01:30 - 02:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE DAMNED",
        events: [
            {
                stage: "AVALON STAGE",
                day: "FRIDAY",
                time: "23:05 - 00:20",
            },
        ],
        imgUrl: "",
        url: "https://www.officialdamned.com/",
    },
    {
        name: "THE DAPPER CHAPS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "15:10 - 16:10",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "12:10 - 13:10",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:00 - 13:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:15 - 13:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "http://www.stevekaos.co.uk/",
    },
    {
        name: "THE DEAD REDS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE DELTA DU BRUIT",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "19:20 - 19:50",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "17:50 - 18:20",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE DELTA SOUND",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "17:30 - 18:15",
            },
        ],
        imgUrl: "",
        url: "https://www.thedeltasound.com/",
    },
    {
        name: "THE DISAPPOINTMENTS",
        events: [
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "WEDNESDAY",
                time: "17:30 - 18:15",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "THE GATEWAY",
                day: "SATURDAY",
                time: "14:20 - 15:05",
            },
        ],
        imgUrl: "",
        url: "https://www.thedisappointments.co.uk/",
    },
    {
        name: "THE DR AND SUE",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
            {
                stage: "SWEET CHARITY",
                day: "FRIDAY",
                time: "02:30 - 04:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE EGG",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "01:00 - 02:30",
            },
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "01:30 - 02:55",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/theeggband",
    },
    {
        name: "THE ENTITLED SONS",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "18:00 - 18:45",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "19:35 - 20:05",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "23:50 - 00:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE EXPERIMAKERS",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE EXPLORERS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:05 - 16:05",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:05 - 14:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:05 - 16:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:05 - 14:05",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:30 - 16:40",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE FAIRY GODMOTHER",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:10 - 14:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:10 - 14:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:10 - 14:55",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/upperleveluk/",
    },
    {
        name: "THE FENCE 18",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SUNDAY",
                time: "16:45 - 18:19",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt15253488/",
    },
    {
        name: "THE FIERCE AND THE FABULOUS",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "THURSDAY",
                time: "21:35 - 22:20",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "22:15 - 23:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "22:00 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://friskyonline.co.uk/",
    },
    {
        name: "THE FIERY JACK TEAM",
        events: [
            {
                stage: "THE PAVEMENT",
                day: "THURSDAY",
                time: "16:40 - 17:10",
            },
            {
                stage: "THE PAVEMENT",
                day: "SUNDAY",
                time: "16:40 - 17:10",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE FIRE FIGHTERS!",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:00 - 16:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:45 - 13:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:00 - 16:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:45 - 13:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:00 - 16:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:45 - 13:15",
            },
        ],
        imgUrl: "",
        url: "https://www.circadiantroupe.co.uk/",
    },
    {
        name: "THE FLAMENCO THIEF",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "14:15 - 15:15",
            },
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "13:30 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE FLAMINGOS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:00 - 17:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:40 - 15:25",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:00 - 17:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:45 - 15:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "17:00 - 17:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:45 - 15:30",
            },
        ],
        imgUrl: "",
        url: "http://www.artemisproductions.co.uk/",
    },
    {
        name: "THE FUTURE SHAPE OF SOUND",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "05:15 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/thefutureshapeofsound",
    },
    {
        name: "THE GIN BOWLERS",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "SATURDAY",
                time: "17:05 - 17:50",
            },
        ],
        imgUrl: "",
        url: "https://www.rachellawrencemusic.co.uk/the-gin-bowlers/",
    },
    {
        name: "THE GLASTONBURY VOX MOB",
        events: [
            {
                stage: "THE PAVEMENT",
                day: "WEDNESDAY",
                time: "15:45 - 16:30",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "THURSDAY",
                time: "15:00 - 15:45",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "16:05 - 16:50",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "16:40 - 17:25",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "14:55 - 15:55",
            },
        ],
        imgUrl: "",
        url: "https://www.thebeatboxcollective.com/",
    },
    {
        name: "THE GLOBAL COLLECTIVE",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SUNDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://seventhwavemusic.co.uk/",
    },
    {
        name: "THE GRUMBLECAT",
        events: [
            {
                stage: "PROFESSOR PANIC'S PUPPET ARENA",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE GUARDIAN LIVE INTERVIEW WITH MEL C",
        events: [
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "12:05 - 12:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE GUARDIAN LIVE INTERVIEW WITH SHARLEEN SPITERI",
        events: [
            {
                stage: "CABARET",
                day: "FRIDAY",
                time: "12:05 - 12:55",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE HIVEBORN",
        events: [
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "23:00 - 03:00",
            },
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "20:45 - 22:00",
            },
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "22:15 - 23:15",
            },
            {
                stage: "THE HIVE",
                day: "SATURDAY",
                time: "00:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE HIVES",
        events: [
            {
                stage: "OTHER STAGE",
                day: "FRIDAY",
                time: "13:00 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://www.thehives.com/",
    },
    {
        name: "THE HU",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thehuofficial.com/",
    },
    {
        name: "THE ILLUSTRIOUS BLACKS LIVE",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "18:50 - 19:50",
            },
        ],
        imgUrl: "",
        url: "https://theillustriousblacks.com/",
    },
    {
        name: "THE IMP",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "18:30 - 19:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:50 - 15:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "18:30 - 19:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:50 - 15:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:30 - 19:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:50 - 15:35",
            },
        ],
        imgUrl: "",
        url: "https://www.amadanensemble.com/",
    },
    {
        name: "THE JAM, IN HONOUR OF NIK TURNER",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
            {
                stage: "MANDALA STAGE",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/mandalastage/videos/1189661938337162/",
    },
    {
        name: "THE JOY",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SUNDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/thejoyofficialmusic/?hl=en",
    },
    {
        name: "THE KAIDEN NOLAN BAND",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/kaidennolan/",
    },
    {
        name: "THE KIDZFIELD PARADE",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE LAST DINNER PARTY",
        events: [
            {
                stage: "WOODSIES",
                day: "SATURDAY",
                time: "11:30 - 12:15",
            },
        ],
        imgUrl: "",
        url: "https://www.thelastdinnerparty.co.uk/",
    },
    {
        name: "THE LATHUMS",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SATURDAY",
                time: "13:00 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://www.thelathums.com/#home",
    },
    {
        name: "THE LIGHTING OF THE FIRE FOR THE FUTURE",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "SUNDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE LITTLE UNSAID",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "SMALL WORLD STAGE",
                day: "SUNDAY",
                time: "12:30 - 01:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE LIVING ARTS CO",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE LONE GROOVER",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "13:00 - 13:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE LOVE BUZZ",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "21:30 - 22:15",
            },
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "19:00 - 19:45",
            },
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "17:30 - 18:30",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "15:15 - 16:15",
            },
            {
                stage: "WOODSIES",
                day: "SUNDAY",
                time: "11:15 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thelovebuzz.com/",
    },
    {
        name: "THE MAGIC NUMBERS",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "14:00 - 14:40",
            },
        ],
        imgUrl: "",
        url: "http://themagicnumbers/",
    },
    {
        name: "THE MAGNIFICENT KEVENS",
        events: [
            {
                stage: "THE GATEWAY",
                day: "FRIDAY",
                time: "15:15 - 16:00",
            },
            {
                stage: "THE GATEWAY",
                day: "SATURDAY",
                time: "16:00 - 16:45",
            },
            {
                stage: "THE GATEWAY",
                day: "SUNDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:15 - 12:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:15 - 12:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:15 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://themagnificentkevens.com/",
    },
    {
        name: "THE MARCHING SKALETONS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "01:45 - 03:00",
            },
            {
                stage: "BIMBLE INN",
                day: "SUNDAY",
                time: "18:30 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://www.marchingskaletons.co.uk/",
    },
    {
        name: "THE MARY WALLOPERS",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "15:00 - 15:40",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/marywallopers/",
    },
    {
        name: "THE MASTER MUSICIANS OF JOUJOUKA",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "FRIDAY",
                time: "12:00 - 12:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/mastermusiciansofjoujouka/?hl=en",
    },
    {
        name: "THE MERMAID AND THE COW",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE MIDNIGHT ZU",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "18:45 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/themidnightzu",
    },
    {
        name: "THE MIGHTY MOJO",
        events: [
            {
                stage: "VILLAGE INN",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/mo__stewart?",
    },
    {
        name: "THE MINI TATE",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE MOANER LISA",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE MURDER CAPITAL",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "21:00 - 21:45",
            },
            {
                stage: "WOODSIES",
                day: "SATURDAY",
                time: "15:15 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://themurdercapital.com/",
    },
    {
        name: "THE ODD BEATS",
        events: [
            {
                stage: "GREENPEACE",
                day: "FRIDAY",
                time: "12:30 - 13:30",
            },
            {
                stage: "THE LIZARD STAGE",
                day: "SUNDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "BIMBLE INN",
                day: "THURSDAY",
                time: "21:30 - 22:30",
            },
        ],
        imgUrl: "",
        url: "http://www.theoddbeats.com/",
    },
    {
        name: "THE OLD TIME RAGS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:30 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/theoldtimerags/",
    },
    {
        name: "THE PANSY BOYS",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "19:55 - 20:25",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "20:30 - 20:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE PETEBOX",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "16:45 - 17:15",
            },
        ],
        imgUrl: "",
        url: "https://www.thepetebox.com/",
    },
    {
        name: "THE PETEBOX (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "http://www.thepetebox.com/",
    },
    {
        name: "THE PORTRAITS",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "13:35 - 14:20",
            },
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://theportraitsmusic.com/",
    },
    {
        name: "THE POWER OF MUSIC TO ACCELERATE CLIMATE ACTION",
        events: [
            {
                stage: "THE INFORMATION",
                day: "FRIDAY",
                time: "13:15 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE POWER OF PUBLICITY",
        events: [
            {
                stage: "THE INFORMATION",
                day: "SATURDAY",
                time: "13:15 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE PRINCES OF 80S POP",
        events: [
            {
                stage: "VILLAGE INN",
                day: "SUNDAY",
                time: "14:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE RIGHT TO DANCE PRESENTS: 'MIGRANT FOOTPRINT'",
        events: [
            {
                stage: "THE INFORMATION",
                day: "SATURDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE ROYSTON CLUB",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "SATURDAY",
                time: "11:00 - 11:40",
            },
            {
                stage: "BREAD AND ROSES",
                day: "SUNDAY",
                time: "12:00 - 12:40",
            },
        ],
        imgUrl: "",
        url: "https://theroystonclub.com/",
    },
    {
        name: "THE RUNAWAY CHRISTMAS TREE FAIRY",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "22:30 - 23:15",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "21:30 - 22:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "22:30 - 23:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "21:30 - 22:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "22:30 - 23:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "21:30 - 22:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/runaway.tree.fairy",
    },
    {
        name: "THE SAW DOCTORS",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "FRIDAY",
                time: "21:30 - 22:45",
            },
        ],
        imgUrl: "",
        url: "http://sawdoctors.com/",
    },
    {
        name: "THE SCHMOOZENBERGS",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "11:00 - 11:45",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "FRIDAY",
                time: "11:00 - 11:45",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SUNDAY",
                time: "22:20 - 22:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE SCRIBES",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
            {
                stage: "STRUMMERVILLE",
                day: "SUNDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "00:10 - 01:10",
            },
            {
                stage: "BIMBLE INN",
                day: "SATURDAY",
                time: "15:45 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/scribesmusic/",
    },
    {
        name: "THE SHARON SHANNON TRIO",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SATURDAY",
                time: "15:00 - 15:40",
            },
        ],
        imgUrl: "",
        url: "http://%20http//sharonshannon.com",
    },
    {
        name: "THE SHOWHAWK DUO",
        events: [
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "23:30 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/showhawkduo",
    },
    {
        name: "THE SILHOUETTES PROJECT",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "THURSDAY",
                time: "23:30 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/thesilhouettesproject/",
    },
    {
        name: "THE SIXSTERS",
        events: [
            {
                stage: "WOODSIES",
                day: "FRIDAY",
                time: "11:30 - 12:15",
            },
        ],
        imgUrl: "",
        url: "https://the-sixsters.com/",
    },
    {
        name: "THE SKY AT DAY",
        events: [
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "14:15 - 15:00",
            },
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "11:15 - 12:00",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "14:45 - 15:30",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "11:45 - 12:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:05 - 16:50",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "12:05 - 12:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://dodifferent.co.uk/",
    },
    {
        name: "THE SMALLEST RACE ON EARTH",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:30 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "13:30 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:10 - 11:40",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:30 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:30 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:30 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "13:30 - 14:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:10 - 11:40",
            },
        ],
        imgUrl: "",
        url: "http://www.compagniemiaow.com/",
    },
    {
        name: "THE SOCIAL W/ C&S, PETE FOWLER + SCARLETT O\u2019MALLEY",
        events: [
            {
                stage: "STONEBRIDGE BAR",
                day: "SATURDAY",
                time: "14:30 - 16:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE SPACE FALCONS",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://spacefalcons.com/",
    },
    {
        name: "THE SPANISH GENTLEMAN JUGGLER",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "17:47 - 18:17",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "15:33 - 16:03",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "14:36 - 15:06",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "FRIDAY",
                time: "13:10 - 13:40",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SATURDAY",
                time: "18:25 - 18:55",
            },
            {
                stage: "A LITTLE MORE SENSATION",
                day: "SUNDAY",
                time: "12:00 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.lascossasnostra.com/breaking-broken-dreams---eng",
    },
    {
        name: "THE SPICE BOYZ [RUFFNEK DISCOTEK X TUN UP!]",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/people/ruffnek-diskotek/100066917265427/",
    },
    {
        name: "THE SPLINTERS",
        events: [
            {
                stage: "AVALON CAF\u00c9",
                day: "THURSDAY",
                time: "10:00 - 10:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE STEVE HILLAGE BAND",
        events: [
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "23:15 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/stevehillageband",
    },
    {
        name: "THE SUMMER OF LOVE BIKE",
        events: [
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "14:00 - 14:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:45 - 17:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://steveapelt.co.uk/",
    },
    {
        name: "THE SUPER MARIO BROS. MOVIE U",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "THURSDAY",
                time: "19:30 - 21:02",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt6718170/",
    },
    {
        name: "THE T.U.R.D.I.S. PORTALOO ESCAPE ROOM",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "THURSDAY",
                time: "11:00 - 19:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "11:00 - 19:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "11:00 - 19:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "11:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.bewilderbox.co.uk/portaclue",
    },
    {
        name: "THE TAPHOUSE BAND FEAT CHARLEY MACAULEY",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "THURSDAY",
                time: "19:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/charleymacaulay/?hl=en",
    },
    {
        name: "THE TAPHOUSE BAND FEAT JONATHAN FASHOLE-LUKE",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "SUNDAY",
                time: "19:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/jayefel/",
    },
    {
        name: "THE TAPHOUSE BAND FEAT SHANNON B",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "SATURDAY",
                time: "19:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/shannonbmusic91/",
    },
    {
        name: "THE TAPHOUSE BAND FEAT SIAN UNWIN",
        events: [
            {
                stage: "THE TAPHOUSE",
                day: "FRIDAY",
                time: "19:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/shunwin_bass/",
    },
    {
        name: "THE TESKEY BROTHERS",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SUNDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.theteskeybrothers.com/",
    },
    {
        name: "THE TRIFLEENEES",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:40 - 16:25",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "11:50 - 12:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:40 - 16:25",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "11:50 - 12:35",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:40 - 16:25",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "11:50 - 12:35",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE TROJANS",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "THURSDAY",
                time: "01:45 - 03:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "FRIDAY",
                time: "03:00 - 05:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "SATURDAY",
                time: "03:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://www.gazrockin.com/thetrojans",
    },
    {
        name: "THE TROUBLE NOTES",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "SUNDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "THURSDAY",
                time: "16:30 - 17:30",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://thetroublenotes.com/",
    },
    {
        name: "THE UNTHANKS",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SATURDAY",
                time: "11:45 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.the-unthanks.com/",
    },
    {
        name: "THE VERY BEST OF TOMMY COOPER",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "18:45 - 19:45",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "18:45 - 19:45",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "17:55 - 18:55",
            },
        ],
        imgUrl: "",
        url: "https://danieltaylorproductions.co.uk/",
    },
    {
        name: "THE VISIONARY",
        events: [
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "17:20 - 18:05",
            },
            {
                stage: "THE GLEBE",
                day: "FRIDAY",
                time: "13:10 - 13:55",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "17:20 - 18:05",
            },
            {
                stage: "THE GLEBE",
                day: "SATURDAY",
                time: "13:10 - 13:55",
            },
            {
                stage: "THE GLEBE",
                day: "SUNDAY",
                time: "16:10 - 16:55",
            },
            {
                stage: "THE GLEBE",
                day: "SUNDAY",
                time: "13:10 - 13:55",
            },
        ],
        imgUrl: "",
        url: "https://www.thejonhicks.com/",
    },
    {
        name: "THE WAR ON DRUGS",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SUNDAY",
                time: "19:45 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://www.thewarondrugs.net/",
    },
    {
        name: "THE WARDENS",
        events: [
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "17:30 - 18:15",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "15:45 - 16:15",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "15:15 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "12:15 - 13:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "15:15 - 16:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "12:15 - 13:00",
            },
        ],
        imgUrl: "",
        url: "https://the2men.co.uk/",
    },
    {
        name: "THE WICKER MAN: 50TH ANNIVERSARY RELEASE 15",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "WEDNESDAY",
                time: "22:00 - 23:34",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt0070917/",
    },
    {
        name: "THE WITCHES AND THEIR FLYING HIGH LUBRICATION",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "SATURDAY",
                time: "14:00 - 14:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THE WOOD DEMONS",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "FRIDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://thewooddemons/",
    },
    {
        name: "THE WOODCRAFT ELDERS",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THEE ONES",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "SMALL WORLD STAGE",
                day: "SATURDAY",
                time: "22:30 - 23:30",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/thee1s/?locale=en_gb",
    },
    {
        name: "THIRD WORLD",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thirdworldband.com/",
    },
    {
        name: "THIS IS INJA",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/inja.makermusic",
    },
    {
        name: "THIS IS NOW DJS",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "21:30 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://www.thisisnowagency.com/",
    },
    {
        name: "THIS LITTLE TRACTOR",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "FRIDAY",
                time: "18:15 - 19:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "THREE DAFT MONKEYS",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "WEDNESDAY",
                time: "20:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.3daftmonkeys.co.uk/",
    },
    {
        name: "THRILL COLLINS",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "13:00 - 14:00",
            },
            {
                stage: "BREAD AND ROSES",
                day: "FRIDAY",
                time: "17:00 - 17:40",
            },
        ],
        imgUrl: "",
        url: "https://www.thrillcollins.co.uk/",
    },
    {
        name: "THRILL COLLINS AND FRIENDS",
        events: [
            {
                stage: "BREAD AND ROSES",
                day: "SUNDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.thrillcollins.co.uk/",
    },
    {
        name: "THUNDERCAT",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SUNDAY",
                time: "19:45 - 20:45",
            },
        ],
        imgUrl: "",
        url: "https://theamazingthundercat.com/",
    },
    {
        name: "TIA COUSINS",
        events: [
            {
                stage: "NOWHERE",
                day: "THURSDAY",
                time: "15:00 - 15:30",
            },
        ],
        imgUrl: "",
        url: "http://tia%20cousins%20(@xn--tiaxcousins%29%20%20instagram%20photos%20and%20videos-t807a/",
    },
    {
        name: "TIDDLES",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/carmelr21_aka_tiddles/?igshid=ymmymta2m2y%3d",
    },
    {
        name: "TIGHTROPE SHOW WITH POEBE BAKER",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "15:30 - 15:50",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "15:30 - 15:50",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SUNDAY",
                time: "15:30 - 15:50",
            },
        ],
        imgUrl: "",
        url: "http://nil/",
    },
    {
        name: "TIGHTROPE WORKSHOP WITH PHOEBE BAKER",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "13:30 - 14:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "11:30 - 12:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "13:30 - 12:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "11:30 - 12:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "13:30 - 14:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "11:30 - 12:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SUNDAY",
                time: "13:30 - 14:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SUNDAY",
                time: "11:30 - 12:30",
            },
        ],
        imgUrl: "",
        url: "http://nil/",
    },
    {
        name: "TILLY LEE-KRONICK",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "THURSDAY",
                time: "17:20 - 17:26",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "16:53 - 16:59",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "13:49 - 13:55",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "20:52 - 20:58",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "16:59 - 17:05",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SUNDAY",
                time: "16:15 - 16:21",
            },
        ],
        imgUrl: "",
        url: "https://tillyleekronick.wixsite.com/performer",
    },
    {
        name: "TIM GARCIA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SUNDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/timoteeg/",
    },
    {
        name: "TIM HEALEY",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "THURSDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/timhealey/biography",
    },
    {
        name: "TIME IS NOW: ELL MURPHY",
        events: [
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/ells_bellss/",
    },
    {
        name: "TIME IS NOW: FLISS MAYO",
        events: [
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/flissmayo/",
    },
    {
        name: "TIME IS NOW: MAINPHASE B2B BAKEY",
        events: [
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/bakey_____/",
    },
    {
        name: "TIME IS NOW: NICKY SOFT TOUCH B2B KGW",
        events: [
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/timeisnowbristol/",
    },
    {
        name: "TIME IS NOW: NIKKI NAIR B2B DJ ADHD",
        events: [
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/nikki__nair/",
    },
    {
        name: "TIME IS NOW: SAMURAI BREAKS B2B NAINA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "THURSDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/samurai_breaks/",
    },
    {
        name: "TIMMY REGISFORD (SHELTER - NYC)",
        events: [
            {
                stage: "NYC DOWNLOW",
                day: "SUNDAY",
                time: "00:35 - 01:50",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/timmyregisford",
    },
    {
        name: "TINARIWEN",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SATURDAY",
                time: "18:15 - 19:15",
            },
        ],
        imgUrl: "",
        url: "https://www.tinariwen.com/",
    },
    {
        name: "TINY K",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "22:30 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/its_only_tiny/",
    },
    {
        name: "TOAD HALL OPENING WITH NIGEL SHAW",
        events: [
            {
                stage: "TOAD HALL",
                day: "WEDNESDAY",
                time: "15:00 - 15:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TOBY 2 SHOES",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SUNDAY",
                time: "00:30 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/toby2shoes",
    },
    {
        name: "TOBY SPIN",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SUNDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/tobyspin",
    },
    {
        name: "TOBY SPIN (COMPERE)",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "22:15 - 02:50",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "22:00 - 03:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "23:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TOKKY HORROR",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "SATURDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "http://www.tokkyhorror.com/",
    },
    {
        name: "TOM A SMITH",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "16:00 - 16:35",
            },
        ],
        imgUrl: "",
        url: "https://www.tomasmithmusic.com/",
    },
    {
        name: "TOM A. SMITH",
        events: [
            {
                stage: "LEFT FIELD",
                day: "SUNDAY",
                time: "17:00 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://www.tomasmithmusic.com/",
    },
    {
        name: "TOM BRIGHT",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "THURSDAY",
                time: "17:00 - 17:40",
            },
        ],
        imgUrl: "",
        url: "http://www.tombright.co.uk/",
    },
    {
        name: "TOM COLLINSON",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "WEDNESDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "http://ocean%20protection/",
    },
    {
        name: "TOM GRENNAN",
        events: [
            {
                stage: "OTHER STAGE",
                day: "SATURDAY",
                time: "14:15 - 15:15",
            },
        ],
        imgUrl: "",
        url: "https://www.tomgrennanmusic.com/",
    },
    {
        name: "TOM MCGUIRE AND THE BRASSHOLES",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "FRIDAY",
                time: "01:45 - 02:30",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "SUNDAY",
                time: "21:00 - 21:45",
            },
        ],
        imgUrl: "",
        url: "https://www.tomandthebrassholes.com/",
    },
    {
        name: "TOM MCQ",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/tommcqofficial/",
    },
    {
        name: "TOM MOORE & ARCHIE MOSS",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "16:20 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.tommoorearchiemoss.com/",
    },
    {
        name: "TOM RAVENSCROFT",
        events: [
            {
                stage: "SAN REMO",
                day: "FRIDAY",
                time: "12:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.tomravenscroft.co.uk/",
    },
    {
        name: "TOM TAPEY",
        events: [
            {
                stage: "THE BUG",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/tapey",
    },
    {
        name: "TOM WARD",
        events: [
            {
                stage: "CABARET",
                day: "SATURDAY",
                time: "00:50 - 01:20",
            },
            {
                stage: "CABARET",
                day: "SUNDAY",
                time: "19:20 - 19:50",
            },
        ],
        imgUrl: "",
        url: "https://www.tomwardvoice.com/",
    },
    {
        name: "TONY ANDREWS ECLECTIC GROOVE",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "18:50 - 19:50",
            },
        ],
        imgUrl: "",
        url: "https://funktion-one.com/",
    },
    {
        name: "TOO MANY T'S",
        events: [
            {
                stage: "BIMBLE INN",
                day: "FRIDAY",
                time: "00:15 - 01:15",
            },
        ],
        imgUrl: "",
        url: "https://www.toomanyts.com/",
    },
    {
        name: "TOO MANY T'S WELCOME PARTY",
        events: [
            {
                stage: "TRUTH STAGE",
                day: "THURSDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/toomanyts/",
    },
    {
        name: "TOO MANY T'S X MR.SWITCH (BLENDID TAKEOVER) 50 YEARS OF HIP HOP CELEBRATION",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "SATURDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://www.toomanyts.com/",
    },
    {
        name: "TORNADO WALLACE",
        events: [
            {
                stage: "SAN REMO",
                day: "THURSDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/tornadowallace/?hl=en",
    },
    {
        name: "TORREY SHINE",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SUNDAY",
                time: "16:50 - 17:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TOTALLY ENORMOUS EXTINCT DINOSAURS DJ SET",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/totallyenormousextinctdinosaurs",
    },
    {
        name: "TOWN OF CATS",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "THURSDAY",
                time: "23:15 - 00:30",
            },
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.townofcats.co.uk/",
    },
    {
        name: "TOYA DELAZY",
        events: [
            {
                stage: "NOMAD",
                day: "SUNDAY",
                time: "01:00 - 01:30",
            },
            {
                stage: "THE RUM SHACK",
                day: "SATURDAY",
                time: "00:00 - 00:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/toyadelazy/",
    },
    {
        name: "TOYAH WILLCOX & ROBERT FRIPP",
        events: [
            {
                stage: "ACOUSTIC STAGE",
                day: "SUNDAY",
                time: "16:10 - 17:10",
            },
        ],
        imgUrl: "",
        url: "https://www.toyahwillcox.com/",
    },
    {
        name: "TRABAN",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TRACK DOGS",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "CROISSANT NEUF BANDSTAND",
                day: "SATURDAY",
                time: "17:30 - 18:00",
            },
            {
                stage: "AVALON CAF\u00c9",
                day: "SATURDAY",
                time: "00:15 - 01:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TRACK DOGS & STEVE KNIGHTLEY",
        events: [
            {
                stage: "CROISSANT NEUF",
                day: "FRIDAY",
                time: "13:00 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://trackdogsmusic.com/",
    },
    {
        name: "TRANSGRESSIVE RECORDS TAKEOVER",
        events: [
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "02:30 - 04:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "01:30 - 02:30",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "00:00 - 01:30",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "FRIDAY",
                time: "23:00 - 00:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "17:00 - 18:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SUNDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "http://www.transgressiverecords.com/",
    },
    {
        name: "TRAVELLER CULTURE",
        events: [
            {
                stage: "THE GATEWAY",
                day: "FRIDAY",
                time: "13:50 - 14:35",
            },
            {
                stage: "THE GATEWAY",
                day: "SATURDAY",
                time: "15:10 - 15:55",
            },
            {
                stage: "THE GATEWAY",
                day: "SUNDAY",
                time: "16:20 - 17:05",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TRAVIS ALABANZA",
        events: [
            {
                stage: "POETRY&WORDS",
                day: "SATURDAY",
                time: "18:26 - 18:56",
            },
        ],
        imgUrl: "",
        url: "https://travisalabanza.co.uk/",
    },
    {
        name: "TREVOR MOSS & HANNAH LOU",
        events: [
            {
                stage: "BIMBLE INN",
                day: "SUNDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TRIGG3R",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TRIPSWITCH",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "21:15 - 22:25",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/nicktripswitch",
    },
    {
        name: "TROL23",
        events: [
            {
                stage: "VILLAGE INN",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "VILLAGE INN",
                day: "FRIDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://web.facebook.com/trol23",
    },
    {
        name: "TWICE SHY",
        events: [
            {
                stage: "THE MEAT RACK",
                day: "THURSDAY",
                time: "23:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/zoeaguilera/?hl=en",
    },
    {
        name: "TWISTED TIME MACHINE",
        events: [
            {
                stage: "GREENPEACE",
                day: "WEDNESDAY",
                time: "12:50 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.twistedtimemachine.com/",
    },
    {
        name: "TWISTER WITH DICK PULSING",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "12:00 - 12:25",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "12:00 - 12:25",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SUNDAY",
                time: "12:00 - 12:25",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "TYRONE SCOTT",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "THURSDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "http://climate%2C%20colonialism%2C%20reparations/",
    },
    {
        name: "UBUNTO",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SUNDAY",
                time: "01:45 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/ubunto3mundo/",
    },
    {
        name: "UKELELE THRASH MOB",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "17:50 - 18:35",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "15:05 - 15:50",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "17:10 - 17:55",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "13:45 - 14:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:15 - 19:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "14:30 - 15:15",
            },
        ],
        imgUrl: "",
        url: "https://garybridgens.com/",
    },
    {
        name: "UKULELE WORKSHOP",
        events: [
            {
                stage: "TOAD HALL",
                day: "THURSDAY",
                time: "12:15 - 13:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FREINDS RAVE TAKEOVER - UNCLE DUGS / BOXER BANTON",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/uncledugs",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - 2 - TU",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "12:00 - 13:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - CROSSY",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - DADDY NATURE & DANSEY",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - DANSEY",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - DUGSY MALONE",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - JOHNNY EARL",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - LEEROY THORNHILL (EX PRODIGY)",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://leeroythornhill.com/",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - MARK ARCHER ALTERN 8",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/mrnex",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - MARK XTC",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/mark-xtc-2",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - MOZEY",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "05:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - ROB DA BANK",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "15:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - ROMPA / SUMBA YOUTH",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://bornonroad.com/",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - SERKUS & DONI K",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - STREETWISE",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS RAVE TAKEOVER - WOODY COOK",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "20:00 - 21:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNCLE DUGS & FRIENDS TAKEOVER - EARL NEVILLE",
        events: [
            {
                stage: "BLIND TIGER",
                day: "SATURDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.bbc.co.uk/programmes/b006wknd",
    },
    {
        name: "UNCOMMON RECORDS VS GORILLA TACTICS; CLOSING PARTY SPECIAL",
        events: [
            {
                stage: "THE TEMPLE",
                day: "SUNDAY",
                time: "04:00 - 05:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/gorillatacticscrew/",
    },
    {
        name: "UNCOMMON RECORDS; JIM BITCH B2B FRD FT. JAGO",
        events: [
            {
                stage: "THE TEMPLE",
                day: "THURSDAY",
                time: "02:00 - 03:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/uncommonrecordsuk/",
    },
    {
        name: "UNDERFOOT, OVERLOOKED: SOIL AS OUR MUSE\n A DAY OF WORKSHOPS AND DROP-IN ACTIVITIES RELATING TO SOIL HOSTED BY POPPY FLINT & BENJI BAILES",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "WEDNESDAY",
                time: "15:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNDERFOOT: LIFE AMONGST THE ROOTS (INSTALLATION). BY POPPY FLINT & BENJI BAILES WITH CONTRIBUTING ARTISTS LEX KOSANKE, MICHELLE TYLICKI AND BARRINGTON",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "WEDNESDAY",
                time: "19:00 - 21:00",
            },
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "20:30 - 22:00",
            },
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "20:30 - 22:00",
            },
            {
                stage: "THE RHIZOSPHERE",
                day: "SATURDAY",
                time: "20:00 - 22:00",
            },
            {
                stage: "THE RHIZOSPHERE",
                day: "SUNDAY",
                time: "19:15 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "UNDERGROUND RESISTANCE \n PRESENTS MARK FLASH (LIVE)",
        events: [
            {
                stage: "IICON",
                day: "SUNDAY",
                time: "00:30 - 02:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/undergroundresistance%20https://www.markflashmusic.com/",
    },
    {
        name: "UNGLUED AND CARASEL",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "http://unglued%20(@unglueddnb%29%20%7C%20instagram/",
    },
    {
        name: "UNKNOWN MORTAL ORCHESTRA",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "FRIDAY",
                time: "16:45 - 17:45",
            },
        ],
        imgUrl: "",
        url: "https://www.unknownmortalorchestra.com/",
    },
    {
        name: "UPCYCLE EXTRAVAGANZA",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "US",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "FRIDAY",
                time: "05:00 - 06:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "SUNDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "STRUMMERVILLE",
                day: "FRIDAY",
                time: "16:45 - 17:15",
            },
        ],
        imgUrl: "",
        url: "http://www.usbandofficial.com/",
    },
    {
        name: "VAMOS THEATRE",
        events: [
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "18:00 - 18:45",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "18:00 - 18:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "16:15 - 17:00",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "18:00 - 18:45",
            },
            {
                stage: "WALKABOUTS",
                day: "SUNDAY",
                time: "16:15 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://www.vamostheatre.co.uk/",
    },
    {
        name: "VC PINES",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "15:00 - 15:45",
            },
        ],
        imgUrl: "",
        url: "https://www.vcpines.com/",
    },
    {
        name: "VELVET FUZZ",
        events: [
            {
                stage: "THE ROCKET LOUNGE",
                day: "FRIDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "THE ROCKET LOUNGE",
                day: "SATURDAY",
                time: "05:00 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/keatonsmout/?hl=en",
    },
    {
        name: "VELVET MARBLES",
        events: [
            {
                stage: "THE KIDZ FIELD",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "THE KIDZ FIELD",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "VENBEE",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "FRIDAY",
                time: "21:30 - 22:15",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "VENUS",
        events: [
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "13:35 - 14:05",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "16:19 - 16:49",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "18:15 - 18:45",
            },
            {
                stage: "THE PAVEMENT",
                day: "FRIDAY",
                time: "16:05 - 16:35",
            },
            {
                stage: "THE PAVEMENT",
                day: "SATURDAY",
                time: "13:10 - 13:40",
            },
            {
                stage: "THE PAVEMENT",
                day: "SUNDAY",
                time: "14:20 - 14:50",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "VIA TRIO",
        events: [
            {
                stage: "TOAD HALL",
                day: "WEDNESDAY",
                time: "19:30 - 20:15",
            },
            {
                stage: "TOAD HALL",
                day: "SUNDAY",
                time: "13:30 - 14:15",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/viatrio/about",
    },
    {
        name: "VIAGRA BOYS",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SUNDAY",
                time: "16:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.vboysstockholm.com/",
    },
    {
        name: "VICTORIA GUGENHEIM",
        events: [
            {
                stage: "GLEBELAND",
                day: "THURSDAY",
                time: "13:00 - 16:30",
            },
            {
                stage: "GLEBELAND",
                day: "FRIDAY",
                time: "13:00 - 16:30",
            },
            {
                stage: "GLEBELAND",
                day: "SATURDAY",
                time: "13:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "http://gugenheim.co.uk/",
    },
    {
        name: "VIGRO DEEP",
        events: [
            {
                stage: "IICON",
                day: "SATURDAY",
                time: "21:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/vigrodeep_za/?hl=en",
    },
    {
        name: "VILLAGE CUTS",
        events: [
            {
                stage: "BABYLON UPRISING",
                day: "THURSDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/villagecuts.ldn/",
    },
    {
        name: "VILLAGE UNDERGROUND: AMALIAH B2B ALETHA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SATURDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/amaliahppeche/",
    },
    {
        name: "VILLAGE UNDERGROUND: CHARLES GREEN B2B T DUNN",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SATURDAY",
                time: "21:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/tdunntimehri/",
    },
    {
        name: "VILLAGE UNDERGROUND: ELKKA B2B TBA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SATURDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/elkkamusic/",
    },
    {
        name: "VILLAGE UNDERGROUND: EMERALD B2B OTIK",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SATURDAY",
                time: "01:00 - 02:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "VILLAGE UNDERGROUND: KEEP HUSH W/ LCY B2B MISFYA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SATURDAY",
                time: "04:30 - 06:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/keephushuk/",
    },
    {
        name: "VILLAGE UNDERGROUND: SUCHI B2B PARRIS",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SATURDAY",
                time: "02:00 - 03:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/______suchi______/",
    },
    {
        name: "VILLAGE UNDERGROUND: TBA",
        events: [
            {
                stage: "PLATFORM 23",
                day: "SATURDAY",
                time: "03:30 - 04:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "VINTAGE TROUBLE",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SATURDAY",
                time: "23:05 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://vintagetrouble.com/",
    },
    {
        name: "VIVA COLECTIVA",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "SATURDAY",
                time: "14:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/colectivamusic/",
    },
    {
        name: "VLADA",
        events: [
            {
                stage: "THE WOW",
                day: "FRIDAY",
                time: "20:30 - 22:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "VLURE",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SATURDAY",
                time: "15:50 - 16:20",
            },
            {
                stage: "THE HIVE",
                day: "FRIDAY",
                time: "00:30 - 01:30",
            },
            {
                stage: "BREAD AND ROSES",
                day: "THURSDAY",
                time: "23:30 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/vlure.gla",
    },
    {
        name: "VOGUE FABRICS DALSTON PRESENT TALANOA FEATURING:\n BLACK OBSIDIAN SOUND SYSTEM, BLACK TRANS PROJECT,\n DECOLONISE FEST, FAGGAMUFFIN, LADIES MUSIC PUB",
        events: [
            {
                stage: "NOMAD",
                day: "THURSDAY",
                time: "17:00 - 20:00",
            },
            {
                stage: "NOMAD",
                day: "FRIDAY",
                time: "17:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "VOICE WORKSHOPS",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/listentoleti/",
    },
    {
        name: "VOICE WORKSHOPS WITH LETI",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "THURSDAY",
                time: "15:15 - 16:15",
            },
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "FRIDAY",
                time: "15:00 - 16:00",
            },
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SUNDAY",
                time: "14:45 - 15:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/listentoleti/",
    },
    {
        name: "VOU FIJI DANCE CO",
        events: [
            {
                stage: "THE ASTROLABE THEATRE",
                day: "FRIDAY",
                time: "16:25 - 17:15",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SATURDAY",
                time: "16:25 - 17:15",
            },
            {
                stage: "THE ASTROLABE THEATRE",
                day: "SUNDAY",
                time: "15:35 - 16:25",
            },
        ],
        imgUrl: "",
        url: "https://vouhubfiji.com/",
    },
    {
        name: "VTSS",
        events: [
            {
                stage: "ARCADIA",
                day: "SATURDAY",
                time: "02:00 - 03:00",
            },
            {
                stage: "THE LEVELS",
                day: "THURSDAY",
                time: "01:30 - 03:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WALLACE & GROMIT: THE CURSE OF THE WERE-RABBIT U",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "WEDNESDAY",
                time: "13:00 - 14:25",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt0312004/",
    },
    {
        name: "WARPAINT",
        events: [
            {
                stage: "WOODSIES",
                day: "FRIDAY",
                time: "21:00 - 22:00",
            },
        ],
        imgUrl: "",
        url: "https://www.warpaintwarpaint.com/",
    },
    {
        name: "WATCH THE BIRDIE",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "16:00 - 17:30",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "12:30 - 14:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "16:00 - 17:30",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "12:30 - 14:00",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "16:00 - 17:30",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "12:30 - 14:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WATCHA",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "FRIDAY",
                time: "23:00 - 00:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/watcha_dj/",
    },
    {
        name: "WAYNE AND WANDA",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "FRIDAY",
                time: "22:30 - 00:00",
            },
            {
                stage: "CIRCUS FIELD",
                day: "SATURDAY",
                time: "22:30 - 00:00",
            },
        ],
        imgUrl: "",
        url: "https://www.wayneandwanda.co.uk/",
    },
    {
        name: "WE BELONG TO THE EARTH: ROOTS, GATHERING, CONNECTIONS, HISTORIES AND FUTURES \n A DAY OF CREATIVE WORKSHOPS, TALKS AND DROP-IN ACTTIVITIES HOSTED BY LION - LAND IN OUR NAMES.",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "12:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WEEKENDER + POST SCREENING DJ SET",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "THURSDAY",
                time: "01:45 - 03:05",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt8455642/",
    },
    {
        name: "WERKHA",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "FRIDAY",
                time: "18:15 - 19:00",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "21:50 - 22:30",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "SATURDAY",
                time: "18:30 - 19:00",
            },
        ],
        imgUrl: "",
        url: "https://www.werkha.com/",
    },
    {
        name: "WEST HOLTS QUIZ",
        events: [
            {
                stage: "THE WEST HOLTS BAR",
                day: "THURSDAY",
                time: "13:30 - 15:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WEYES BLOOD",
        events: [
            {
                stage: "THE PARK STAGE",
                day: "SUNDAY",
                time: "15:15 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.weyesblood.com/",
    },
    {
        name: "WHAM! NETFLIX EXCLUSIVE PREVIEW",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SUNDAY",
                time: "13:00 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.nme.com/news/film/wham-documentary-in-development-netflix-andrew-ridgeley-3241511",
    },
    {
        name: "WHAM! SING-A-LONG",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "WEDNESDAY",
                time: "16:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WHEEL OF FOUR TUNES",
        events: [
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "THURSDAY",
                time: "00:00 - 01:00",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "FRIDAY",
                time: "01:50 - 02:50",
            },
            {
                stage: "SENSATION SEEKERS STAGE",
                day: "SATURDAY",
                time: "23:00 - 00:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WHISTLING TREASON",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "19:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WHO KNEW (LIVE) FT SEPIA X ICKLE",
        events: [
            {
                stage: "NOWHERE",
                day: "SATURDAY",
                time: "23:00 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/who_knew__/%20%20%20%20%20%20%20https://www.instagram.com/sepiamusicuk/%20%20%20%20https://www.instagram.com/icklegram/",
    },
    {
        name: "WHY DOES IT ALWAYS RAIN ON ME? IS IT BECAUSE BIG OIL LIED BACK IN THE 70S? DARREN JONES MP, LUCY SYMONS-JONES & NIGEL SHIPLEY",
        events: [
            {
                stage: "LABORATORY STAGE",
                day: "SATURDAY",
                time: "15:00 - 15:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WHYCHBURY BAND",
        events: [
            {
                stage: "THE LIZARD STAGE",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://wychbury.bandcamp.com/album/unmarked-grave",
    },
    {
        name: "WICKED WINGS",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WILD FANTASY",
        events: [
            {
                stage: "THE MEETING PLACE BAR",
                day: "SATURDAY",
                time: "16:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/wildfantasybtn/",
    },
    {
        name: "WILFY D",
        events: [
            {
                stage: "GLADE DOME",
                day: "SATURDAY",
                time: "14:00 - 15:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/wilfy.d/?hl=en",
    },
    {
        name: "WILKINSON",
        events: [
            {
                stage: "ARCADIA",
                day: "SUNDAY",
                time: "01:30 - 02:30",
            },
        ],
        imgUrl: "",
        url: "https://www.wilkinson-music.com/",
    },
    {
        name: "WILL HODGKINSON",
        events: [
            {
                stage: "FREE UNIVERSITY OF GLASTONBURY",
                day: "SATURDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "http://www.willhodgkinsonwriter.com/",
    },
    {
        name: "WILL KAYALL",
        events: [
            {
                stage: "RABBIT HOLE'S FUNKINGHAM PALACE",
                day: "SUNDAY",
                time: "22:30 - 23:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/wkayll/",
    },
    {
        name: "WILL SKILLZ",
        events: [
            {
                stage: "STRUMMERVILLE",
                day: "SATURDAY",
                time: "00:30 - 01:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WILL YOUNG",
        events: [
            {
                stage: "AVALON STAGE",
                day: "SUNDAY",
                time: "16:50 - 17:50",
            },
        ],
        imgUrl: "",
        url: "https://willyoung.co.uk/",
    },
    {
        name: "WILLIAM CRIGHTON",
        events: [
            {
                stage: "GREENPEACE",
                day: "SUNDAY",
                time: "13:30 - 14:15",
            },
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "14:40 - 15:40",
            },
            {
                stage: "THE RABBIT HOLE",
                day: "SATURDAY",
                time: "15:00 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://williamcrightonmusic.com.au/",
    },
    {
        name: "WILSON PHOENIX",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SATURDAY",
                time: "18:00 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/wilsonphoenix",
    },
    {
        name: "WIM HOFF",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SATURDAY",
                time: "11:30 - 12:30",
            },
        ],
        imgUrl: "",
        url: "https://www.wimhofmethod.com/instructors/julianvon-dueffel",
    },
    {
        name: "WIM HOFF WITH JULIAN VON",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "THURSDAY",
                time: "12:45 - 13:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/julian_vondueffel",
    },
    {
        name: "WITHNAIL AND I 15",
        events: [
            {
                stage: "PILTON PALAIS CINEMA",
                day: "SATURDAY",
                time: "16:45 - 18:33",
            },
        ],
        imgUrl: "",
        url: "https://www.imdb.com/title/tt0094336/",
    },
    {
        name: "WIZARD OTR",
        events: [
            {
                stage: "DELUXE DINER",
                day: "THURSDAY",
                time: "20:00 - 22:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WIZKID",
        events: [
            {
                stage: "OTHER STAGE",
                day: "FRIDAY",
                time: "22:30 - 23:45",
            },
        ],
        imgUrl: "",
        url: "https://www.wizkidofficial.com/",
    },
    {
        name: "WOBBLE AND WHEEZE",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "https://www.youtube.com/wobbleandwheeze",
    },
    {
        name: "WONKA",
        events: [
            {
                stage: "THE RUM SHACK",
                day: "SUNDAY",
                time: "03:00 - 04:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/wonkajames/",
    },
    {
        name: "WONKY BIKE",
        events: [
            {
                stage: "RIMSKI'S YARD",
                day: "SUNDAY",
                time: "16:00 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://www.rimskipiano.org/",
    },
    {
        name: "WOOKEY HOLE CIRCUS",
        events: [
            {
                stage: "CIRCUS BIG TOP",
                day: "FRIDAY",
                time: "12:10 - 12:25",
            },
            {
                stage: "CIRCUS BIG TOP",
                day: "SATURDAY",
                time: "12:10 - 12:25",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "FRIDAY",
                time: "13:15 - 13:30",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SATURDAY",
                time: "13:15 - 13:30",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "15:11 - 15:26",
            },
            {
                stage: "OUTSIDE CIRCUS STAGE",
                day: "SUNDAY",
                time: "12:35 - 12:50",
            },
        ],
        imgUrl: "",
        url: "https://www.wookeyholecircus.co.uk/",
    },
    {
        name: "WORKING BOYS CLUB",
        events: [
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "BELLA'S FIELD",
                day: "FRIDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SATURDAY",
                time: "13:00 - 13:45",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "15:30 - 16:15",
            },
            {
                stage: "BELLA'S FIELD",
                day: "SUNDAY",
                time: "13:00 - 13:45",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WORKING MEN'S CLUB",
        events: [
            {
                stage: "WOODSIES",
                day: "SATURDAY",
                time: "14:00 - 14:45",
            },
        ],
        imgUrl: "",
        url: "https://workingmensclub.net/",
    },
    {
        name: "WORLDROOTS ACAPPELLA",
        events: [
            {
                stage: "WALKABOUTS",
                day: "WEDNESDAY",
                time: "11:30 - 13:30",
            },
            {
                stage: "WALKABOUTS",
                day: "THURSDAY",
                time: "11:30 - 13:30",
            },
            {
                stage: "WALKABOUTS",
                day: "FRIDAY",
                time: "14:30 - 16:30",
            },
            {
                stage: "WALKABOUTS",
                day: "SATURDAY",
                time: "14:30 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://www.gatheringvoices.org.uk/",
    },
    {
        name: "WOW CREATE WITH MRS RECYCLE",
        events: [
            {
                stage: "MAKE AND DO MARQUEE",
                day: "THURSDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "FRIDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SATURDAY",
                time: "TBA",
            },
            {
                stage: "MAKE AND DO MARQUEE",
                day: "SUNDAY",
                time: "TBA",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WUNDER TANDEM",
        events: [
            {
                stage: "THE BANDSTAND",
                day: "THURSDAY",
                time: "20:20 - 21:00",
            },
        ],
        imgUrl: "",
        url: "https://en-gb.facebook.com/wundertandem/",
    },
    {
        name: "WUNDERHORSE",
        events: [
            {
                stage: "BBC MUSIC INTRODUCING",
                day: "SATURDAY",
                time: "18:20 - 18:50",
            },
            {
                stage: "WOODSIES",
                day: "SATURDAY",
                time: "12:45 - 13:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/wunderhorse_/",
    },
    {
        name: "WYCHBURY BAND",
        events: [
            {
                stage: "TOAD HALL",
                day: "WEDNESDAY",
                time: "17:20 - 18:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "WYLDEST",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
            {
                stage: "THE HIVE",
                day: "THURSDAY",
                time: "15:15 - 16:00",
            },
        ],
        imgUrl: "",
        url: "https://www.wyldest.co.uk/",
    },
    {
        name: "XAVIER RUDD",
        events: [
            {
                stage: "AVALON STAGE",
                day: "FRIDAY",
                time: "20:05 - 21:05",
            },
        ],
        imgUrl: "",
        url: "https://xavierrudd.com/",
    },
    {
        name: "XICOME THE CALL OF QUETZALCOATL",
        events: [
            {
                stage: "GLADE",
                day: "SUNDAY",
                time: "12:00 - 12:50",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/alyoshabarreiro/",
    },
    {
        name: "XICOME THE CALL OF THE QUETZALCOATL RITUAL",
        events: [
            {
                stage: "FIRESIDE STORIES",
                day: "WEDNESDAY",
                time: "19:30 - 20:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "XULLAB",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "17:45 - 18:45",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/xullab",
    },
    {
        name: "YAYA BEY",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "FRIDAY",
                time: "13:00 - 14:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/yayabeybay/?hl=en",
    },
    {
        name: "YAYA BONES",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SUNDAY",
                time: "00:15 - 01:00",
            },
            {
                stage: "GREENPEACE",
                day: "SATURDAY",
                time: "13:45 - 14:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/yaya.bones/",
    },
    {
        name: "YAZMIN LACEY",
        events: [
            {
                stage: "THE LONELY HEARTS CLUB",
                day: "SUNDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "YES MEL",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SUNDAY",
                time: "03:00 - 04:30",
            },
        ],
        imgUrl: "",
        url: "https://www.yesmel.com/",
    },
    {
        name: "YES MEL (LIVE)",
        events: [
            {
                stage: "THE SISTXRHOOD",
                day: "SUNDAY",
                time: "22:00 - 22:45",
            },
        ],
        imgUrl: "",
        url: "https://www.yesmel.com/",
    },
    {
        name: "YIN YOGA + GONG BATH WITH SASHA AND MARTINA",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "THURSDAY",
                time: "17:30 - 18:30",
            },
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "SATURDAY",
                time: "16:00 - 17:00",
            },
        ],
        imgUrl: "",
        url: "https://sashayoga.uk/,",
    },
    {
        name: "YIN YOGA + GONG BATHS WITH SASHA AND MARTINA",
        events: [
            {
                stage: "HUMBLEWELL RETREAT YURT",
                day: "FRIDAY",
                time: "17:00 - 18:00",
            },
        ],
        imgUrl: "",
        url: "https://sashayoga.uk/",
    },
    {
        name: "YOGA - RISE + SHINE",
        events: [
            {
                stage: "HUMBLEWELL ACTIVE PLATFORM",
                day: "SUNDAY",
                time: "08:30 - 09:30",
            },
        ],
        imgUrl: "",
        url: "http://ig%20@lanagsmith/",
    },
    {
        name: "YONTI",
        events: [
            {
                stage: "GENOSYS SOUND SYSTEM",
                day: "SUNDAY",
                time: "18:00 - 19:30",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/yonti",
    },
    {
        name: "YOUNG FATHERS",
        events: [
            {
                stage: "WEST HOLTS STAGE",
                day: "FRIDAY",
                time: "20:30 - 21:30",
            },
        ],
        imgUrl: "",
        url: "https://www.young-fathers.com/",
    },
    {
        name: "YOUNG MARCO",
        events: [
            {
                stage: "THE WOW",
                day: "SUNDAY",
                time: "23:30 - 01:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "YOUNG PADAWAN",
        events: [
            {
                stage: "GLADE DOME",
                day: "SUNDAY",
                time: "23:35 - 00:45",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/medlar_/",
    },
    {
        name: "YOUNG WATERS",
        events: [
            {
                stage: "SMALL WORLD STAGE",
                day: "THURSDAY",
                time: "13:20 - 14:20",
            },
            {
                stage: "THE BANDSTAND",
                day: "WEDNESDAY",
                time: "19:15 - 20:10",
            },
        ],
        imgUrl: "",
        url: "https://linktr.ee/youngwatersband",
    },
    {
        name: "YOUSEF",
        events: [
            {
                stage: "GLADE DOME",
                day: "THURSDAY",
                time: "00:25 - 01:40",
            },
        ],
        imgUrl: "",
        url: "https://yousef.co.uk/",
    },
    {
        name: "YOUTH",
        events: [
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "00:30 - 01:30",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/youthmartin",
    },
    {
        name: "YOUTH B2B GAUDI",
        events: [
            {
                stage: "GLADE",
                day: "SATURDAY",
                time: "14:00 - 15:10",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/gaudi.it",
    },
    {
        name: "YUNG SINGH",
        events: [
            {
                stage: "IICON",
                day: "FRIDAY",
                time: "02:50 - 04:20",
            },
        ],
        imgUrl: "",
        url: "https://ra.co/dj/yungsingh",
    },
    {
        name: "YUSUF / CAT STEVENS",
        events: [
            {
                stage: "PYRAMID STAGE",
                day: "SUNDAY",
                time: "15:15 - 16:30",
            },
        ],
        imgUrl: "",
        url: "https://catstevens.com/",
    },
    {
        name: "ZED BIAS",
        events: [
            {
                stage: "GREENPEACE",
                day: "THURSDAY",
                time: "17:30 - 18:30",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/zed_bias",
    },
    {
        name: "ZEN LEWIS & DJ JERRY SOBER (BLENDID TAKEOVER)",
        events: [
            {
                stage: "CORNISH ARMS",
                day: "THURSDAY",
                time: "22:00 - 23:00",
            },
        ],
        imgUrl: "",
        url: "https://www.facebook.com/zenlewismusic",
    },
    {
        name: "ZEN LEWIS (& DJ JERRY SOBER)",
        events: [
            {
                stage: "MANDALA STAGE",
                day: "THURSDAY",
                time: "01:00 - 02:00",
            },
            {
                stage: "THE WEST HOLTS BAR",
                day: "SUNDAY",
                time: "19:30 - 20:00",
            },
        ],
        imgUrl: "",
        url: "https://www.instagram.com/zenlewisofficial/?hl=en",
    },
    {
        name: "ZENKER BROTHERS",
        events: [
            {
                stage: "IICON",
                day: "SUNDAY",
                time: "22:45 - 00:15",
            },
        ],
        imgUrl: "",
        url: "https://iliantape.de/zenker-brothers/%20https://ra.co/dj/zenkerbrothers",
    },
    {
        name: "ZERO",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "00:00 - 01:00",
            },
        ],
        imgUrl: "",
        url: "https://soundcloud.com/zero_uk",
    },
    {
        name: "ZIMMA",
        events: [
            {
                stage: "BLIND TIGER",
                day: "THURSDAY",
                time: "18:00 - 19:00",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ZINE TIME WITH ZOE MILES FROM OUT ON THE LAND AND SOLIDARITY AMOUNG LAND TRADES - DROP IN TO COLLAGE, DODDLE, WRITE, PAINT, ETCH AND SKETCH ON THE THEMES OF CONNECTION AND SOIL",
        events: [
            {
                stage: "THE RHIZOSPHERE",
                day: "THURSDAY",
                time: "13:15 - 15:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ZOE BROUGHTON",
        events: [
            {
                stage: "SPEAKERS FORUM",
                day: "SUNDAY",
                time: "11:00 - 12:00",
            },
        ],
        imgUrl: "",
        url: "http://phones%20filming%20for%20change/",
    },
    {
        name: "ZONZO",
        events: [
            {
                stage: "SWEET CHARITY",
                day: "FRIDAY",
                time: "04:00 - 06:00",
            },
            {
                stage: "SWEET CHARITY",
                day: "SUNDAY",
                time: "00:00 - 01:30",
            },
        ],
        imgUrl: "",
        url: "",
    },
    {
        name: "ZORBING WITH STREETGAMES UK",
        events: [
            {
                stage: "CIRCUS FIELD",
                day: "WEDNESDAY",
                time: "11:30 - 16:30",
            },
            {
                stage: "CIRCUS FIELD",
                day: "THURSDAY",
                time: "12:30 - 17:30",
            },
        ],
        imgUrl: "",
        url: "https://www.streetgames.org/",
    },
];

export default artists;
